/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Money: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AddFulfillmentToOrderResult = CreateFulfillmentError | EmptyOrderLineSelectionError | Fulfillment | FulfillmentStateTransitionError | InsufficientStockOnHandError | InvalidFulfillmentHandlerError | ItemsAlreadyFulfilledError;

export type AddItemInput = {
  customFields?: InputMaybe<OrderLineCustomFieldsInput>;
  productVariantId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type AddItemToDraftOrderInput = {
  customFields?: InputMaybe<OrderLineCustomFieldsInput>;
  productVariantId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type AddManualPaymentToOrderResult = ManualPaymentStateError | Order;

export type AddNoteToCustomerInput = {
  id: Scalars['ID']['input'];
  isPublic: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
};

export type AddNoteToOrderInput = {
  id: Scalars['ID']['input'];
  isPublic: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
};

export type Address = Node & {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country: Country;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<AddressCustomFields>;
  defaultBillingAddress?: Maybe<Scalars['Boolean']['output']>;
  defaultShippingAddress?: Maybe<Scalars['Boolean']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  streetLine1: Scalars['String']['output'];
  streetLine2?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AddressCustomFields = {
  __typename?: 'AddressCustomFields';
  addressTag?: Maybe<Scalars['String']['output']>;
};

export type AdjustDraftOrderLineInput = {
  customFields?: InputMaybe<OrderLineCustomFieldsInput>;
  orderLineId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type Adjustment = {
  __typename?: 'Adjustment';
  adjustmentSource: Scalars['String']['output'];
  amount: Scalars['Money']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  type: AdjustmentType;
};

export enum AdjustmentType {
  DISTRIBUTED_ORDER_PROMOTION = 'DISTRIBUTED_ORDER_PROMOTION',
  OTHER = 'OTHER',
  PROMOTION = 'PROMOTION'
}

export type Administrator = Node & {
  __typename?: 'Administrator';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<AdministratorCustomFields>;
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type AdministratorCustomFields = {
  __typename?: 'AdministratorCustomFields';
  adminLoyaltyPoints?: Maybe<Scalars['Int']['output']>;
  adminReferralCode?: Maybe<Scalars['String']['output']>;
  fcmToken?: Maybe<Scalars['String']['output']>;
};

export type AdministratorFilterParameter = {
  _and?: InputMaybe<Array<AdministratorFilterParameter>>;
  _or?: InputMaybe<Array<AdministratorFilterParameter>>;
  adminLoyaltyPoints?: InputMaybe<NumberOperators>;
  adminReferralCode?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  emailAddress?: InputMaybe<StringOperators>;
  fcmToken?: InputMaybe<StringOperators>;
  firstName?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  lastName?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type AdministratorList = PaginatedList & {
  __typename?: 'AdministratorList';
  items: Array<Administrator>;
  totalItems: Scalars['Int']['output'];
};

export type AdministratorListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<AdministratorFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<AdministratorSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type AdministratorPaymentInput = {
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type AdministratorRefundInput = {
  /**
   * The amount to be refunded to this particular Payment. This was introduced in
   * v2.2.0 as the preferred way to specify the refund amount. The `lines`, `shipping` and `adjustment`
   * fields will be removed in a future version.
   */
  amount?: InputMaybe<Scalars['Money']['input']>;
  paymentId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AdministratorSortParameter = {
  adminLoyaltyPoints?: InputMaybe<SortOrder>;
  adminReferralCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  emailAddress?: InputMaybe<SortOrder>;
  fcmToken?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type Allocation = Node & StockMovement & {
  __typename?: 'Allocation';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  orderLine: OrderLine;
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  type: StockMovementType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Returned if an attempting to refund an OrderItem which has already been refunded */
export type AlreadyRefundedError = ErrorResult & {
  __typename?: 'AlreadyRefundedError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  refundId: Scalars['ID']['output'];
};

export type AppDownload = {
  __typename?: 'AppDownload';
  appId: Scalars['String']['output'];
  appName: Scalars['String']['output'];
  downloads: Scalars['Int']['output'];
  platform: Scalars['String']['output'];
};

export type AppReview = {
  __typename?: 'AppReview';
  at?: Maybe<Scalars['DateTime']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  repliedAt?: Maybe<Scalars['DateTime']['output']>;
  replyContent?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  userImage?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type ApplyCouponCodeResult = CouponCodeExpiredError | CouponCodeInvalidError | CouponCodeLimitError | Order;

export type Asset = Node & {
  __typename?: 'Asset';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  fileSize: Scalars['Int']['output'];
  focalPoint?: Maybe<Coordinate>;
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  preview: Scalars['String']['output'];
  source: Scalars['String']['output'];
  tags: Array<Tag>;
  type: AssetType;
  updatedAt: Scalars['DateTime']['output'];
  width: Scalars['Int']['output'];
};

export type AssetFilterParameter = {
  _and?: InputMaybe<Array<AssetFilterParameter>>;
  _or?: InputMaybe<Array<AssetFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  fileSize?: InputMaybe<NumberOperators>;
  height?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  mimeType?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  preview?: InputMaybe<StringOperators>;
  source?: InputMaybe<StringOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  width?: InputMaybe<NumberOperators>;
};

export type AssetList = PaginatedList & {
  __typename?: 'AssetList';
  items: Array<Asset>;
  totalItems: Scalars['Int']['output'];
};

export type AssetListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<AssetFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<AssetSortParameter>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsOperator?: InputMaybe<LogicalOperator>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type AssetSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  fileSize?: InputMaybe<SortOrder>;
  height?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mimeType?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  preview?: InputMaybe<SortOrder>;
  source?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
};

export enum AssetType {
  BINARY = 'BINARY',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

export type AssignAssetsToChannelInput = {
  assetIds: Array<Scalars['ID']['input']>;
  channelId: Scalars['ID']['input'];
};

export type AssignCollectionsToChannelInput = {
  channelId: Scalars['ID']['input'];
  collectionIds: Array<Scalars['ID']['input']>;
};

export type AssignFacetsToChannelInput = {
  channelId: Scalars['ID']['input'];
  facetIds: Array<Scalars['ID']['input']>;
};

export type AssignPaymentMethodsToChannelInput = {
  channelId: Scalars['ID']['input'];
  paymentMethodIds: Array<Scalars['ID']['input']>;
};

export type AssignProductVariantsToChannelInput = {
  channelId: Scalars['ID']['input'];
  priceFactor?: InputMaybe<Scalars['Float']['input']>;
  productVariantIds: Array<Scalars['ID']['input']>;
};

export type AssignProductsToChannelInput = {
  channelId: Scalars['ID']['input'];
  priceFactor?: InputMaybe<Scalars['Float']['input']>;
  productIds: Array<Scalars['ID']['input']>;
};

export type AssignPromotionsToChannelInput = {
  channelId: Scalars['ID']['input'];
  promotionIds: Array<Scalars['ID']['input']>;
};

export type AssignShippingMethodsToChannelInput = {
  channelId: Scalars['ID']['input'];
  shippingMethodIds: Array<Scalars['ID']['input']>;
};

export type AssignStockLocationsToChannelInput = {
  channelId: Scalars['ID']['input'];
  stockLocationIds: Array<Scalars['ID']['input']>;
};

export type AuthenticationInput = {
  native?: InputMaybe<NativeAuthInput>;
};

export type AuthenticationMethod = Node & {
  __typename?: 'AuthenticationMethod';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  strategy: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AuthenticationResult = CurrentUser | InvalidCredentialsError;

export type BooleanCustomFieldConfig = CustomField & {
  __typename?: 'BooleanCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

/** Operators for filtering on a list of Boolean fields */
export type BooleanListOperators = {
  inList: Scalars['Boolean']['input'];
};

/** Operators for filtering on a Boolean field */
export type BooleanOperators = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BooleanStructFieldConfig = StructField & {
  __typename?: 'BooleanStructFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type Campaign = Node & {
  __typename?: 'Campaign';
  config?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  steps?: Maybe<Array<Maybe<CampaignStep>>>;
  triggerType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CampaignConfigInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  steps: Array<CampaignStepInput>;
  triggerType: Scalars['String']['input'];
};

export type CampaignFilterParameter = {
  _and?: InputMaybe<Array<CampaignFilterParameter>>;
  _or?: InputMaybe<Array<CampaignFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  isActive?: InputMaybe<BooleanOperators>;
  name?: InputMaybe<StringOperators>;
  triggerType?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type CampaignList = PaginatedList & {
  __typename?: 'CampaignList';
  items: Array<Campaign>;
  totalItems: Scalars['Int']['output'];
};

export type CampaignListOptions = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CampaignLog = Node & {
  __typename?: 'CampaignLog';
  campaignId: Scalars['ID']['output'];
  customerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  sentAt: Scalars['DateTime']['output'];
  stepIndex: Scalars['Int']['output'];
};

export type CampaignSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  triggerType?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CampaignStep = Node & {
  __typename?: 'CampaignStep';
  action: Scalars['String']['output'];
  delayHours: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  once: Scalars['Boolean']['output'];
  payload?: Maybe<Scalars['JSON']['output']>;
};

export type CampaignStepInput = {
  action: Scalars['String']['input'];
  delayHours: Scalars['Int']['input'];
  once?: InputMaybe<Scalars['Boolean']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
};

/** Returned if an attempting to cancel lines from an Order which is still active */
export type CancelActiveOrderError = ErrorResult & {
  __typename?: 'CancelActiveOrderError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  orderState: Scalars['String']['output'];
};

export type CancelOrderInput = {
  /** Specify whether the shipping charges should also be cancelled. Defaults to false */
  cancelShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally specify which OrderLines to cancel. If not provided, all OrderLines will be cancelled */
  lines?: InputMaybe<Array<OrderLineInput>>;
  /** The id of the order to be cancelled */
  orderId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CancelOrderResult = CancelActiveOrderError | EmptyOrderLineSelectionError | MultipleOrderError | Order | OrderStateTransitionError | QuantityTooGreatError;

/** Returned if the Payment cancellation fails */
export type CancelPaymentError = ErrorResult & {
  __typename?: 'CancelPaymentError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  paymentErrorMessage: Scalars['String']['output'];
};

export type CancelPaymentResult = CancelPaymentError | Payment | PaymentStateTransitionError;

export type Cancellation = Node & StockMovement & {
  __typename?: 'Cancellation';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  orderLine: OrderLine;
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  type: StockMovementType;
  updatedAt: Scalars['DateTime']['output'];
};

export type CarDetails = {
  __typename?: 'CarDetails';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  licensePlate: Scalars['String']['output'];
  model: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CarResult = CarDetails | CurbsidePickupError;

export type Career = Node & {
  __typename?: 'Career';
  addressLine1: Scalars['String']['output'];
  addressLine2: Scalars['String']['output'];
  availableHours: Scalars['String']['output'];
  city: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  desiredSalary: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fridayAm: Scalars['Boolean']['output'];
  fridayPm: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  mondayAm: Scalars['Boolean']['output'];
  mondayPm: Scalars['Boolean']['output'];
  phone: Scalars['String']['output'];
  positionAppliedFor: Scalars['String']['output'];
  previousEmployer: Scalars['String']['output'];
  previousEmployerPhone: Scalars['String']['output'];
  previousEmploymentEnd: Scalars['DateTime']['output'];
  previousEmploymentStart: Scalars['DateTime']['output'];
  restaurantId: Scalars['ID']['output'];
  saturdayAm: Scalars['Boolean']['output'];
  saturdayPm: Scalars['Boolean']['output'];
  state: Scalars['String']['output'];
  sundayAm: Scalars['Boolean']['output'];
  sundayPm: Scalars['Boolean']['output'];
  thursdayAm: Scalars['Boolean']['output'];
  thursdayPm: Scalars['Boolean']['output'];
  tuesdayAm: Scalars['Boolean']['output'];
  tuesdayPm: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wednesdayAm: Scalars['Boolean']['output'];
  wednesdayPm: Scalars['Boolean']['output'];
  zip: Scalars['String']['output'];
};

export type CareerFilterParameter = {
  _and?: InputMaybe<Array<CareerFilterParameter>>;
  _or?: InputMaybe<Array<CareerFilterParameter>>;
  addressLine1?: InputMaybe<StringOperators>;
  addressLine2?: InputMaybe<StringOperators>;
  availableHours?: InputMaybe<StringOperators>;
  city?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  desiredSalary?: InputMaybe<NumberOperators>;
  email?: InputMaybe<StringOperators>;
  firstName?: InputMaybe<StringOperators>;
  fridayAm?: InputMaybe<BooleanOperators>;
  fridayPm?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  lastName?: InputMaybe<StringOperators>;
  mondayAm?: InputMaybe<BooleanOperators>;
  mondayPm?: InputMaybe<BooleanOperators>;
  phone?: InputMaybe<StringOperators>;
  positionAppliedFor?: InputMaybe<StringOperators>;
  previousEmployer?: InputMaybe<StringOperators>;
  previousEmployerPhone?: InputMaybe<StringOperators>;
  previousEmploymentEnd?: InputMaybe<DateOperators>;
  previousEmploymentStart?: InputMaybe<DateOperators>;
  restaurantId?: InputMaybe<IdOperators>;
  saturdayAm?: InputMaybe<BooleanOperators>;
  saturdayPm?: InputMaybe<BooleanOperators>;
  state?: InputMaybe<StringOperators>;
  sundayAm?: InputMaybe<BooleanOperators>;
  sundayPm?: InputMaybe<BooleanOperators>;
  thursdayAm?: InputMaybe<BooleanOperators>;
  thursdayPm?: InputMaybe<BooleanOperators>;
  tuesdayAm?: InputMaybe<BooleanOperators>;
  tuesdayPm?: InputMaybe<BooleanOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  wednesdayAm?: InputMaybe<BooleanOperators>;
  wednesdayPm?: InputMaybe<BooleanOperators>;
  zip?: InputMaybe<StringOperators>;
};

export type CareerList = PaginatedList & {
  __typename?: 'CareerList';
  items: Array<Career>;
  totalItems: Scalars['Int']['output'];
};

export type CareerListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<CareerFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<CareerSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CareerSortParameter = {
  addressLine1?: InputMaybe<SortOrder>;
  addressLine2?: InputMaybe<SortOrder>;
  availableHours?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  desiredSalary?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  positionAppliedFor?: InputMaybe<SortOrder>;
  previousEmployer?: InputMaybe<SortOrder>;
  previousEmployerPhone?: InputMaybe<SortOrder>;
  previousEmploymentEnd?: InputMaybe<SortOrder>;
  previousEmploymentStart?: InputMaybe<SortOrder>;
  restaurantId?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  zip?: InputMaybe<SortOrder>;
};

export enum CategoryEnum {
  MARKETING = 'MARKETING',
  PROMOTIONS = 'PROMOTIONS'
}

export type Channel = Node & {
  __typename?: 'Channel';
  availableCurrencyCodes: Array<CurrencyCode>;
  availableLanguageCodes?: Maybe<Array<LanguageCode>>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated Use defaultCurrencyCode instead */
  currencyCode: CurrencyCode;
  customFields?: Maybe<ChannelCustomFields>;
  defaultCurrencyCode: CurrencyCode;
  defaultLanguageCode: LanguageCode;
  defaultShippingZone?: Maybe<Zone>;
  defaultTaxZone?: Maybe<Zone>;
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  /** Not yet used - will be implemented in a future release. */
  outOfStockThreshold?: Maybe<Scalars['Int']['output']>;
  pricesIncludeTax: Scalars['Boolean']['output'];
  seller?: Maybe<Seller>;
  token: Scalars['String']['output'];
  /** Not yet used - will be implemented in a future release. */
  trackInventory?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ChannelCustomFields = {
  __typename?: 'ChannelCustomFields';
  address?: Maybe<Scalars['String']['output']>;
  allowFeedbackAdminEmail?: Maybe<Scalars['Boolean']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  backUpDoorDashURL?: Maybe<Scalars['String']['output']>;
  backUpPaytronixURL?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cloverAccessToken?: Maybe<Scalars['String']['output']>;
  cloverLocationId?: Maybe<Scalars['String']['output']>;
  cloverTenderName?: Maybe<Scalars['String']['output']>;
  curbSideOperationTimes?: Maybe<Array<Scalars['String']['output']>>;
  deviceNumber?: Maybe<Scalars['String']['output']>;
  disableOrderMinutesBeforeClosing?: Maybe<Scalars['Int']['output']>;
  doordashExternalId?: Maybe<Scalars['String']['output']>;
  doordashOnboarded?: Maybe<Scalars['Boolean']['output']>;
  driveInOperationTimes?: Maybe<Array<Scalars['String']['output']>>;
  email?: Maybe<Scalars['String']['output']>;
  enableAlACarte?: Maybe<Scalars['Boolean']['output']>;
  enableCateringOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableCurbsidePickUp?: Maybe<Scalars['Boolean']['output']>;
  enableDripCampaigns?: Maybe<Scalars['Boolean']['output']>;
  enableHolidayOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableHolidayTimeSlot?: Maybe<Scalars['Boolean']['output']>;
  enableMakeAMeal?: Maybe<Scalars['Boolean']['output']>;
  isAlwaysOpen?: Maybe<Scalars['Boolean']['output']>;
  isClosed?: Maybe<Scalars['Boolean']['output']>;
  isInactive?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  popUpTerminalNumber?: Maybe<Scalars['String']['output']>;
  positouchAdminEmail?: Maybe<Scalars['String']['output']>;
  positouchStatus?: Maybe<Scalars['Boolean']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  sendHolidayOrderEmailAfterPlacement?: Maybe<Scalars['Int']['output']>;
  sendHolidayOrderEmailDurationBeforePickup?: Maybe<Scalars['Int']['output']>;
  sendToCloverPOS?: Maybe<Scalars['Boolean']['output']>;
  sendToXMLPOS?: Maybe<Scalars['Boolean']['output']>;
  shift4AccessToken?: Maybe<Scalars['String']['output']>;
  shift4AuthToken?: Maybe<Scalars['String']['output']>;
  storeBasedTax?: Maybe<Array<ChannelStoreBasedTaxStruct>>;
  storeIp?: Maybe<Scalars['String']['output']>;
  storeNumber?: Maybe<Scalars['String']['output']>;
  streetLine1?: Maybe<Scalars['String']['output']>;
  streetLine2?: Maybe<Scalars['String']['output']>;
  welcomeMessageBody?: Maybe<Scalars['String']['output']>;
  welcomeMessageEnabled?: Maybe<Scalars['Boolean']['output']>;
  welcomeMessageFrom?: Maybe<Scalars['String']['output']>;
  welcomeMessageIcon?: Maybe<Asset>;
  welcomeMessageTitle?: Maybe<Scalars['String']['output']>;
};

/**
 * Returned when the default LanguageCode of a Channel is no longer found in the `availableLanguages`
 * of the GlobalSettings
 */
export type ChannelDefaultLanguageError = ErrorResult & {
  __typename?: 'ChannelDefaultLanguageError';
  channelCode: Scalars['String']['output'];
  errorCode: ErrorCode;
  language: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ChannelFilterParameter = {
  _and?: InputMaybe<Array<ChannelFilterParameter>>;
  _or?: InputMaybe<Array<ChannelFilterParameter>>;
  address?: InputMaybe<StringOperators>;
  allowFeedbackAdminEmail?: InputMaybe<BooleanOperators>;
  apiKey?: InputMaybe<StringOperators>;
  backUpDoorDashURL?: InputMaybe<StringOperators>;
  backUpPaytronixURL?: InputMaybe<StringOperators>;
  city?: InputMaybe<StringOperators>;
  cloverAccessToken?: InputMaybe<StringOperators>;
  cloverLocationId?: InputMaybe<StringOperators>;
  cloverTenderName?: InputMaybe<StringOperators>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  curbSideOperationTimes?: InputMaybe<StringListOperators>;
  currencyCode?: InputMaybe<StringOperators>;
  defaultCurrencyCode?: InputMaybe<StringOperators>;
  defaultLanguageCode?: InputMaybe<StringOperators>;
  deviceNumber?: InputMaybe<StringOperators>;
  disableOrderMinutesBeforeClosing?: InputMaybe<NumberOperators>;
  doordashExternalId?: InputMaybe<StringOperators>;
  doordashOnboarded?: InputMaybe<BooleanOperators>;
  driveInOperationTimes?: InputMaybe<StringListOperators>;
  email?: InputMaybe<StringOperators>;
  enableAlACarte?: InputMaybe<BooleanOperators>;
  enableCateringOrdering?: InputMaybe<BooleanOperators>;
  enableCurbsidePickUp?: InputMaybe<BooleanOperators>;
  enableDripCampaigns?: InputMaybe<BooleanOperators>;
  enableHolidayOrdering?: InputMaybe<BooleanOperators>;
  enableHolidayTimeSlot?: InputMaybe<BooleanOperators>;
  enableMakeAMeal?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  isAlwaysOpen?: InputMaybe<BooleanOperators>;
  isClosed?: InputMaybe<BooleanOperators>;
  isInactive?: InputMaybe<BooleanOperators>;
  outOfStockThreshold?: InputMaybe<NumberOperators>;
  phoneNumber?: InputMaybe<StringOperators>;
  popUpTerminalNumber?: InputMaybe<StringOperators>;
  positouchAdminEmail?: InputMaybe<StringOperators>;
  positouchStatus?: InputMaybe<BooleanOperators>;
  postalCode?: InputMaybe<StringOperators>;
  pricesIncludeTax?: InputMaybe<BooleanOperators>;
  province?: InputMaybe<StringOperators>;
  sendHolidayOrderEmailAfterPlacement?: InputMaybe<NumberOperators>;
  sendHolidayOrderEmailDurationBeforePickup?: InputMaybe<NumberOperators>;
  sendToCloverPOS?: InputMaybe<BooleanOperators>;
  sendToXMLPOS?: InputMaybe<BooleanOperators>;
  shift4AccessToken?: InputMaybe<StringOperators>;
  shift4AuthToken?: InputMaybe<StringOperators>;
  storeIp?: InputMaybe<StringOperators>;
  storeNumber?: InputMaybe<StringOperators>;
  streetLine1?: InputMaybe<StringOperators>;
  streetLine2?: InputMaybe<StringOperators>;
  token?: InputMaybe<StringOperators>;
  trackInventory?: InputMaybe<BooleanOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  welcomeMessageBody?: InputMaybe<StringOperators>;
  welcomeMessageEnabled?: InputMaybe<BooleanOperators>;
  welcomeMessageFrom?: InputMaybe<StringOperators>;
  welcomeMessageTitle?: InputMaybe<StringOperators>;
};

export type ChannelList = PaginatedList & {
  __typename?: 'ChannelList';
  items: Array<Channel>;
  totalItems: Scalars['Int']['output'];
};

export type ChannelListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ChannelFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ChannelSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ChannelSortParameter = {
  address?: InputMaybe<SortOrder>;
  allowFeedbackAdminEmail?: InputMaybe<SortOrder>;
  apiKey?: InputMaybe<SortOrder>;
  backUpDoorDashURL?: InputMaybe<SortOrder>;
  backUpPaytronixURL?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  cloverAccessToken?: InputMaybe<SortOrder>;
  cloverLocationId?: InputMaybe<SortOrder>;
  cloverTenderName?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deviceNumber?: InputMaybe<SortOrder>;
  disableOrderMinutesBeforeClosing?: InputMaybe<SortOrder>;
  doordashExternalId?: InputMaybe<SortOrder>;
  doordashOnboarded?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  enableAlACarte?: InputMaybe<SortOrder>;
  enableCateringOrdering?: InputMaybe<SortOrder>;
  enableCurbsidePickUp?: InputMaybe<SortOrder>;
  enableDripCampaigns?: InputMaybe<SortOrder>;
  enableHolidayOrdering?: InputMaybe<SortOrder>;
  enableHolidayTimeSlot?: InputMaybe<SortOrder>;
  enableMakeAMeal?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAlwaysOpen?: InputMaybe<SortOrder>;
  isClosed?: InputMaybe<SortOrder>;
  isInactive?: InputMaybe<SortOrder>;
  outOfStockThreshold?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  popUpTerminalNumber?: InputMaybe<SortOrder>;
  positouchAdminEmail?: InputMaybe<SortOrder>;
  positouchStatus?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  province?: InputMaybe<SortOrder>;
  sendHolidayOrderEmailAfterPlacement?: InputMaybe<SortOrder>;
  sendHolidayOrderEmailDurationBeforePickup?: InputMaybe<SortOrder>;
  sendToCloverPOS?: InputMaybe<SortOrder>;
  sendToXMLPOS?: InputMaybe<SortOrder>;
  shift4AccessToken?: InputMaybe<SortOrder>;
  shift4AuthToken?: InputMaybe<SortOrder>;
  storeIp?: InputMaybe<SortOrder>;
  storeNumber?: InputMaybe<SortOrder>;
  streetLine1?: InputMaybe<SortOrder>;
  streetLine2?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  welcomeMessageBody?: InputMaybe<SortOrder>;
  welcomeMessageEnabled?: InputMaybe<SortOrder>;
  welcomeMessageFrom?: InputMaybe<SortOrder>;
  welcomeMessageIcon?: InputMaybe<SortOrder>;
  welcomeMessageTitle?: InputMaybe<SortOrder>;
};

export type ChannelStoreBasedTaxStruct = {
  __typename?: 'ChannelStoreBasedTaxStruct';
  Name?: Maybe<Scalars['String']['output']>;
  Rate?: Maybe<Scalars['Float']['output']>;
};

export type ChannelStoreBasedTaxStructInput = {
  Name?: InputMaybe<Scalars['String']['input']>;
  Rate?: InputMaybe<Scalars['Float']['input']>;
};

export type Collection = Node & {
  __typename?: 'Collection';
  assets: Array<Asset>;
  breadcrumbs: Array<CollectionBreadcrumb>;
  children?: Maybe<Array<Collection>>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<CollectionCustomFields>;
  description: Scalars['String']['output'];
  featuredAsset?: Maybe<Asset>;
  filters: Array<ConfigurableOperation>;
  id: Scalars['ID']['output'];
  inheritFilters: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  languageCode?: Maybe<LanguageCode>;
  name: Scalars['String']['output'];
  parent?: Maybe<Collection>;
  parentId: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  productVariants: ProductVariantList;
  slug: Scalars['String']['output'];
  translations: Array<CollectionTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CollectionProductVariantsArgs = {
  options?: InputMaybe<ProductVariantListOptions>;
};

export type CollectionBreadcrumb = {
  __typename?: 'CollectionBreadcrumb';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type CollectionCustomFields = {
  __typename?: 'CollectionCustomFields';
  availableDates?: Maybe<Array<Scalars['String']['output']>>;
  availableDays?: Maybe<Array<Scalars['String']['output']>>;
  cateringAvailableDates?: Maybe<Array<Scalars['String']['output']>>;
  cateringAvailableDays?: Maybe<Array<Scalars['String']['output']>>;
  cateringCutOffDates?: Maybe<Array<Scalars['String']['output']>>;
  cateringCutOffDays?: Maybe<Array<Scalars['String']['output']>>;
  cateringShowIfNotAvailable?: Maybe<Scalars['Boolean']['output']>;
  cutOffDates?: Maybe<Array<Scalars['String']['output']>>;
  cutOffDays?: Maybe<Array<Scalars['String']['output']>>;
  holidayAvailableDates?: Maybe<Array<Scalars['String']['output']>>;
  holidayAvailableDays?: Maybe<Array<Scalars['String']['output']>>;
  holidayCutOffDates?: Maybe<Array<Scalars['String']['output']>>;
  holidayCutOffDays?: Maybe<Array<Scalars['String']['output']>>;
  holidayShowIfNotAvailable?: Maybe<Scalars['Boolean']['output']>;
  isAlACarteBreadRequired?: Maybe<Scalars['Boolean']['output']>;
  isAlACarteSauceRequired?: Maybe<Scalars['Boolean']['output']>;
  isAlACarteSideRequired?: Maybe<Scalars['Boolean']['output']>;
  isCateringCollection?: Maybe<Scalars['Boolean']['output']>;
  isHolidayCollection?: Maybe<Scalars['Boolean']['output']>;
  isMakeAMeakSauceRequired?: Maybe<Scalars['Boolean']['output']>;
  isMakeAMealBreadRequired?: Maybe<Scalars['Boolean']['output']>;
  isMakeAMealSideRequired?: Maybe<Scalars['Boolean']['output']>;
  showIfNotAvailable?: Maybe<Scalars['Boolean']['output']>;
  showInDeals?: Maybe<Scalars['Boolean']['output']>;
};

export type CollectionFilterParameter = {
  _and?: InputMaybe<Array<CollectionFilterParameter>>;
  _or?: InputMaybe<Array<CollectionFilterParameter>>;
  availableDates?: InputMaybe<StringListOperators>;
  availableDays?: InputMaybe<StringListOperators>;
  cateringAvailableDates?: InputMaybe<StringListOperators>;
  cateringAvailableDays?: InputMaybe<StringListOperators>;
  cateringCutOffDates?: InputMaybe<StringListOperators>;
  cateringCutOffDays?: InputMaybe<StringListOperators>;
  cateringShowIfNotAvailable?: InputMaybe<BooleanOperators>;
  createdAt?: InputMaybe<DateOperators>;
  cutOffDates?: InputMaybe<StringListOperators>;
  cutOffDays?: InputMaybe<StringListOperators>;
  description?: InputMaybe<StringOperators>;
  holidayAvailableDates?: InputMaybe<StringListOperators>;
  holidayAvailableDays?: InputMaybe<StringListOperators>;
  holidayCutOffDates?: InputMaybe<StringListOperators>;
  holidayCutOffDays?: InputMaybe<StringListOperators>;
  holidayShowIfNotAvailable?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  inheritFilters?: InputMaybe<BooleanOperators>;
  isAlACarteBreadRequired?: InputMaybe<BooleanOperators>;
  isAlACarteSauceRequired?: InputMaybe<BooleanOperators>;
  isAlACarteSideRequired?: InputMaybe<BooleanOperators>;
  isCateringCollection?: InputMaybe<BooleanOperators>;
  isHolidayCollection?: InputMaybe<BooleanOperators>;
  isMakeAMeakSauceRequired?: InputMaybe<BooleanOperators>;
  isMakeAMealBreadRequired?: InputMaybe<BooleanOperators>;
  isMakeAMealSideRequired?: InputMaybe<BooleanOperators>;
  isPrivate?: InputMaybe<BooleanOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  parentId?: InputMaybe<IdOperators>;
  position?: InputMaybe<NumberOperators>;
  showIfNotAvailable?: InputMaybe<BooleanOperators>;
  showInDeals?: InputMaybe<BooleanOperators>;
  slug?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type CollectionList = PaginatedList & {
  __typename?: 'CollectionList';
  items: Array<Collection>;
  totalItems: Scalars['Int']['output'];
};

export type CollectionListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<CollectionFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<CollectionSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
  topLevelOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Which Collections are present in the products returned
 * by the search, and in what quantity.
 */
export type CollectionResult = {
  __typename?: 'CollectionResult';
  collection: Collection;
  count: Scalars['Int']['output'];
};

export type CollectionSortParameter = {
  cateringShowIfNotAvailable?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  holidayShowIfNotAvailable?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAlACarteBreadRequired?: InputMaybe<SortOrder>;
  isAlACarteSauceRequired?: InputMaybe<SortOrder>;
  isAlACarteSideRequired?: InputMaybe<SortOrder>;
  isCateringCollection?: InputMaybe<SortOrder>;
  isHolidayCollection?: InputMaybe<SortOrder>;
  isMakeAMeakSauceRequired?: InputMaybe<SortOrder>;
  isMakeAMealBreadRequired?: InputMaybe<SortOrder>;
  isMakeAMealSideRequired?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  showIfNotAvailable?: InputMaybe<SortOrder>;
  showInDeals?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CollectionTranslation = {
  __typename?: 'CollectionTranslation';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ConfigArg = {
  __typename?: 'ConfigArg';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ConfigArgDefinition = {
  __typename?: 'ConfigArgDefinition';
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type ConfigArgInput = {
  name: Scalars['String']['input'];
  /** A JSON stringified representation of the actual value */
  value: Scalars['String']['input'];
};

export type ConfigurableOperation = {
  __typename?: 'ConfigurableOperation';
  args: Array<ConfigArg>;
  code: Scalars['String']['output'];
};

export type ConfigurableOperationDefinition = {
  __typename?: 'ConfigurableOperationDefinition';
  args: Array<ConfigArgDefinition>;
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type ConfigurableOperationInput = {
  arguments: Array<ConfigArgInput>;
  code: Scalars['String']['input'];
};

export type Coordinate = {
  __typename?: 'Coordinate';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type CoordinateInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

/**
 * A Country of the world which your shop operates in.
 *
 * The `code` field is typically a 2-character ISO code such as "GB", "US", "DE" etc. This code is used in certain inputs such as
 * `UpdateAddressInput` and `CreateAddressInput` to specify the country.
 */
export type Country = Node & Region & {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  parent?: Maybe<Region>;
  parentId?: Maybe<Scalars['ID']['output']>;
  translations: Array<RegionTranslation>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CountryFilterParameter = {
  _and?: InputMaybe<Array<CountryFilterParameter>>;
  _or?: InputMaybe<Array<CountryFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  parentId?: InputMaybe<IdOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type CountryList = PaginatedList & {
  __typename?: 'CountryList';
  items: Array<Country>;
  totalItems: Scalars['Int']['output'];
};

export type CountryListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<CountryFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<CountrySortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CountrySortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CountryTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Returned if the provided coupon code is invalid */
export type CouponCodeExpiredError = ErrorResult & {
  __typename?: 'CouponCodeExpiredError';
  couponCode: Scalars['String']['output'];
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned if the provided coupon code is invalid */
export type CouponCodeInvalidError = ErrorResult & {
  __typename?: 'CouponCodeInvalidError';
  couponCode: Scalars['String']['output'];
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned if the provided coupon code is invalid */
export type CouponCodeLimitError = ErrorResult & {
  __typename?: 'CouponCodeLimitError';
  couponCode: Scalars['String']['output'];
  errorCode: ErrorCode;
  limit: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type CreateAddressCustomFieldsInput = {
  addressTag?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input used to create an Address.
 *
 * The countryCode must correspond to a `code` property of a Country that has been defined in the
 * Vendure server. The `code` property is typically a 2-character ISO code such as "GB", "US", "DE" etc.
 * If an invalid code is passed, the mutation will fail.
 */
export type CreateAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  customFields?: InputMaybe<CreateAddressCustomFieldsInput>;
  defaultBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  defaultShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  streetLine1: Scalars['String']['input'];
  streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdministratorCustomFieldsInput = {
  fcmToken?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAdministratorInput = {
  customFields?: InputMaybe<CreateAdministratorCustomFieldsInput>;
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  roleIds: Array<Scalars['ID']['input']>;
};

export type CreateAndSendMarketingEmail = {
  body: Scalars['String']['input'];
  category: CategoryEnum;
  id: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  type: TemplateEnum;
};

export type CreateAssetInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  file: Scalars['Upload']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateAssetResult = Asset | MimeTypeError;

export type CreateBulkTimeSlotsInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  maxOrdersPerSlot?: InputMaybe<Scalars['Int']['input']>;
  slotDurationInMinutes: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type CreateCarInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateChannelCustomFieldsInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  allowFeedbackAdminEmail?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  backUpDoorDashURL?: InputMaybe<Scalars['String']['input']>;
  backUpPaytronixURL?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cloverAccessToken?: InputMaybe<Scalars['String']['input']>;
  cloverLocationId?: InputMaybe<Scalars['String']['input']>;
  cloverTenderName?: InputMaybe<Scalars['String']['input']>;
  curbSideOperationTimes?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceNumber?: InputMaybe<Scalars['String']['input']>;
  disableOrderMinutesBeforeClosing?: InputMaybe<Scalars['Int']['input']>;
  doordashExternalId?: InputMaybe<Scalars['String']['input']>;
  doordashOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  driveInOperationTimes?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  enableAlACarte?: InputMaybe<Scalars['Boolean']['input']>;
  enableCateringOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableCurbsidePickUp?: InputMaybe<Scalars['Boolean']['input']>;
  enableDripCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  enableHolidayOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableHolidayTimeSlot?: InputMaybe<Scalars['Boolean']['input']>;
  enableMakeAMeal?: InputMaybe<Scalars['Boolean']['input']>;
  isAlwaysOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isInactive?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  popUpTerminalNumber?: InputMaybe<Scalars['String']['input']>;
  positouchAdminEmail?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  sendHolidayOrderEmailAfterPlacement?: InputMaybe<Scalars['Int']['input']>;
  sendHolidayOrderEmailDurationBeforePickup?: InputMaybe<Scalars['Int']['input']>;
  sendToCloverPOS?: InputMaybe<Scalars['Boolean']['input']>;
  sendToXMLPOS?: InputMaybe<Scalars['Boolean']['input']>;
  shift4AccessToken?: InputMaybe<Scalars['String']['input']>;
  shift4AuthToken?: InputMaybe<Scalars['String']['input']>;
  storeBasedTax?: InputMaybe<Array<ChannelStoreBasedTaxStructInput>>;
  storeIp?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
  streetLine1?: InputMaybe<Scalars['String']['input']>;
  streetLine2?: InputMaybe<Scalars['String']['input']>;
  welcomeMessageBody?: InputMaybe<Scalars['String']['input']>;
  welcomeMessageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeMessageFrom?: InputMaybe<Scalars['String']['input']>;
  welcomeMessageIconId?: InputMaybe<Scalars['ID']['input']>;
  welcomeMessageTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CreateChannelInput = {
  availableCurrencyCodes?: InputMaybe<Array<CurrencyCode>>;
  availableLanguageCodes?: InputMaybe<Array<LanguageCode>>;
  code: Scalars['String']['input'];
  customFields?: InputMaybe<CreateChannelCustomFieldsInput>;
  defaultCurrencyCode?: InputMaybe<CurrencyCode>;
  defaultLanguageCode: LanguageCode;
  defaultShippingZoneId: Scalars['ID']['input'];
  defaultTaxZoneId: Scalars['ID']['input'];
  outOfStockThreshold?: InputMaybe<Scalars['Int']['input']>;
  pricesIncludeTax: Scalars['Boolean']['input'];
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateChannelResult = Channel | LanguageNotAvailableError;

export type CreateCollectionCustomFieldsInput = {
  availableDates?: InputMaybe<Array<Scalars['String']['input']>>;
  availableDays?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringAvailableDates?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringAvailableDays?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringCutOffDates?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringCutOffDays?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringShowIfNotAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  cutOffDates?: InputMaybe<Array<Scalars['String']['input']>>;
  cutOffDays?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayAvailableDates?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayAvailableDays?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayCutOffDates?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayCutOffDays?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayShowIfNotAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isAlACarteBreadRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isAlACarteSauceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isAlACarteSideRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isCateringCollection?: InputMaybe<Scalars['Boolean']['input']>;
  isHolidayCollection?: InputMaybe<Scalars['Boolean']['input']>;
  isMakeAMeakSauceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isMakeAMealBreadRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isMakeAMealSideRequired?: InputMaybe<Scalars['Boolean']['input']>;
  showIfNotAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  showInDeals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCollectionInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customFields?: InputMaybe<CreateCollectionCustomFieldsInput>;
  featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
  filters: Array<ConfigurableOperationInput>;
  inheritFilters?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  translations: Array<CreateCollectionTranslationInput>;
};

export type CreateCollectionTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  languageCode: LanguageCode;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type CreateCountryInput = {
  code: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  enabled: Scalars['Boolean']['input'];
  translations: Array<CountryTranslationInput>;
};

export type CreateCustomerCustomFieldsInput = {
  claimSignUpRewardLater?: InputMaybe<Scalars['Boolean']['input']>;
  cloverCustomerIds?: InputMaybe<Scalars['String']['input']>;
  cumulativePoints?: InputMaybe<Scalars['Int']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  lastScratchDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastSpinDate?: InputMaybe<Scalars['DateTime']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  loyaltyCodes?: InputMaybe<Array<CustomerLoyaltyCodesStructInput>>;
  loyaltyPoints?: InputMaybe<Scalars['Int']['input']>;
  loyaltyTier?: InputMaybe<Scalars['String']['input']>;
  marketingUserID?: InputMaybe<Scalars['String']['input']>;
  signUpRewardClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  topMostFavoriteLocation?: InputMaybe<Scalars['String']['input']>;
  topMostFavoriteRestaurantId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCustomerGroupInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
};

export type CreateCustomerInput = {
  customFields?: InputMaybe<CreateCustomerCustomFieldsInput>;
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerResult = Customer | EmailAddressConflictError;

export type CreateDoorDashOrderInput = {
  currency: Scalars['String']['input'];
  deliveryRiderDasherId: Scalars['String']['input'];
  deliveryRiderName: Scalars['String']['input'];
  deliveryRiderNumber: Scalars['String']['input'];
  deliveryRiderVehicle: Scalars['String']['input'];
  dropoffAddress: Scalars['String']['input'];
  dropoffContactFamilyName: Scalars['String']['input'];
  dropoffContactGivenName: Scalars['String']['input'];
  dropoffPhoneNumber: Scalars['String']['input'];
  dropoffTimeActual?: InputMaybe<Scalars['String']['input']>;
  dropoffTimeEstimated?: InputMaybe<Scalars['String']['input']>;
  externalDeliveryId: Scalars['String']['input'];
  orderValue: Scalars['Int']['input'];
  pickupAddress: Scalars['String']['input'];
  pickupExternalStoreId: Scalars['String']['input'];
  pickupTimeActual?: InputMaybe<Scalars['String']['input']>;
  pickupTimeEstimated?: InputMaybe<Scalars['String']['input']>;
  trackingUrl: Scalars['String']['input'];
};

export type CreateDoordashBusinessInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateDripCampaignInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fromEmail: Scalars['String']['input'];
  fromName: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  steps?: InputMaybe<Array<DripStepInput>>;
};

export type CreateEmailTemplateInput = {
  body: Scalars['String']['input'];
  category: CategoryEnum;
  name: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  type: TemplateEnum;
};

export type CreateFacetInput = {
  code: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  isPrivate: Scalars['Boolean']['input'];
  translations: Array<FacetTranslationInput>;
  values?: InputMaybe<Array<CreateFacetValueWithFacetInput>>;
};

export type CreateFacetValueInput = {
  code: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  facetId: Scalars['ID']['input'];
  translations: Array<FacetValueTranslationInput>;
};

export type CreateFacetValueWithFacetInput = {
  code: Scalars['String']['input'];
  translations: Array<FacetValueTranslationInput>;
};

/** Returned if an error is thrown in a FulfillmentHandler's createFulfillment method */
export type CreateFulfillmentError = ErrorResult & {
  __typename?: 'CreateFulfillmentError';
  errorCode: ErrorCode;
  fulfillmentHandlerError: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type CreateGroupOptionInput = {
  code: Scalars['String']['input'];
  translations: Array<ProductOptionGroupTranslationInput>;
};

export type CreateIndividualMessageInput = {
  email: Scalars['Boolean']['input'];
  emailTemplateName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  phone: Scalars['Boolean']['input'];
  phoneTemplateName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMessageInput = {
  email: Scalars['Boolean']['input'];
  emailTemplateName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phone: Scalars['Boolean']['input'];
  phoneTemplateName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNotificationInput = {
  body: Scalars['String']['input'];
  title: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type CreatePageInput = {
  content: Scalars['String']['input'];
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTags?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type CreatePaymentMethodInput = {
  checker?: InputMaybe<ConfigurableOperationInput>;
  code: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  enabled: Scalars['Boolean']['input'];
  handler: ConfigurableOperationInput;
  translations: Array<PaymentMethodTranslationInput>;
};

export type CreateProductCustomFieldsInput = {
  cateringUnitMeasure?: InputMaybe<Scalars['String']['input']>;
  featuredReviewId?: InputMaybe<Scalars['ID']['input']>;
  isOrderCatering?: InputMaybe<Scalars['Boolean']['input']>;
  nutritionalInfoId?: InputMaybe<Scalars['ID']['input']>;
  reviewCount?: InputMaybe<Scalars['Float']['input']>;
  reviewRating?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateProductInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customFields?: InputMaybe<CreateProductCustomFieldsInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  facetValueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
  translations: Array<ProductTranslationInput>;
};

export type CreateProductOptionGroupInput = {
  code: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  options: Array<CreateGroupOptionInput>;
  translations: Array<ProductOptionGroupTranslationInput>;
};

export type CreateProductOptionInput = {
  code: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  productOptionGroupId: Scalars['ID']['input'];
  translations: Array<ProductOptionGroupTranslationInput>;
};

export type CreateProductVariantCustomFieldsInput = {
  beverageAddOnVariantsAvailableIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  beverageAlACarteAddOnVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  beverageAlACarteAddOnVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  beverageMakeAMealAddOnVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  beverageMakeAMealAddOnVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  breadAddOnVariantsAvailableIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  breadAlACarteAddOnVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  breadAlACarteAddOnVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  breadMakeAMealAddOnVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  breadMakeAMealAddOnVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  cateringFreeOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringMinimumThreshold?: InputMaybe<Scalars['Int']['input']>;
  cateringServingSize?: InputMaybe<Scalars['Int']['input']>;
  cloverCatalogObjectId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  desertAddOnVariantsAvailableIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  desertAlACarteAddOnVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  desertAlACarteAddOnVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  desertMakeAMealAddOnVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  desertMakeAMealAddOnVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  loyaltyGiftPoints?: InputMaybe<Array<ProductVariantLoyaltyGiftPointsStructInput>>;
  makeAMealSKU?: InputMaybe<Scalars['String']['input']>;
  noOfCateringSidesRequired?: InputMaybe<Scalars['Int']['input']>;
  preparationTime?: InputMaybe<Scalars['Float']['input']>;
  sauceAddOnVariantsAvailableIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sauceAlACarteAddOnVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  sauceAlACarteAddOnVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  sauceMakeAMealAddOnVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  sauceMakeAMealAddOnVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  showInDeals?: InputMaybe<Scalars['Boolean']['input']>;
  sideAlACarteVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  sideAlACarteVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  sideMakeAMealVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  sideMakeAMealVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  sideVariantsAvailableIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateProductVariantInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customFields?: InputMaybe<CreateProductVariantCustomFieldsInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  facetValueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  outOfStockThreshold?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Money']['input']>;
  prices?: InputMaybe<Array<InputMaybe<CreateProductVariantPriceInput>>>;
  productId: Scalars['ID']['input'];
  sku: Scalars['String']['input'];
  stockLevels?: InputMaybe<Array<StockLevelInput>>;
  stockOnHand?: InputMaybe<Scalars['Int']['input']>;
  taxCategoryId?: InputMaybe<Scalars['ID']['input']>;
  trackInventory?: InputMaybe<GlobalFlag>;
  translations: Array<ProductVariantTranslationInput>;
  useGlobalOutOfStockThreshold?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateProductVariantOptionInput = {
  code: Scalars['String']['input'];
  optionGroupId: Scalars['ID']['input'];
  translations: Array<ProductOptionTranslationInput>;
};

export type CreateProductVariantPriceCustomFieldsInput = {
  availableDates?: InputMaybe<Array<Scalars['String']['input']>>;
  availableDays?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringAvailableDates?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringAvailableDays?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringCutOffDates?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringCutOffDays?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringShowIfNotAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  cutOffDates?: InputMaybe<Array<Scalars['String']['input']>>;
  cutOffDays?: InputMaybe<Array<Scalars['String']['input']>>;
  enableAlACarte?: InputMaybe<Scalars['Boolean']['input']>;
  enableMakeAMeal?: InputMaybe<Scalars['Boolean']['input']>;
  enableVariant?: InputMaybe<Scalars['Boolean']['input']>;
  holidayAvailableDates?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayAvailableDays?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayCutOffDates?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayCutOffDays?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayShowIfNotAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  makeAMealCost?: InputMaybe<Scalars['Int']['input']>;
  showIfNotAvailable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateProductVariantPriceInput = {
  currencyCode: CurrencyCode;
  customFields?: InputMaybe<CreateProductVariantPriceCustomFieldsInput>;
  price: Scalars['Money']['input'];
};

export type CreatePromotionCustomFieldsInput = {
  adminAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  bannerId?: InputMaybe<Scalars['ID']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isDeal?: InputMaybe<Scalars['Boolean']['input']>;
  isFeedbackReward?: InputMaybe<Scalars['Boolean']['input']>;
  isScratchPromo?: InputMaybe<Scalars['Boolean']['input']>;
  isScratchReward?: InputMaybe<Scalars['Boolean']['input']>;
  isSpinPromo?: InputMaybe<Scalars['Boolean']['input']>;
  isSpinReward?: InputMaybe<Scalars['Boolean']['input']>;
  promoTag?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  typeOfCoupon?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePromotionInput = {
  actions: Array<ConfigurableOperationInput>;
  conditions: Array<ConfigurableOperationInput>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<CreatePromotionCustomFieldsInput>;
  enabled: Scalars['Boolean']['input'];
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  perCustomerUsageLimit?: InputMaybe<Scalars['Int']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  translations: Array<PromotionTranslationInput>;
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePromotionResult = MissingConditionsError | Promotion;

export type CreateProvinceInput = {
  code: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  enabled: Scalars['Boolean']['input'];
  translations: Array<ProvinceTranslationInput>;
};

export type CreateRoleInput = {
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  permissions: Array<Permission>;
};

export type CreateSellerInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
};

export type CreateShippingMethodInput = {
  calculator: ConfigurableOperationInput;
  checker: ConfigurableOperationInput;
  code: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  fulfillmentHandler: Scalars['String']['input'];
  translations: Array<ShippingMethodTranslationInput>;
};

export type CreateStockLocationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTagInput = {
  value: Scalars['String']['input'];
};

export type CreateTaxCategoryInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTaxRateInput = {
  categoryId: Scalars['ID']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  customerGroupId?: InputMaybe<Scalars['ID']['input']>;
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  value: Scalars['Float']['input'];
  zoneId: Scalars['ID']['input'];
};

export type CreateTemplateError = {
  __typename?: 'CreateTemplateError';
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type CreateTimeSlotInput = {
  date: Scalars['String']['input'];
  slots: Array<SlotInput>;
};

export type CreateZoneInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  memberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
};

export type CurbsidePickupError = ErrorResult & {
  __typename?: 'CurbsidePickupError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type CurbsidePickupResult = CurbsidePickupError | Order;

/**
 * @description
 * ISO 4217 currency code
 *
 * @docsCategory common
 */
export enum CurrencyCode {
  /** United Arab Emirates dirham */
  AED = 'AED',
  /** Afghan afghani */
  AFN = 'AFN',
  /** Albanian lek */
  ALL = 'ALL',
  /** Armenian dram */
  AMD = 'AMD',
  /** Netherlands Antillean guilder */
  ANG = 'ANG',
  /** Angolan kwanza */
  AOA = 'AOA',
  /** Argentine peso */
  ARS = 'ARS',
  /** Australian dollar */
  AUD = 'AUD',
  /** Aruban florin */
  AWG = 'AWG',
  /** Azerbaijani manat */
  AZN = 'AZN',
  /** Bosnia and Herzegovina convertible mark */
  BAM = 'BAM',
  /** Barbados dollar */
  BBD = 'BBD',
  /** Bangladeshi taka */
  BDT = 'BDT',
  /** Bulgarian lev */
  BGN = 'BGN',
  /** Bahraini dinar */
  BHD = 'BHD',
  /** Burundian franc */
  BIF = 'BIF',
  /** Bermudian dollar */
  BMD = 'BMD',
  /** Brunei dollar */
  BND = 'BND',
  /** Boliviano */
  BOB = 'BOB',
  /** Brazilian real */
  BRL = 'BRL',
  /** Bahamian dollar */
  BSD = 'BSD',
  /** Bhutanese ngultrum */
  BTN = 'BTN',
  /** Botswana pula */
  BWP = 'BWP',
  /** Belarusian ruble */
  BYN = 'BYN',
  /** Belize dollar */
  BZD = 'BZD',
  /** Canadian dollar */
  CAD = 'CAD',
  /** Congolese franc */
  CDF = 'CDF',
  /** Swiss franc */
  CHF = 'CHF',
  /** Chilean peso */
  CLP = 'CLP',
  /** Renminbi (Chinese) yuan */
  CNY = 'CNY',
  /** Colombian peso */
  COP = 'COP',
  /** Costa Rican colon */
  CRC = 'CRC',
  /** Cuban convertible peso */
  CUC = 'CUC',
  /** Cuban peso */
  CUP = 'CUP',
  /** Cape Verde escudo */
  CVE = 'CVE',
  /** Czech koruna */
  CZK = 'CZK',
  /** Djiboutian franc */
  DJF = 'DJF',
  /** Danish krone */
  DKK = 'DKK',
  /** Dominican peso */
  DOP = 'DOP',
  /** Algerian dinar */
  DZD = 'DZD',
  /** Egyptian pound */
  EGP = 'EGP',
  /** Eritrean nakfa */
  ERN = 'ERN',
  /** Ethiopian birr */
  ETB = 'ETB',
  /** Euro */
  EUR = 'EUR',
  /** Fiji dollar */
  FJD = 'FJD',
  /** Falkland Islands pound */
  FKP = 'FKP',
  /** Pound sterling */
  GBP = 'GBP',
  /** Georgian lari */
  GEL = 'GEL',
  /** Ghanaian cedi */
  GHS = 'GHS',
  /** Gibraltar pound */
  GIP = 'GIP',
  /** Gambian dalasi */
  GMD = 'GMD',
  /** Guinean franc */
  GNF = 'GNF',
  /** Guatemalan quetzal */
  GTQ = 'GTQ',
  /** Guyanese dollar */
  GYD = 'GYD',
  /** Hong Kong dollar */
  HKD = 'HKD',
  /** Honduran lempira */
  HNL = 'HNL',
  /** Croatian kuna */
  HRK = 'HRK',
  /** Haitian gourde */
  HTG = 'HTG',
  /** Hungarian forint */
  HUF = 'HUF',
  /** Indonesian rupiah */
  IDR = 'IDR',
  /** Israeli new shekel */
  ILS = 'ILS',
  /** Indian rupee */
  INR = 'INR',
  /** Iraqi dinar */
  IQD = 'IQD',
  /** Iranian rial */
  IRR = 'IRR',
  /** Icelandic króna */
  ISK = 'ISK',
  /** Jamaican dollar */
  JMD = 'JMD',
  /** Jordanian dinar */
  JOD = 'JOD',
  /** Japanese yen */
  JPY = 'JPY',
  /** Kenyan shilling */
  KES = 'KES',
  /** Kyrgyzstani som */
  KGS = 'KGS',
  /** Cambodian riel */
  KHR = 'KHR',
  /** Comoro franc */
  KMF = 'KMF',
  /** North Korean won */
  KPW = 'KPW',
  /** South Korean won */
  KRW = 'KRW',
  /** Kuwaiti dinar */
  KWD = 'KWD',
  /** Cayman Islands dollar */
  KYD = 'KYD',
  /** Kazakhstani tenge */
  KZT = 'KZT',
  /** Lao kip */
  LAK = 'LAK',
  /** Lebanese pound */
  LBP = 'LBP',
  /** Sri Lankan rupee */
  LKR = 'LKR',
  /** Liberian dollar */
  LRD = 'LRD',
  /** Lesotho loti */
  LSL = 'LSL',
  /** Libyan dinar */
  LYD = 'LYD',
  /** Moroccan dirham */
  MAD = 'MAD',
  /** Moldovan leu */
  MDL = 'MDL',
  /** Malagasy ariary */
  MGA = 'MGA',
  /** Macedonian denar */
  MKD = 'MKD',
  /** Myanmar kyat */
  MMK = 'MMK',
  /** Mongolian tögrög */
  MNT = 'MNT',
  /** Macanese pataca */
  MOP = 'MOP',
  /** Mauritanian ouguiya */
  MRU = 'MRU',
  /** Mauritian rupee */
  MUR = 'MUR',
  /** Maldivian rufiyaa */
  MVR = 'MVR',
  /** Malawian kwacha */
  MWK = 'MWK',
  /** Mexican peso */
  MXN = 'MXN',
  /** Malaysian ringgit */
  MYR = 'MYR',
  /** Mozambican metical */
  MZN = 'MZN',
  /** Namibian dollar */
  NAD = 'NAD',
  /** Nigerian naira */
  NGN = 'NGN',
  /** Nicaraguan córdoba */
  NIO = 'NIO',
  /** Norwegian krone */
  NOK = 'NOK',
  /** Nepalese rupee */
  NPR = 'NPR',
  /** New Zealand dollar */
  NZD = 'NZD',
  /** Omani rial */
  OMR = 'OMR',
  /** Panamanian balboa */
  PAB = 'PAB',
  /** Peruvian sol */
  PEN = 'PEN',
  /** Papua New Guinean kina */
  PGK = 'PGK',
  /** Philippine peso */
  PHP = 'PHP',
  /** Pakistani rupee */
  PKR = 'PKR',
  /** Polish złoty */
  PLN = 'PLN',
  /** Paraguayan guaraní */
  PYG = 'PYG',
  /** Qatari riyal */
  QAR = 'QAR',
  /** Romanian leu */
  RON = 'RON',
  /** Serbian dinar */
  RSD = 'RSD',
  /** Russian ruble */
  RUB = 'RUB',
  /** Rwandan franc */
  RWF = 'RWF',
  /** Saudi riyal */
  SAR = 'SAR',
  /** Solomon Islands dollar */
  SBD = 'SBD',
  /** Seychelles rupee */
  SCR = 'SCR',
  /** Sudanese pound */
  SDG = 'SDG',
  /** Swedish krona/kronor */
  SEK = 'SEK',
  /** Singapore dollar */
  SGD = 'SGD',
  /** Saint Helena pound */
  SHP = 'SHP',
  /** Sierra Leonean leone */
  SLL = 'SLL',
  /** Somali shilling */
  SOS = 'SOS',
  /** Surinamese dollar */
  SRD = 'SRD',
  /** South Sudanese pound */
  SSP = 'SSP',
  /** São Tomé and Príncipe dobra */
  STN = 'STN',
  /** Salvadoran colón */
  SVC = 'SVC',
  /** Syrian pound */
  SYP = 'SYP',
  /** Swazi lilangeni */
  SZL = 'SZL',
  /** Thai baht */
  THB = 'THB',
  /** Tajikistani somoni */
  TJS = 'TJS',
  /** Turkmenistan manat */
  TMT = 'TMT',
  /** Tunisian dinar */
  TND = 'TND',
  /** Tongan paʻanga */
  TOP = 'TOP',
  /** Turkish lira */
  TRY = 'TRY',
  /** Trinidad and Tobago dollar */
  TTD = 'TTD',
  /** New Taiwan dollar */
  TWD = 'TWD',
  /** Tanzanian shilling */
  TZS = 'TZS',
  /** Ukrainian hryvnia */
  UAH = 'UAH',
  /** Ugandan shilling */
  UGX = 'UGX',
  /** United States dollar */
  USD = 'USD',
  /** Uruguayan peso */
  UYU = 'UYU',
  /** Uzbekistan som */
  UZS = 'UZS',
  /** Venezuelan bolívar soberano */
  VES = 'VES',
  /** Vietnamese đồng */
  VND = 'VND',
  /** Vanuatu vatu */
  VUV = 'VUV',
  /** Samoan tala */
  WST = 'WST',
  /** CFA franc BEAC */
  XAF = 'XAF',
  /** East Caribbean dollar */
  XCD = 'XCD',
  /** CFA franc BCEAO */
  XOF = 'XOF',
  /** CFP franc (franc Pacifique) */
  XPF = 'XPF',
  /** Yemeni rial */
  YER = 'YER',
  /** South African rand */
  ZAR = 'ZAR',
  /** Zambian kwacha */
  ZMW = 'ZMW',
  /** Zimbabwean dollar */
  ZWL = 'ZWL'
}

export type CurrentUser = {
  __typename?: 'CurrentUser';
  channels: Array<CurrentUserChannel>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
};

export type CurrentUserChannel = {
  __typename?: 'CurrentUserChannel';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  permissions: Array<Permission>;
  token: Scalars['String']['output'];
};

export type CustomField = {
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type CustomFieldConfig = BooleanCustomFieldConfig | DateTimeCustomFieldConfig | FloatCustomFieldConfig | IntCustomFieldConfig | LocaleStringCustomFieldConfig | LocaleTextCustomFieldConfig | RelationCustomFieldConfig | StringCustomFieldConfig | StructCustomFieldConfig | TextCustomFieldConfig;

/**
 * This type is deprecated in v2.2 in favor of the EntityCustomFields type,
 * which allows custom fields to be defined on user-supplied entities.
 */
export type CustomFields = {
  __typename?: 'CustomFields';
  Address: Array<CustomFieldConfig>;
  Administrator: Array<CustomFieldConfig>;
  Asset: Array<CustomFieldConfig>;
  Channel: Array<CustomFieldConfig>;
  Collection: Array<CustomFieldConfig>;
  Customer: Array<CustomFieldConfig>;
  CustomerGroup: Array<CustomFieldConfig>;
  Facet: Array<CustomFieldConfig>;
  FacetValue: Array<CustomFieldConfig>;
  Fulfillment: Array<CustomFieldConfig>;
  GlobalSettings: Array<CustomFieldConfig>;
  HistoryEntry: Array<CustomFieldConfig>;
  Order: Array<CustomFieldConfig>;
  OrderLine: Array<CustomFieldConfig>;
  Payment: Array<CustomFieldConfig>;
  PaymentMethod: Array<CustomFieldConfig>;
  Product: Array<CustomFieldConfig>;
  ProductOption: Array<CustomFieldConfig>;
  ProductOptionGroup: Array<CustomFieldConfig>;
  ProductVariant: Array<CustomFieldConfig>;
  ProductVariantPrice: Array<CustomFieldConfig>;
  Promotion: Array<CustomFieldConfig>;
  Refund: Array<CustomFieldConfig>;
  Region: Array<CustomFieldConfig>;
  Seller: Array<CustomFieldConfig>;
  Session: Array<CustomFieldConfig>;
  ShippingLine: Array<CustomFieldConfig>;
  ShippingMethod: Array<CustomFieldConfig>;
  StockLevel: Array<CustomFieldConfig>;
  StockLocation: Array<CustomFieldConfig>;
  StockMovement: Array<CustomFieldConfig>;
  TaxCategory: Array<CustomFieldConfig>;
  TaxRate: Array<CustomFieldConfig>;
  User: Array<CustomFieldConfig>;
  Zone: Array<CustomFieldConfig>;
};

export type CustomSearchResponse = {
  __typename?: 'CustomSearchResponse';
  items: Array<ProductVariantSearchItem>;
  totalItems: Scalars['Int']['output'];
};

export type Customer = Node & {
  __typename?: 'Customer';
  abandonedCartSince?: Maybe<Scalars['DateTime']['output']>;
  actualDob?: Maybe<Scalars['String']['output']>;
  addresses?: Maybe<Array<Address>>;
  appUser?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<CustomerCustomFields>;
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  groups: Array<CustomerGroup>;
  history: HistoryEntryList;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  notPurchasedSince?: Maybe<Scalars['DateTime']['output']>;
  notSignedInSince?: Maybe<Scalars['DateTime']['output']>;
  orders: OrderList;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};


export type CustomerHistoryArgs = {
  options?: InputMaybe<HistoryEntryListOptions>;
};


export type CustomerOrdersArgs = {
  options?: InputMaybe<OrderListOptions>;
};

export type CustomerAnalyticsSummaryInput = {
  channelID?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['DateTime']['input'];
  interval: MetricInterval;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type CustomerCustomFields = {
  __typename?: 'CustomerCustomFields';
  activeCartSince?: Maybe<Scalars['DateTime']['output']>;
  barcode?: Maybe<Asset>;
  claimSignUpRewardLater?: Maybe<Scalars['Boolean']['output']>;
  cloverCustomerIds?: Maybe<Scalars['String']['output']>;
  cumulativePoints?: Maybe<Scalars['Int']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  dripCampaignEnrolledAt?: Maybe<Scalars['DateTime']['output']>;
  favouriteRestaurants?: Maybe<Array<Channel>>;
  fcmToken?: Maybe<Scalars['String']['output']>;
  isAppUser?: Maybe<Scalars['Boolean']['output']>;
  lastScratchDate?: Maybe<Scalars['DateTime']['output']>;
  lastSpinDate?: Maybe<Scalars['DateTime']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  loginCount?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  loyaltyCodes?: Maybe<Array<CustomerLoyaltyCodesStruct>>;
  loyaltyPoints?: Maybe<Scalars['Int']['output']>;
  loyaltyTier?: Maybe<Scalars['String']['output']>;
  marketingUserID?: Maybe<Scalars['String']['output']>;
  notLoggedInSince?: Maybe<Scalars['DateTime']['output']>;
  notPurchasedItemSince?: Maybe<Scalars['DateTime']['output']>;
  posNumber?: Maybe<Scalars['String']['output']>;
  referralCodeShared?: Maybe<Scalars['String']['output']>;
  referralCodeUsed?: Maybe<Scalars['String']['output']>;
  scratchLastRewardDate?: Maybe<Scalars['DateTime']['output']>;
  shift4CustomerId?: Maybe<Scalars['String']['output']>;
  signUpRewardClaimed?: Maybe<Scalars['Boolean']['output']>;
  spinLastRewardDate?: Maybe<Scalars['DateTime']['output']>;
  topMostFavoriteLocation?: Maybe<Scalars['String']['output']>;
  topMostFavoriteRestaurant?: Maybe<Channel>;
  wishlistItems?: Maybe<Array<WishlistItem>>;
};

export type CustomerFilterParameter = {
  _and?: InputMaybe<Array<CustomerFilterParameter>>;
  _or?: InputMaybe<Array<CustomerFilterParameter>>;
  abandonedCartSince?: InputMaybe<DateOperators>;
  activeCartSince?: InputMaybe<DateOperators>;
  actualDob?: InputMaybe<StringOperators>;
  appUser?: InputMaybe<BooleanOperators>;
  claimSignUpRewardLater?: InputMaybe<BooleanOperators>;
  cloverCustomerIds?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  cumulativePoints?: InputMaybe<NumberOperators>;
  dob?: InputMaybe<StringOperators>;
  dripCampaignEnrolledAt?: InputMaybe<DateOperators>;
  emailAddress?: InputMaybe<StringOperators>;
  fcmToken?: InputMaybe<StringOperators>;
  firstName?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  isAppUser?: InputMaybe<BooleanOperators>;
  lastName?: InputMaybe<StringOperators>;
  lastScratchDate?: InputMaybe<DateOperators>;
  lastSpinDate?: InputMaybe<DateOperators>;
  latitude?: InputMaybe<StringOperators>;
  loginCount?: InputMaybe<NumberOperators>;
  longitude?: InputMaybe<StringOperators>;
  loyaltyPoints?: InputMaybe<NumberOperators>;
  loyaltyTier?: InputMaybe<StringOperators>;
  marketingUserID?: InputMaybe<StringOperators>;
  notLoggedInSince?: InputMaybe<DateOperators>;
  notPurchasedItemSince?: InputMaybe<DateOperators>;
  notPurchasedSince?: InputMaybe<DateOperators>;
  notSignedInSince?: InputMaybe<DateOperators>;
  phoneNumber?: InputMaybe<StringOperators>;
  posNumber?: InputMaybe<StringOperators>;
  postalCode?: InputMaybe<StringOperators>;
  referralCodeShared?: InputMaybe<StringOperators>;
  referralCodeUsed?: InputMaybe<StringOperators>;
  scratchLastRewardDate?: InputMaybe<DateOperators>;
  shift4CustomerId?: InputMaybe<StringOperators>;
  signUpRewardClaimed?: InputMaybe<BooleanOperators>;
  spinLastRewardDate?: InputMaybe<DateOperators>;
  title?: InputMaybe<StringOperators>;
  topMostFavoriteLocation?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type CustomerGroup = Node & {
  __typename?: 'CustomerGroup';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  customers: CustomerList;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type CustomerGroupCustomersArgs = {
  options?: InputMaybe<CustomerListOptions>;
};

export type CustomerGroupFilterParameter = {
  _and?: InputMaybe<Array<CustomerGroupFilterParameter>>;
  _or?: InputMaybe<Array<CustomerGroupFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type CustomerGroupList = PaginatedList & {
  __typename?: 'CustomerGroupList';
  items: Array<CustomerGroup>;
  totalItems: Scalars['Int']['output'];
};

export type CustomerGroupListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<CustomerGroupFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<CustomerGroupSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerGroupSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CustomerList = PaginatedList & {
  __typename?: 'CustomerList';
  items: Array<Customer>;
  totalItems: Scalars['Int']['output'];
};

export type CustomerListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<CustomerFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<CustomerSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerLocation = {
  __typename?: 'CustomerLocation';
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
};

export type CustomerLocationList = {
  __typename?: 'CustomerLocationList';
  items: Array<CustomerLocation>;
  totalItems: Scalars['Int']['output'];
};

export type CustomerLoyaltyCodesStruct = {
  __typename?: 'CustomerLoyaltyCodesStruct';
  asset?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  isInActive?: Maybe<Scalars['Boolean']['output']>;
  isRedeemed?: Maybe<Scalars['Boolean']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
};

export type CustomerLoyaltyCodesStructInput = {
  asset?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  isInActive?: InputMaybe<Scalars['Boolean']['input']>;
  isRedeemed?: InputMaybe<Scalars['Boolean']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerMetricData = {
  __typename?: 'CustomerMetricData';
  entries: Array<MetricSummaryEntry>;
  interval: MetricInterval;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CustomerMetricSummary = {
  __typename?: 'CustomerMetricSummary';
  items: Array<CustomerMetricData>;
  totalCustomers: Scalars['Int']['output'];
};

export type CustomerSortParameter = {
  abandonedCartSince?: InputMaybe<SortOrder>;
  activeCartSince?: InputMaybe<SortOrder>;
  actualDob?: InputMaybe<SortOrder>;
  barcode?: InputMaybe<SortOrder>;
  claimSignUpRewardLater?: InputMaybe<SortOrder>;
  cloverCustomerIds?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  cumulativePoints?: InputMaybe<SortOrder>;
  dob?: InputMaybe<SortOrder>;
  dripCampaignEnrolledAt?: InputMaybe<SortOrder>;
  emailAddress?: InputMaybe<SortOrder>;
  fcmToken?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isAppUser?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  lastScratchDate?: InputMaybe<SortOrder>;
  lastSpinDate?: InputMaybe<SortOrder>;
  latitude?: InputMaybe<SortOrder>;
  loginCount?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  loyaltyPoints?: InputMaybe<SortOrder>;
  loyaltyTier?: InputMaybe<SortOrder>;
  marketingUserID?: InputMaybe<SortOrder>;
  notLoggedInSince?: InputMaybe<SortOrder>;
  notPurchasedItemSince?: InputMaybe<SortOrder>;
  notPurchasedSince?: InputMaybe<SortOrder>;
  notSignedInSince?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  posNumber?: InputMaybe<SortOrder>;
  referralCodeShared?: InputMaybe<SortOrder>;
  referralCodeUsed?: InputMaybe<SortOrder>;
  scratchLastRewardDate?: InputMaybe<SortOrder>;
  shift4CustomerId?: InputMaybe<SortOrder>;
  signUpRewardClaimed?: InputMaybe<SortOrder>;
  spinLastRewardDate?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  topMostFavoriteLocation?: InputMaybe<SortOrder>;
  topMostFavoriteRestaurant?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

/** Operators for filtering on a list of Date fields */
export type DateListOperators = {
  inList: Scalars['DateTime']['input'];
};

/** Operators for filtering on a DateTime field */
export type DateOperators = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  between?: InputMaybe<DateRange>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DateRange = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

/**
 * Expects the same validation formats as the `<input type="datetime-local">` HTML element.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/datetime-local#Additional_attributes
 */
export type DateTimeCustomFieldConfig = CustomField & {
  __typename?: 'DateTimeCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  step?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

/**
 * Expects the same validation formats as the `<input type="datetime-local">` HTML element.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/datetime-local#Additional_attributes
 */
export type DateTimeStructFieldConfig = StructField & {
  __typename?: 'DateTimeStructFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  step?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type DeleteAssetInput = {
  assetId: Scalars['ID']['input'];
  deleteFromAllChannels?: InputMaybe<Scalars['Boolean']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteAssetsInput = {
  assetIds: Array<Scalars['ID']['input']>;
  deleteFromAllChannels?: InputMaybe<Scalars['Boolean']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteFeedbacksResponse = {
  __typename?: 'DeleteFeedbacksResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteStockLocationInput = {
  id: Scalars['ID']['input'];
  transferToLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeletionResponse = {
  __typename?: 'DeletionResponse';
  message?: Maybe<Scalars['String']['output']>;
  result: DeletionResult;
};

export enum DeletionResult {
  /** The entity was successfully deleted */
  DELETED = 'DELETED',
  /** Deletion did not take place, reason given in message */
  NOT_DELETED = 'NOT_DELETED'
}

export type Discount = {
  __typename?: 'Discount';
  adjustmentSource: Scalars['String']['output'];
  amount: Scalars['Money']['output'];
  amountWithTax: Scalars['Money']['output'];
  description: Scalars['String']['output'];
  type: AdjustmentType;
};

export type DoorDashOrder = {
  __typename?: 'DoorDashOrder';
  currency: Scalars['String']['output'];
  deliveryRiderDasherId: Scalars['String']['output'];
  deliveryRiderName: Scalars['String']['output'];
  deliveryRiderNumber: Scalars['String']['output'];
  deliveryRiderVehicle: Scalars['String']['output'];
  dropoffAddress: Scalars['String']['output'];
  dropoffContactFamilyName: Scalars['String']['output'];
  dropoffContactGivenName: Scalars['String']['output'];
  dropoffPhoneNumber: Scalars['String']['output'];
  dropoffTimeActual?: Maybe<Scalars['String']['output']>;
  dropoffTimeEstimated?: Maybe<Scalars['String']['output']>;
  externalDeliveryId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  orderValue: Scalars['Int']['output'];
  pickupAddress: Scalars['String']['output'];
  pickupTimeActual?: Maybe<Scalars['String']['output']>;
  pickupTimeEstimated?: Maybe<Scalars['String']['output']>;
  trackingUrl: Scalars['String']['output'];
};

export type DoorDashOrderList = {
  __typename?: 'DoorDashOrderList';
  items: Array<DoorDashOrder>;
  totalItems: Scalars['Int']['output'];
};

export type DoordashBusinessError = ErrorResult & {
  __typename?: 'DoordashBusinessError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type DoordashBusinessResult = DoordashBusinessError | DoordashResponse;

export type DoordashResponse = {
  __typename?: 'DoordashResponse';
  activation_status: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  description: Scalars['String']['output'];
  external_business_id: Scalars['String']['output'];
  is_test: Scalars['Boolean']['output'];
  last_updated_at: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DripCampaign = {
  __typename?: 'DripCampaign';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fromEmail: Scalars['String']['output'];
  fromName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  steps: Array<DripStep>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DripStep = {
  __typename?: 'DripStep';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  daysAfterRegistration: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  subject: Scalars['String']['output'];
  timeToSend: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DripStepInput = {
  content: Scalars['String']['input'];
  daysAfterRegistration: Scalars['Int']['input'];
  subject: Scalars['String']['input'];
  timeToSend: Scalars['String']['input'];
};

export type DuplicateEntityError = ErrorResult & {
  __typename?: 'DuplicateEntityError';
  duplicationError: Scalars['String']['output'];
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type DuplicateEntityInput = {
  duplicatorInput: ConfigurableOperationInput;
  entityId: Scalars['ID']['input'];
  entityName: Scalars['String']['input'];
};

export type DuplicateEntityResult = DuplicateEntityError | DuplicateEntitySuccess;

export type DuplicateEntitySuccess = {
  __typename?: 'DuplicateEntitySuccess';
  newEntityId: Scalars['ID']['output'];
};

/** Returned when attempting to create a Customer with an email address already registered to an existing User. */
export type EmailAddressConflictError = ErrorResult & {
  __typename?: 'EmailAddressConflictError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type EmailTemplate = Node & {
  __typename?: 'EmailTemplate';
  body: Scalars['String']['output'];
  category: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmailTemplateFilterParameter = {
  _and?: InputMaybe<Array<EmailTemplateFilterParameter>>;
  _or?: InputMaybe<Array<EmailTemplateFilterParameter>>;
  body?: InputMaybe<StringOperators>;
  category?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  subject?: InputMaybe<StringOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type EmailTemplateList = PaginatedList & {
  __typename?: 'EmailTemplateList';
  items: Array<EmailTemplate>;
  totalItems: Scalars['Int']['output'];
};

export type EmailTemplateListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<EmailTemplateFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<EmailTemplateSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type EmailTemplateResult = CreateTemplateError | EmailTemplate;

export type EmailTemplateSortParameter = {
  body?: InputMaybe<SortOrder>;
  category?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

/** Returned if no OrderLines have been specified for the operation */
export type EmptyOrderLineSelectionError = ErrorResult & {
  __typename?: 'EmptyOrderLineSelectionError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type EntityCustomFields = {
  __typename?: 'EntityCustomFields';
  customFields: Array<CustomFieldConfig>;
  entityName: Scalars['String']['output'];
};

export type EntityDuplicatorDefinition = {
  __typename?: 'EntityDuplicatorDefinition';
  args: Array<ConfigArgDefinition>;
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  forEntities: Array<Scalars['String']['output']>;
  requiresPermission: Array<Permission>;
};

export enum ErrorCode {
  ALREADY_REFUNDED_ERROR = 'ALREADY_REFUNDED_ERROR',
  CANCEL_ACTIVE_ORDER_ERROR = 'CANCEL_ACTIVE_ORDER_ERROR',
  CANCEL_PAYMENT_ERROR = 'CANCEL_PAYMENT_ERROR',
  CHANNEL_DEFAULT_LANGUAGE_ERROR = 'CHANNEL_DEFAULT_LANGUAGE_ERROR',
  COUPON_CODE_EXPIRED_ERROR = 'COUPON_CODE_EXPIRED_ERROR',
  COUPON_CODE_INVALID_ERROR = 'COUPON_CODE_INVALID_ERROR',
  COUPON_CODE_LIMIT_ERROR = 'COUPON_CODE_LIMIT_ERROR',
  CREATE_FULFILLMENT_ERROR = 'CREATE_FULFILLMENT_ERROR',
  CURBSIDE_PICKUP_ERROR = 'CURBSIDE_PICKUP_ERROR',
  DOORDASH_BUSINESS_ERROR = 'DOORDASH_BUSINESS_ERROR',
  DUPLICATE_ENTITY_ERROR = 'DUPLICATE_ENTITY_ERROR',
  EMAIL_ADDRESS_CONFLICT_ERROR = 'EMAIL_ADDRESS_CONFLICT_ERROR',
  EMPTY_ORDER_LINE_SELECTION_ERROR = 'EMPTY_ORDER_LINE_SELECTION_ERROR',
  FACET_IN_USE_ERROR = 'FACET_IN_USE_ERROR',
  FULFILLMENT_STATE_TRANSITION_ERROR = 'FULFILLMENT_STATE_TRANSITION_ERROR',
  GUEST_CHECKOUT_ERROR = 'GUEST_CHECKOUT_ERROR',
  INELIGIBLE_SHIPPING_METHOD_ERROR = 'INELIGIBLE_SHIPPING_METHOD_ERROR',
  INSUFFICIENT_STOCK_ERROR = 'INSUFFICIENT_STOCK_ERROR',
  INSUFFICIENT_STOCK_ON_HAND_ERROR = 'INSUFFICIENT_STOCK_ON_HAND_ERROR',
  INVALID_CREDENTIALS_ERROR = 'INVALID_CREDENTIALS_ERROR',
  INVALID_FULFILLMENT_HANDLER_ERROR = 'INVALID_FULFILLMENT_HANDLER_ERROR',
  ITEMS_ALREADY_FULFILLED_ERROR = 'ITEMS_ALREADY_FULFILLED_ERROR',
  LANGUAGE_NOT_AVAILABLE_ERROR = 'LANGUAGE_NOT_AVAILABLE_ERROR',
  MANUAL_PAYMENT_STATE_ERROR = 'MANUAL_PAYMENT_STATE_ERROR',
  MIME_TYPE_ERROR = 'MIME_TYPE_ERROR',
  MISSING_CONDITIONS_ERROR = 'MISSING_CONDITIONS_ERROR',
  MULTIPLE_ORDER_ERROR = 'MULTIPLE_ORDER_ERROR',
  NATIVE_AUTH_STRATEGY_ERROR = 'NATIVE_AUTH_STRATEGY_ERROR',
  NEGATIVE_QUANTITY_ERROR = 'NEGATIVE_QUANTITY_ERROR',
  NOTHING_TO_REFUND_ERROR = 'NOTHING_TO_REFUND_ERROR',
  NO_ACTIVE_ORDER_ERROR = 'NO_ACTIVE_ORDER_ERROR',
  NO_CHANGES_SPECIFIED_ERROR = 'NO_CHANGES_SPECIFIED_ERROR',
  ORDER_INTERCEPTOR_ERROR = 'ORDER_INTERCEPTOR_ERROR',
  ORDER_LIMIT_ERROR = 'ORDER_LIMIT_ERROR',
  ORDER_MODIFICATION_ERROR = 'ORDER_MODIFICATION_ERROR',
  ORDER_MODIFICATION_STATE_ERROR = 'ORDER_MODIFICATION_STATE_ERROR',
  ORDER_STATE_TRANSITION_ERROR = 'ORDER_STATE_TRANSITION_ERROR',
  PAYMENT_METHOD_MISSING_ERROR = 'PAYMENT_METHOD_MISSING_ERROR',
  PAYMENT_ORDER_MISMATCH_ERROR = 'PAYMENT_ORDER_MISMATCH_ERROR',
  PAYMENT_STATE_TRANSITION_ERROR = 'PAYMENT_STATE_TRANSITION_ERROR',
  PRODUCT_OPTION_IN_USE_ERROR = 'PRODUCT_OPTION_IN_USE_ERROR',
  QUANTITY_TOO_GREAT_ERROR = 'QUANTITY_TOO_GREAT_ERROR',
  REFUND_AMOUNT_ERROR = 'REFUND_AMOUNT_ERROR',
  REFUND_ORDER_STATE_ERROR = 'REFUND_ORDER_STATE_ERROR',
  REFUND_PAYMENT_ID_MISSING_ERROR = 'REFUND_PAYMENT_ID_MISSING_ERROR',
  REFUND_STATE_TRANSITION_ERROR = 'REFUND_STATE_TRANSITION_ERROR',
  SETTLE_PAYMENT_ERROR = 'SETTLE_PAYMENT_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

export type ErrorResult = {
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type ExternalMetadata = {
  __typename?: 'ExternalMetadata';
  client_email?: Maybe<Scalars['String']['output']>;
  client_phone_number?: Maybe<Scalars['String']['output']>;
  external_store_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  number_of_stores?: Maybe<Scalars['String']['output']>;
};

export type Facet = Node & {
  __typename?: 'Facet';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  translations: Array<FacetTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  /** Returns a paginated, sortable, filterable list of the Facet's values. Added in v2.1.0. */
  valueList: FacetValueList;
  values: Array<FacetValue>;
};


export type FacetValueListArgs = {
  options?: InputMaybe<FacetValueListOptions>;
};

export type FacetFilterParameter = {
  _and?: InputMaybe<Array<FacetFilterParameter>>;
  _or?: InputMaybe<Array<FacetFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  isPrivate?: InputMaybe<BooleanOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FacetInUseError = ErrorResult & {
  __typename?: 'FacetInUseError';
  errorCode: ErrorCode;
  facetCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
  productCount: Scalars['Int']['output'];
  variantCount: Scalars['Int']['output'];
};

export type FacetList = PaginatedList & {
  __typename?: 'FacetList';
  items: Array<Facet>;
  totalItems: Scalars['Int']['output'];
};

export type FacetListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FacetFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FacetSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FacetSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FacetTranslation = {
  __typename?: 'FacetTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FacetTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FacetValue = Node & {
  __typename?: 'FacetValue';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  facet: Facet;
  facetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  translations: Array<FacetValueTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Used to construct boolean expressions for filtering search results
 * by FacetValue ID. Examples:
 *
 * * ID=1 OR ID=2: `{ facetValueFilters: [{ or: [1,2] }] }`
 * * ID=1 AND ID=2: `{ facetValueFilters: [{ and: 1 }, { and: 2 }] }`
 * * ID=1 AND (ID=2 OR ID=3): `{ facetValueFilters: [{ and: 1 }, { or: [2,3] }] }`
 */
export type FacetValueFilterInput = {
  and?: InputMaybe<Scalars['ID']['input']>;
  or?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FacetValueFilterParameter = {
  _and?: InputMaybe<Array<FacetValueFilterParameter>>;
  _or?: InputMaybe<Array<FacetValueFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  facetId?: InputMaybe<IdOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FacetValueList = PaginatedList & {
  __typename?: 'FacetValueList';
  items: Array<FacetValue>;
  totalItems: Scalars['Int']['output'];
};

export type FacetValueListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FacetValueFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FacetValueSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Which FacetValues are present in the products returned
 * by the search, and in what quantity.
 */
export type FacetValueResult = {
  __typename?: 'FacetValueResult';
  count: Scalars['Int']['output'];
  facetValue: FacetValue;
};

export type FacetValueSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  facetId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FacetValueTranslation = {
  __typename?: 'FacetValueTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FacetValueTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Feedback = Node & {
  __typename?: 'Feedback';
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  deviceType?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  phone?: Maybe<Scalars['String']['output']>;
  promoMetadata?: Maybe<Scalars['JSON']['output']>;
  promotionSent?: Maybe<Promotion>;
  responsesSent?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  sentiment: FeedbackSentiment;
  store?: Maybe<Channel>;
  subject: Scalars['String']['output'];
  tag: Scalars['String']['output'];
  type: FeedbackType;
  updatedAt: Scalars['DateTime']['output'];
};

export type FeedbackAdminSendResponseInput = {
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  sendVia: SendViaInput;
};

export type FeedbackAdminUpdateInput = {
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  sentiment?: InputMaybe<FeedbackSentiment>;
  subject?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FeedbackType>;
};

export type FeedbackFilterParameter = {
  _and?: InputMaybe<Array<FeedbackFilterParameter>>;
  _or?: InputMaybe<Array<FeedbackFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  customerFirstName?: InputMaybe<StringOperators>;
  customerId?: InputMaybe<IdOperators>;
  customerLastName?: InputMaybe<StringOperators>;
  deviceType?: InputMaybe<StringOperators>;
  email?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  message?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  orderCode?: InputMaybe<StringOperators>;
  orderId?: InputMaybe<IdOperators>;
  phone?: InputMaybe<StringOperators>;
  sentiment?: InputMaybe<StringOperators>;
  storeName?: InputMaybe<StringOperators>;
  subject?: InputMaybe<StringOperators>;
  tag?: InputMaybe<StringOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FeedbackList = PaginatedList & {
  __typename?: 'FeedbackList';
  items: Array<Feedback>;
  totalItems: Scalars['Int']['output'];
};

export type FeedbackListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FeedbackFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FeedbackSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export enum FeedbackSentiment {
  NA = 'NA',
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
  POSITIVE = 'POSITIVE'
}

export type FeedbackSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  customerFirstName?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  customerLastName?: InputMaybe<SortOrder>;
  deviceType?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  orderCode?: InputMaybe<SortOrder>;
  orderId?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  sentiment?: InputMaybe<SortOrder>;
  storeName?: InputMaybe<SortOrder>;
  subject?: InputMaybe<SortOrder>;
  tag?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum FeedbackType {
  BUG = 'BUG',
  FEATURE = 'FEATURE',
  FEEDBACK = 'FEEDBACK',
  OTHER = 'OTHER',
  SUPPORT = 'SUPPORT'
}

export type FilteredOrdersByDay = {
  __typename?: 'FilteredOrdersByDay';
  rows: Array<OrderRow>;
  subTotal?: Maybe<Scalars['String']['output']>;
  totalDiscount?: Maybe<Scalars['String']['output']>;
  totalShippingCost?: Maybe<Scalars['String']['output']>;
  totalTax?: Maybe<Scalars['String']['output']>;
  totalTips?: Maybe<Scalars['String']['output']>;
  totalWithTax?: Maybe<Scalars['String']['output']>;
};

export type FloatCustomFieldConfig = CustomField & {
  __typename?: 'FloatCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  step?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type FloatStructFieldConfig = StructField & {
  __typename?: 'FloatStructFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  step?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type FocalPoint = {
  __typename?: 'FocalPoint';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type FulfillOrderInput = {
  handler: ConfigurableOperationInput;
  lines: Array<OrderLineInput>;
};

export type Fulfillment = Node & {
  __typename?: 'Fulfillment';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  lines: Array<FulfillmentLine>;
  method: Scalars['String']['output'];
  nextStates: Array<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  /** @deprecated Use the `lines` field instead */
  summary: Array<FulfillmentLine>;
  trackingCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FulfillmentLine = {
  __typename?: 'FulfillmentLine';
  fulfillment: Fulfillment;
  fulfillmentId: Scalars['ID']['output'];
  orderLine: OrderLine;
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

/** Returned when there is an error in transitioning the Fulfillment state */
export type FulfillmentStateTransitionError = ErrorResult & {
  __typename?: 'FulfillmentStateTransitionError';
  errorCode: ErrorCode;
  fromState: Scalars['String']['output'];
  message: Scalars['String']['output'];
  toState: Scalars['String']['output'];
  transitionError: Scalars['String']['output'];
};

export type GetFilteredOrdersByDayInput = {
  endDate: Scalars['DateTime']['input'];
  orderState: Scalars['String']['input'];
  orderType?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
  startDate: Scalars['DateTime']['input'];
};

export enum GlobalFlag {
  FALSE = 'FALSE',
  INHERIT = 'INHERIT',
  TRUE = 'TRUE'
}

export type GlobalSettings = {
  __typename?: 'GlobalSettings';
  availableLanguages: Array<LanguageCode>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<GlobalSettingsCustomFields>;
  id: Scalars['ID']['output'];
  outOfStockThreshold: Scalars['Int']['output'];
  serverConfig: ServerConfig;
  trackInventory: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GlobalSettingsCustomFields = {
  __typename?: 'GlobalSettingsCustomFields';
  cateringTierOneConversionToDollar?: Maybe<Scalars['Float']['output']>;
  cateringTierOneConversionToPoints?: Maybe<Scalars['Float']['output']>;
  cateringTierThreeConversionToDollar?: Maybe<Scalars['Float']['output']>;
  cateringTierThreeConversionToPoints?: Maybe<Scalars['Float']['output']>;
  cateringTierTwoConversionToDollar?: Maybe<Scalars['Float']['output']>;
  cateringTierTwoConversionToPoints?: Maybe<Scalars['Float']['output']>;
  curbsideNumber?: Maybe<Scalars['String']['output']>;
  doordashBusinessId?: Maybe<Scalars['String']['output']>;
  dripCampaigns?: Maybe<Array<GlobalSettingsDripCampaignsStruct>>;
  enableAlACarte?: Maybe<Scalars['Boolean']['output']>;
  enableCateringOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableCurbsidePickUp?: Maybe<Scalars['Boolean']['output']>;
  enableHolidayOrdering?: Maybe<Scalars['Boolean']['output']>;
  enableMakeAMeal?: Maybe<Scalars['Boolean']['output']>;
  enablePOSStatusEmail?: Maybe<Scalars['Boolean']['output']>;
  enableScratchPromo?: Maybe<Scalars['Boolean']['output']>;
  enableSpinPromo?: Maybe<Scalars['Boolean']['output']>;
  franchiseColor?: Maybe<Scalars['String']['output']>;
  franchiseEmail?: Maybe<Scalars['String']['output']>;
  franchiseLogo?: Maybe<Asset>;
  franchiseName?: Maybe<Scalars['String']['output']>;
  franchiseNumber?: Maybe<Scalars['String']['output']>;
  heroSectionAsset?: Maybe<Asset>;
  heroSectionText?: Maybe<Scalars['String']['output']>;
  holidayTierOneConversionToDollar?: Maybe<Scalars['Float']['output']>;
  holidayTierOneConversionToPoints?: Maybe<Scalars['Float']['output']>;
  holidayTierThreeConversionToDollar?: Maybe<Scalars['Float']['output']>;
  holidayTierThreeConversionToPoints?: Maybe<Scalars['Float']['output']>;
  holidayTierTwoConversionToDollar?: Maybe<Scalars['Float']['output']>;
  holidayTierTwoConversionToPoints?: Maybe<Scalars['Float']['output']>;
  loyaltyBreakPoints?: Maybe<Scalars['String']['output']>;
  loyaltyGiftExpiresInDays?: Maybe<Scalars['Int']['output']>;
  loyaltyPointsForAdminReferralCodeShared?: Maybe<Scalars['Int']['output']>;
  loyaltyPointsForAdminReferralCodeUsed?: Maybe<Scalars['Int']['output']>;
  loyaltyPointsForreferralCodeShared?: Maybe<Scalars['Int']['output']>;
  loyaltyPointsForreferralCodeUsed?: Maybe<Scalars['Int']['output']>;
  marketingCustomerSyncEnabled?: Maybe<Scalars['Boolean']['output']>;
  marketingPlatformAPIKey?: Maybe<Scalars['String']['output']>;
  marketingPlatformURL?: Maybe<Scalars['String']['output']>;
  memoNumber?: Maybe<Scalars['String']['output']>;
  mobileDiscountNumber?: Maybe<Scalars['String']['output']>;
  nameNumber?: Maybe<Scalars['String']['output']>;
  pickUpTimeNumber?: Maybe<Scalars['String']['output']>;
  posLoyaltyActiveMinutes?: Maybe<Scalars['Int']['output']>;
  positouchServerNumber?: Maybe<Scalars['String']['output']>;
  scratchWinningAllowedPeriod?: Maybe<Scalars['Int']['output']>;
  scratchesRequiredToWin?: Maybe<Scalars['Int']['output']>;
  serverMaintenance?: Maybe<Scalars['Boolean']['output']>;
  signUpLoyaltyPoints?: Maybe<Scalars['Int']['output']>;
  spinsRequiredToWin?: Maybe<Scalars['Int']['output']>;
  splashScreenImage?: Maybe<Asset>;
  splashScreenText?: Maybe<Scalars['String']['output']>;
  supportTicketReceiverEmail?: Maybe<Array<Scalars['String']['output']>>;
  temporaryMenuNumber?: Maybe<Scalars['String']['output']>;
  terminalNumber?: Maybe<Scalars['String']['output']>;
  tierOne?: Maybe<Scalars['Int']['output']>;
  tierOneBreakPoint1Description?: Maybe<Scalars['String']['output']>;
  tierOneBreakPoint2Description?: Maybe<Scalars['String']['output']>;
  tierOneBreakPoint3Description?: Maybe<Scalars['String']['output']>;
  tierOneConversionToDollar?: Maybe<Scalars['Float']['output']>;
  tierOneConversionToPoints?: Maybe<Scalars['Float']['output']>;
  tierOneDescription?: Maybe<Scalars['String']['output']>;
  tierOneName?: Maybe<Scalars['String']['output']>;
  tierThree?: Maybe<Scalars['Int']['output']>;
  tierThreeBreakPoint1Description?: Maybe<Scalars['String']['output']>;
  tierThreeBreakPoint2Description?: Maybe<Scalars['String']['output']>;
  tierThreeBreakPoint3Description?: Maybe<Scalars['String']['output']>;
  tierThreeConversionToDollar?: Maybe<Scalars['Float']['output']>;
  tierThreeConversionToPoints?: Maybe<Scalars['Float']['output']>;
  tierThreeDescription?: Maybe<Scalars['String']['output']>;
  tierThreeName?: Maybe<Scalars['String']['output']>;
  tierTwo?: Maybe<Scalars['Int']['output']>;
  tierTwoBreakPoint1Description?: Maybe<Scalars['String']['output']>;
  tierTwoBreakPoint2Description?: Maybe<Scalars['String']['output']>;
  tierTwoBreakPoint3Description?: Maybe<Scalars['String']['output']>;
  tierTwoConversionToDollar?: Maybe<Scalars['Float']['output']>;
  tierTwoConversionToPoints?: Maybe<Scalars['Float']['output']>;
  tierTwoDescription?: Maybe<Scalars['String']['output']>;
  tierTwoName?: Maybe<Scalars['String']['output']>;
  tipsOptions?: Maybe<Array<GlobalSettingsTipsOptionsStruct>>;
  utensilsRequiredTimeNumber?: Maybe<Scalars['String']['output']>;
  winningAllowedPeriod?: Maybe<Scalars['Int']['output']>;
};

export type GlobalSettingsDripCampaignsStruct = {
  __typename?: 'GlobalSettingsDripCampaignsStruct';
  interval?: Maybe<Scalars['Float']['output']>;
  intervalUnit?: Maybe<Scalars['String']['output']>;
  isOneTime?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sendingMode?: Maybe<Scalars['String']['output']>;
};

export type GlobalSettingsDripCampaignsStructInput = {
  interval?: InputMaybe<Scalars['Float']['input']>;
  intervalUnit?: InputMaybe<Scalars['String']['input']>;
  isOneTime?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendingMode?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalSettingsTipsOptionsStruct = {
  __typename?: 'GlobalSettingsTipsOptionsStruct';
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type GlobalSettingsTipsOptionsStructInput = {
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type GoogleReview = {
  __typename?: 'GoogleReview';
  authorName?: Maybe<Scalars['String']['output']>;
  authorUrl?: Maybe<Scalars['String']['output']>;
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  relativeTimeDescription?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['DateTime']['output']>;
};

/** Returned when attempting to set the Customer on a guest checkout when the configured GuestCheckoutStrategy does not allow it. */
export type GuestCheckoutError = ErrorResult & {
  __typename?: 'GuestCheckoutError';
  errorCode: ErrorCode;
  errorDetail: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type HistoryEntry = Node & {
  __typename?: 'HistoryEntry';
  administrator?: Maybe<Administrator>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  type: HistoryEntryType;
  updatedAt: Scalars['DateTime']['output'];
};

export type HistoryEntryFilterParameter = {
  _and?: InputMaybe<Array<HistoryEntryFilterParameter>>;
  _or?: InputMaybe<Array<HistoryEntryFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  isPublic?: InputMaybe<BooleanOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type HistoryEntryList = PaginatedList & {
  __typename?: 'HistoryEntryList';
  items: Array<HistoryEntry>;
  totalItems: Scalars['Int']['output'];
};

export type HistoryEntryListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<HistoryEntryFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<HistoryEntrySortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type HistoryEntrySortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum HistoryEntryType {
  CUSTOMER_ADDED_TO_GROUP = 'CUSTOMER_ADDED_TO_GROUP',
  CUSTOMER_ADDRESS_CREATED = 'CUSTOMER_ADDRESS_CREATED',
  CUSTOMER_ADDRESS_DELETED = 'CUSTOMER_ADDRESS_DELETED',
  CUSTOMER_ADDRESS_UPDATED = 'CUSTOMER_ADDRESS_UPDATED',
  CUSTOMER_DETAIL_UPDATED = 'CUSTOMER_DETAIL_UPDATED',
  CUSTOMER_EMAIL_UPDATE_REQUESTED = 'CUSTOMER_EMAIL_UPDATE_REQUESTED',
  CUSTOMER_EMAIL_UPDATE_VERIFIED = 'CUSTOMER_EMAIL_UPDATE_VERIFIED',
  CUSTOMER_NOTE = 'CUSTOMER_NOTE',
  CUSTOMER_PASSWORD_RESET_REQUESTED = 'CUSTOMER_PASSWORD_RESET_REQUESTED',
  CUSTOMER_PASSWORD_RESET_VERIFIED = 'CUSTOMER_PASSWORD_RESET_VERIFIED',
  CUSTOMER_PASSWORD_UPDATED = 'CUSTOMER_PASSWORD_UPDATED',
  CUSTOMER_REGISTERED = 'CUSTOMER_REGISTERED',
  CUSTOMER_REMOVED_FROM_GROUP = 'CUSTOMER_REMOVED_FROM_GROUP',
  CUSTOMER_VERIFIED = 'CUSTOMER_VERIFIED',
  ORDER_CANCELLATION = 'ORDER_CANCELLATION',
  ORDER_COUPON_APPLIED = 'ORDER_COUPON_APPLIED',
  ORDER_COUPON_REMOVED = 'ORDER_COUPON_REMOVED',
  ORDER_CUSTOMER_UPDATED = 'ORDER_CUSTOMER_UPDATED',
  ORDER_FULFILLMENT = 'ORDER_FULFILLMENT',
  ORDER_FULFILLMENT_TRANSITION = 'ORDER_FULFILLMENT_TRANSITION',
  ORDER_MODIFIED = 'ORDER_MODIFIED',
  ORDER_NOTE = 'ORDER_NOTE',
  ORDER_PAYMENT_TRANSITION = 'ORDER_PAYMENT_TRANSITION',
  ORDER_REFUND_TRANSITION = 'ORDER_REFUND_TRANSITION',
  ORDER_STATE_TRANSITION = 'ORDER_STATE_TRANSITION'
}

/** Operators for filtering on a list of ID fields */
export type IdListOperators = {
  inList: Scalars['ID']['input'];
};

/** Operators for filtering on an ID field */
export type IdOperators = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ImportInfo = {
  __typename?: 'ImportInfo';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  imported: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
};

/** Returned when attempting to set a ShippingMethod for which the Order is not eligible */
export type IneligibleShippingMethodError = ErrorResult & {
  __typename?: 'IneligibleShippingMethodError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned when attempting to add more items to the Order than are available */
export type InsufficientStockError = ErrorResult & {
  __typename?: 'InsufficientStockError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  order: Order;
  quantityAvailable: Scalars['Int']['output'];
};

/**
 * Returned if attempting to create a Fulfillment when there is insufficient
 * stockOnHand of a ProductVariant to satisfy the requested quantity.
 */
export type InsufficientStockOnHandError = ErrorResult & {
  __typename?: 'InsufficientStockOnHandError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  productVariantId: Scalars['ID']['output'];
  productVariantName: Scalars['String']['output'];
  stockOnHand: Scalars['Int']['output'];
};

export type IntCustomFieldConfig = CustomField & {
  __typename?: 'IntCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  step?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type IntStructFieldConfig = StructField & {
  __typename?: 'IntStructFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  step?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

/** Returned if the user authentication credentials are not valid */
export type InvalidCredentialsError = ErrorResult & {
  __typename?: 'InvalidCredentialsError';
  authenticationError: Scalars['String']['output'];
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned if the specified FulfillmentHandler code is not valid */
export type InvalidFulfillmentHandlerError = ErrorResult & {
  __typename?: 'InvalidFulfillmentHandlerError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned if the specified items are already part of a Fulfillment */
export type ItemsAlreadyFulfilledError = ErrorResult & {
  __typename?: 'ItemsAlreadyFulfilledError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type Job = Node & {
  __typename?: 'Job';
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  duration: Scalars['Int']['output'];
  error?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isSettled: Scalars['Boolean']['output'];
  progress: Scalars['Float']['output'];
  queueName: Scalars['String']['output'];
  result?: Maybe<Scalars['JSON']['output']>;
  retries: Scalars['Int']['output'];
  settledAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  state: JobState;
};

export type JobBufferSize = {
  __typename?: 'JobBufferSize';
  bufferId: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export type JobFilterParameter = {
  _and?: InputMaybe<Array<JobFilterParameter>>;
  _or?: InputMaybe<Array<JobFilterParameter>>;
  attempts?: InputMaybe<NumberOperators>;
  createdAt?: InputMaybe<DateOperators>;
  duration?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  isSettled?: InputMaybe<BooleanOperators>;
  progress?: InputMaybe<NumberOperators>;
  queueName?: InputMaybe<StringOperators>;
  retries?: InputMaybe<NumberOperators>;
  settledAt?: InputMaybe<DateOperators>;
  startedAt?: InputMaybe<DateOperators>;
  state?: InputMaybe<StringOperators>;
};

export type JobList = PaginatedList & {
  __typename?: 'JobList';
  items: Array<Job>;
  totalItems: Scalars['Int']['output'];
};

export type JobListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<JobFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<JobSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type JobQueue = {
  __typename?: 'JobQueue';
  name: Scalars['String']['output'];
  running: Scalars['Boolean']['output'];
};

export type JobSortParameter = {
  attempts?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  progress?: InputMaybe<SortOrder>;
  queueName?: InputMaybe<SortOrder>;
  retries?: InputMaybe<SortOrder>;
  settledAt?: InputMaybe<SortOrder>;
  startedAt?: InputMaybe<SortOrder>;
};

/**
 * @description
 * The state of a Job in the JobQueue
 *
 * @docsCategory common
 */
export enum JobState {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  RETRYING = 'RETRYING',
  RUNNING = 'RUNNING'
}

/**
 * @description
 * Languages in the form of a ISO 639-1 language code with optional
 * region or script modifier (e.g. de_AT). The selection available is based
 * on the [Unicode CLDR summary list](https://unicode-org.github.io/cldr-staging/charts/37/summary/root.html)
 * and includes the major spoken languages of the world and any widely-used variants.
 *
 * @docsCategory common
 */
export enum LanguageCode {
  /** Afrikaans */
  af = 'af',
  /** Akan */
  ak = 'ak',
  /** Amharic */
  am = 'am',
  /** Arabic */
  ar = 'ar',
  /** Assamese */
  as = 'as',
  /** Azerbaijani */
  az = 'az',
  /** Belarusian */
  be = 'be',
  /** Bulgarian */
  bg = 'bg',
  /** Bambara */
  bm = 'bm',
  /** Bangla */
  bn = 'bn',
  /** Tibetan */
  bo = 'bo',
  /** Breton */
  br = 'br',
  /** Bosnian */
  bs = 'bs',
  /** Catalan */
  ca = 'ca',
  /** Chechen */
  ce = 'ce',
  /** Corsican */
  co = 'co',
  /** Czech */
  cs = 'cs',
  /** Church Slavic */
  cu = 'cu',
  /** Welsh */
  cy = 'cy',
  /** Danish */
  da = 'da',
  /** German */
  de = 'de',
  /** Austrian German */
  de_AT = 'de_AT',
  /** Swiss High German */
  de_CH = 'de_CH',
  /** Dzongkha */
  dz = 'dz',
  /** Ewe */
  ee = 'ee',
  /** Greek */
  el = 'el',
  /** English */
  en = 'en',
  /** Australian English */
  en_AU = 'en_AU',
  /** Canadian English */
  en_CA = 'en_CA',
  /** British English */
  en_GB = 'en_GB',
  /** American English */
  en_US = 'en_US',
  /** Esperanto */
  eo = 'eo',
  /** Spanish */
  es = 'es',
  /** European Spanish */
  es_ES = 'es_ES',
  /** Mexican Spanish */
  es_MX = 'es_MX',
  /** Estonian */
  et = 'et',
  /** Basque */
  eu = 'eu',
  /** Persian */
  fa = 'fa',
  /** Dari */
  fa_AF = 'fa_AF',
  /** Fulah */
  ff = 'ff',
  /** Finnish */
  fi = 'fi',
  /** Faroese */
  fo = 'fo',
  /** French */
  fr = 'fr',
  /** Canadian French */
  fr_CA = 'fr_CA',
  /** Swiss French */
  fr_CH = 'fr_CH',
  /** Western Frisian */
  fy = 'fy',
  /** Irish */
  ga = 'ga',
  /** Scottish Gaelic */
  gd = 'gd',
  /** Galician */
  gl = 'gl',
  /** Gujarati */
  gu = 'gu',
  /** Manx */
  gv = 'gv',
  /** Hausa */
  ha = 'ha',
  /** Hebrew */
  he = 'he',
  /** Hindi */
  hi = 'hi',
  /** Croatian */
  hr = 'hr',
  /** Haitian Creole */
  ht = 'ht',
  /** Hungarian */
  hu = 'hu',
  /** Armenian */
  hy = 'hy',
  /** Interlingua */
  ia = 'ia',
  /** Indonesian */
  id = 'id',
  /** Igbo */
  ig = 'ig',
  /** Sichuan Yi */
  ii = 'ii',
  /** Icelandic */
  is = 'is',
  /** Italian */
  it = 'it',
  /** Japanese */
  ja = 'ja',
  /** Javanese */
  jv = 'jv',
  /** Georgian */
  ka = 'ka',
  /** Kikuyu */
  ki = 'ki',
  /** Kazakh */
  kk = 'kk',
  /** Kalaallisut */
  kl = 'kl',
  /** Khmer */
  km = 'km',
  /** Kannada */
  kn = 'kn',
  /** Korean */
  ko = 'ko',
  /** Kashmiri */
  ks = 'ks',
  /** Kurdish */
  ku = 'ku',
  /** Cornish */
  kw = 'kw',
  /** Kyrgyz */
  ky = 'ky',
  /** Latin */
  la = 'la',
  /** Luxembourgish */
  lb = 'lb',
  /** Ganda */
  lg = 'lg',
  /** Lingala */
  ln = 'ln',
  /** Lao */
  lo = 'lo',
  /** Lithuanian */
  lt = 'lt',
  /** Luba-Katanga */
  lu = 'lu',
  /** Latvian */
  lv = 'lv',
  /** Malagasy */
  mg = 'mg',
  /** Maori */
  mi = 'mi',
  /** Macedonian */
  mk = 'mk',
  /** Malayalam */
  ml = 'ml',
  /** Mongolian */
  mn = 'mn',
  /** Marathi */
  mr = 'mr',
  /** Malay */
  ms = 'ms',
  /** Maltese */
  mt = 'mt',
  /** Burmese */
  my = 'my',
  /** Norwegian Bokmål */
  nb = 'nb',
  /** North Ndebele */
  nd = 'nd',
  /** Nepali */
  ne = 'ne',
  /** Dutch */
  nl = 'nl',
  /** Flemish */
  nl_BE = 'nl_BE',
  /** Norwegian Nynorsk */
  nn = 'nn',
  /** Nyanja */
  ny = 'ny',
  /** Oromo */
  om = 'om',
  /** Odia */
  or = 'or',
  /** Ossetic */
  os = 'os',
  /** Punjabi */
  pa = 'pa',
  /** Polish */
  pl = 'pl',
  /** Pashto */
  ps = 'ps',
  /** Portuguese */
  pt = 'pt',
  /** Brazilian Portuguese */
  pt_BR = 'pt_BR',
  /** European Portuguese */
  pt_PT = 'pt_PT',
  /** Quechua */
  qu = 'qu',
  /** Romansh */
  rm = 'rm',
  /** Rundi */
  rn = 'rn',
  /** Romanian */
  ro = 'ro',
  /** Moldavian */
  ro_MD = 'ro_MD',
  /** Russian */
  ru = 'ru',
  /** Kinyarwanda */
  rw = 'rw',
  /** Sanskrit */
  sa = 'sa',
  /** Sindhi */
  sd = 'sd',
  /** Northern Sami */
  se = 'se',
  /** Sango */
  sg = 'sg',
  /** Sinhala */
  si = 'si',
  /** Slovak */
  sk = 'sk',
  /** Slovenian */
  sl = 'sl',
  /** Samoan */
  sm = 'sm',
  /** Shona */
  sn = 'sn',
  /** Somali */
  so = 'so',
  /** Albanian */
  sq = 'sq',
  /** Serbian */
  sr = 'sr',
  /** Southern Sotho */
  st = 'st',
  /** Sundanese */
  su = 'su',
  /** Swedish */
  sv = 'sv',
  /** Swahili */
  sw = 'sw',
  /** Congo Swahili */
  sw_CD = 'sw_CD',
  /** Tamil */
  ta = 'ta',
  /** Telugu */
  te = 'te',
  /** Tajik */
  tg = 'tg',
  /** Thai */
  th = 'th',
  /** Tigrinya */
  ti = 'ti',
  /** Turkmen */
  tk = 'tk',
  /** Tongan */
  to = 'to',
  /** Turkish */
  tr = 'tr',
  /** Tatar */
  tt = 'tt',
  /** Uyghur */
  ug = 'ug',
  /** Ukrainian */
  uk = 'uk',
  /** Urdu */
  ur = 'ur',
  /** Uzbek */
  uz = 'uz',
  /** Vietnamese */
  vi = 'vi',
  /** Volapük */
  vo = 'vo',
  /** Wolof */
  wo = 'wo',
  /** Xhosa */
  xh = 'xh',
  /** Yiddish */
  yi = 'yi',
  /** Yoruba */
  yo = 'yo',
  /** Chinese */
  zh = 'zh',
  /** Simplified Chinese */
  zh_Hans = 'zh_Hans',
  /** Traditional Chinese */
  zh_Hant = 'zh_Hant',
  /** Zulu */
  zu = 'zu'
}

/** Returned if attempting to set a Channel's defaultLanguageCode to a language which is not enabled in GlobalSettings */
export type LanguageNotAvailableError = ErrorResult & {
  __typename?: 'LanguageNotAvailableError';
  errorCode: ErrorCode;
  languageCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type LocaleStringCustomFieldConfig = CustomField & {
  __typename?: 'LocaleStringCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  length?: Maybe<Scalars['Int']['output']>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type LocaleTextCustomFieldConfig = CustomField & {
  __typename?: 'LocaleTextCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type LocalizedString = {
  __typename?: 'LocalizedString';
  languageCode: LanguageCode;
  value: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export enum LogicalOperator {
  AND = 'AND',
  OR = 'OR'
}

export type ManualPaymentInput = {
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  method: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Returned when a call to addManualPaymentToOrder is made but the Order
 * is not in the required state.
 */
export type ManualPaymentStateError = ErrorResult & {
  __typename?: 'ManualPaymentStateError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type MetabaseDashboard = {
  __typename?: 'MetabaseDashboard';
  id: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export enum MetricInterval {
  Daily = 'Daily'
}

export type MetricSummary = {
  __typename?: 'MetricSummary';
  entries: Array<MetricSummaryEntry>;
  interval: MetricInterval;
  title: Scalars['String']['output'];
  type: MetricType;
};

export type MetricSummaryEntry = {
  __typename?: 'MetricSummaryEntry';
  label: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type MetricSummaryInput = {
  interval: MetricInterval;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  types: Array<MetricType>;
};

export enum MetricType {
  AverageOrderValue = 'AverageOrderValue',
  OrderCount = 'OrderCount',
  OrderTotal = 'OrderTotal'
}

export type MimeTypeError = ErrorResult & {
  __typename?: 'MimeTypeError';
  errorCode: ErrorCode;
  fileName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

/** Returned if a PromotionCondition has neither a couponCode nor any conditions set */
export type MissingConditionsError = ErrorResult & {
  __typename?: 'MissingConditionsError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type ModifyOrderInput = {
  addItems?: InputMaybe<Array<AddItemInput>>;
  adjustOrderLines?: InputMaybe<Array<OrderLineInput>>;
  couponCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  customFields?: InputMaybe<UpdateOrderCustomFieldsInput>;
  dryRun: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<ModifyOrderOptions>;
  orderId: Scalars['ID']['input'];
  /**
   * Deprecated in v2.2.0. Use `refunds` instead to allow multiple refunds to be
   * applied in the case that multiple payment methods have been used on the order.
   */
  refund?: InputMaybe<AdministratorRefundInput>;
  refunds?: InputMaybe<Array<AdministratorRefundInput>>;
  /** Added in v2.2 */
  shippingMethodIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  surcharges?: InputMaybe<Array<SurchargeInput>>;
  updateBillingAddress?: InputMaybe<UpdateOrderAddressInput>;
  updateShippingAddress?: InputMaybe<UpdateOrderAddressInput>;
};

export type ModifyOrderOptions = {
  freezePromotions?: InputMaybe<Scalars['Boolean']['input']>;
  recalculateShipping?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModifyOrderResult = CouponCodeExpiredError | CouponCodeInvalidError | CouponCodeLimitError | IneligibleShippingMethodError | InsufficientStockError | NegativeQuantityError | NoChangesSpecifiedError | Order | OrderLimitError | OrderModificationStateError | PaymentMethodMissingError | RefundPaymentIdMissingError;

export type MoveCollectionInput = {
  collectionId: Scalars['ID']['input'];
  index: Scalars['Int']['input'];
  parentId: Scalars['ID']['input'];
};

/** Returned if an operation has specified OrderLines from multiple Orders */
export type MultipleOrderError = ErrorResult & {
  __typename?: 'MultipleOrderError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptPromotion?: Maybe<Promotion>;
  /** Add Customers to a CustomerGroup */
  addCustomersToGroup: CustomerGroup;
  addFulfillmentToOrder: AddFulfillmentToOrderResult;
  /** Adds an item to the draft Order. */
  addItemToDraftOrder: UpdateOrderItemsResult;
  /**
   * Used to manually create a new Payment against an Order.
   * This can be used by an Administrator when an Order is in the ArrangingPayment state.
   *
   * It is also used when a completed Order
   * has been modified (using `modifyOrder`) and the price has increased. The extra payment
   * can then be manually arranged by the administrator, and the details used to create a new
   * Payment.
   */
  addManualPaymentToOrder: AddManualPaymentToOrderResult;
  /** Add members to a Zone */
  addMembersToZone: Zone;
  addNoteToCustomer: Customer;
  addNoteToOrder: Order;
  /** Add an OptionGroup to a Product */
  addOptionGroupToProduct: Product;
  /** Adjusts a draft OrderLine. If custom fields are defined on the OrderLine entity, a third argument 'customFields' of type `OrderLineCustomFieldsInput` will be available. */
  adjustDraftOrderLine: UpdateOrderItemsResult;
  /** Applies the given coupon code to the draft Order */
  applyCouponCodeToDraftOrder: ApplyCouponCodeResult;
  approveProductReview?: Maybe<ProductReview>;
  /** Assign assets to channel */
  assignAssetsToChannel: Array<Asset>;
  /** Assigns Collections to the specified Channel */
  assignCollectionsToChannel: Array<Collection>;
  assignFacetToChannelBulk: Scalars['Boolean']['output'];
  /** Assigns Facets to the specified Channel */
  assignFacetsToChannel: Array<Facet>;
  /** Assigns PaymentMethods to the specified Channel */
  assignPaymentMethodsToChannel: Array<PaymentMethod>;
  /** Assigns ProductVariants to the specified Channel */
  assignProductVariantsToChannel: Array<ProductVariant>;
  /** Assigns all ProductVariants of Product to the specified Channel */
  assignProductsToChannel: Array<Product>;
  /** Assigns Promotions to the specified Channel */
  assignPromotionsToChannel: Array<Promotion>;
  /** Assign a Role to an Administrator */
  assignRoleToAdministrator: Administrator;
  /** Assigns ShippingMethods to the specified Channel */
  assignShippingMethodsToChannel: Array<ShippingMethod>;
  /** Assigns StockLocations to the specified Channel */
  assignStockLocationsToChannel: Array<StockLocation>;
  /** Authenticates the user using a named authentication strategy */
  authenticate: AuthenticationResult;
  cancelDoordashDelivery: MessageResponse;
  cancelJob: Job;
  cancelOrder: CancelOrderResult;
  cancelPayment: CancelPaymentResult;
  /** Create a new Administrator */
  createAdministrator: Administrator;
  createAndSendMarketingMessage: MessageResponse;
  /** Create a new Asset */
  createAssets: Array<CreateAssetResult>;
  createBulkTimeSlots: Success;
  createCampaign: Campaign;
  createCar: CarResult;
  /** Create a new Channel */
  createChannel: CreateChannelResult;
  /** Create a new Collection */
  createCollection: Collection;
  /** Create a new Country */
  createCountry: Country;
  /** Create a new Customer. If a password is provided, a new User will also be created an linked to the Customer. */
  createCustomer: CreateCustomerResult;
  /** Create a new Address and associate it with the Customer specified by customerId */
  createCustomerAddress: Address;
  /** Create a new CustomerGroup */
  createCustomerGroup: CustomerGroup;
  createDoordashBusiness: DoordashBusinessResult;
  createDoordashOrder: DoorDashOrder;
  createDoordashStore: MessageResponse;
  /** Creates a draft Order */
  createDraftOrder: Order;
  createDripCampaign: DripCampaign;
  /** Create a new Facet */
  createFacet: Facet;
  /** Create one or more FacetValues */
  createFacetValues: Array<FacetValue>;
  createMarketingTemlate?: Maybe<EmailTemplateResult>;
  createPage: Page;
  /** Create existing PaymentMethod */
  createPaymentMethod: PaymentMethod;
  /** Create a new Product */
  createProduct: Product;
  /** Create a new ProductOption within a ProductOptionGroup */
  createProductOption: ProductOption;
  /** Create a new ProductOptionGroup */
  createProductOptionGroup: ProductOptionGroup;
  /** Create a set of ProductVariants based on the OptionGroups assigned to the given Product */
  createProductVariants: Array<Maybe<ProductVariant>>;
  createPromotion: CreatePromotionResult;
  /** Create a new Province */
  createProvince: Province;
  /** Create a new Role */
  createRole: Role;
  /** Create a new Seller */
  createSeller: Seller;
  /** Create a new ShippingMethod */
  createShippingMethod: ShippingMethod;
  createStockLocation: StockLocation;
  /** Create a new Tag */
  createTag: Tag;
  /** Create a new TaxCategory */
  createTaxCategory: TaxCategory;
  /** Create a new TaxRate */
  createTaxRate: TaxRate;
  createTimeSlot: TimeSlot;
  /** Create a new Zone */
  createZone: Zone;
  /** Delete an Administrator */
  deleteAdministrator: DeletionResponse;
  /** Delete multiple Administrators */
  deleteAdministrators: Array<DeletionResponse>;
  /** Delete an Asset */
  deleteAsset: DeletionResponse;
  /** Delete multiple Assets */
  deleteAssets: DeletionResponse;
  deleteCampaign: Scalars['Boolean']['output'];
  deleteCampaigns: Scalars['Boolean']['output'];
  deleteCareer: Scalars['Boolean']['output'];
  /** Delete a Channel */
  deleteChannel: DeletionResponse;
  /** Delete multiple Channels */
  deleteChannels: Array<DeletionResponse>;
  /** Delete a Collection and all of its descendants */
  deleteCollection: DeletionResponse;
  /** Delete multiple Collections and all of their descendants */
  deleteCollections: Array<DeletionResponse>;
  /** Delete multiple Countries */
  deleteCountries: Array<DeletionResponse>;
  /** Delete a Country */
  deleteCountry: DeletionResponse;
  /** Delete a Customer */
  deleteCustomer: DeletionResponse;
  /** Update an existing Address */
  deleteCustomerAddress: Success;
  /** Delete a CustomerGroup */
  deleteCustomerGroup: DeletionResponse;
  /** Delete multiple CustomerGroups */
  deleteCustomerGroups: Array<DeletionResponse>;
  deleteCustomerNote: DeletionResponse;
  /** Deletes Customers */
  deleteCustomers: Array<DeletionResponse>;
  /** Deletes a draft Order */
  deleteDraftOrder: DeletionResponse;
  deleteDripCampaign: Scalars['Boolean']['output'];
  /** Delete an existing Facet */
  deleteFacet: DeletionResponse;
  /** Delete one or more FacetValues */
  deleteFacetValues: Array<DeletionResponse>;
  /** Delete multiple existing Facets */
  deleteFacets: Array<DeletionResponse>;
  deleteFeedbacks: DeleteFeedbacksResponse;
  deleteMarketingTemplate: MessageResponse;
  deleteOrderNote: DeletionResponse;
  deletePage: DeletionResponse;
  /** Delete a PaymentMethod */
  deletePaymentMethod: DeletionResponse;
  /** Delete multiple PaymentMethods */
  deletePaymentMethods: Array<DeletionResponse>;
  /** Delete a Product */
  deleteProduct: DeletionResponse;
  /** Delete a ProductOption */
  deleteProductOption: DeletionResponse;
  deleteProductReview: DeletionResponse;
  /** Delete a ProductVariant */
  deleteProductVariant: DeletionResponse;
  /** Delete multiple ProductVariants */
  deleteProductVariants: Array<DeletionResponse>;
  /** Delete multiple Products */
  deleteProducts: Array<DeletionResponse>;
  deletePromotion: DeletionResponse;
  deletePromotions: Array<DeletionResponse>;
  /** Delete a Province */
  deleteProvince: DeletionResponse;
  /** Delete an existing Role */
  deleteRole: DeletionResponse;
  /** Delete multiple Roles */
  deleteRoles: Array<DeletionResponse>;
  /** Delete a Seller */
  deleteSeller: DeletionResponse;
  /** Delete multiple Sellers */
  deleteSellers: Array<DeletionResponse>;
  /** Delete a ShippingMethod */
  deleteShippingMethod: DeletionResponse;
  /** Delete multiple ShippingMethods */
  deleteShippingMethods: Array<DeletionResponse>;
  deleteStockLocation: DeletionResponse;
  deleteStockLocations: Array<DeletionResponse>;
  /** Delete an existing Tag */
  deleteTag: DeletionResponse;
  /** Deletes multiple TaxCategories */
  deleteTaxCategories: Array<DeletionResponse>;
  /** Deletes a TaxCategory */
  deleteTaxCategory: DeletionResponse;
  /** Delete a TaxRate */
  deleteTaxRate: DeletionResponse;
  /** Delete multiple TaxRates */
  deleteTaxRates: Array<DeletionResponse>;
  deleteTimeSlots: DeletionResponse;
  deleteUserSessions: Scalars['Boolean']['output'];
  /** Delete a Zone */
  deleteZone: DeletionResponse;
  /** Delete a Zone */
  deleteZones: Array<DeletionResponse>;
  /**
   * Duplicate an existing entity using a specific EntityDuplicator.
   * Since v2.2.0.
   */
  duplicateEntity: DuplicateEntityResult;
  duplicateMarketingTemplate?: Maybe<EmailTemplateResult>;
  flushBufferedJobs: Success;
  importProducts?: Maybe<ImportInfo>;
  /**
   * Authenticates the user using the native authentication strategy. This mutation is an alias for authenticate({ native: { ... }})
   *
   * The `rememberMe` option applies when using cookie-based sessions, and if `true` it will set the maxAge of the session cookie
   * to 1 year.
   */
  login: NativeAuthenticationResult;
  logout: Success;
  /**
   * Allows an Order to be modified after it has been completed by the Customer. The Order must first
   * be in the `Modifying` state.
   */
  modifyOrder: ModifyOrderResult;
  /** Move a Collection to a different parent or index */
  moveCollection: Collection;
  refundOrder: RefundOrderResult;
  refundPayment?: Maybe<Scalars['Boolean']['output']>;
  reindex: Job;
  rejectProductReview?: Maybe<ProductReview>;
  rejectPromotion?: Maybe<Promotion>;
  /** Removes Collections from the specified Channel */
  removeCollectionsFromChannel: Array<Collection>;
  /** Removes the given coupon code from the draft Order */
  removeCouponCodeFromDraftOrder?: Maybe<Order>;
  /** Remove Customers from a CustomerGroup */
  removeCustomersFromGroup: CustomerGroup;
  /** Remove an OrderLine from the draft Order */
  removeDraftOrderLine: RemoveOrderItemsResult;
  /** Removes Facets from the specified Channel */
  removeFacetsFromChannel: Array<RemoveFacetFromChannelResult>;
  /** Remove members from a Zone */
  removeMembersFromZone: Zone;
  /**
   * Remove an OptionGroup from a Product. If the OptionGroup is in use by any ProductVariants
   * the mutation will return a ProductOptionInUseError, and the OptionGroup will not be removed.
   * Setting the `force` argument to `true` will override this and remove the OptionGroup anyway,
   * as well as removing any of the group's options from the Product's ProductVariants.
   */
  removeOptionGroupFromProduct: RemoveOptionGroupFromProductResult;
  /** Removes PaymentMethods from the specified Channel */
  removePaymentMethodsFromChannel: Array<PaymentMethod>;
  /** Removes ProductVariants from the specified Channel */
  removeProductVariantsFromChannel: Array<ProductVariant>;
  /** Removes all ProductVariants of Product from the specified Channel */
  removeProductsFromChannel: Array<Product>;
  /** Removes Promotions from the specified Channel */
  removePromotionsFromChannel: Array<Promotion>;
  /** Remove all settled jobs in the given queues older than the given date. Returns the number of jobs deleted. */
  removeSettledJobs: Scalars['Int']['output'];
  /** Removes ShippingMethods from the specified Channel */
  removeShippingMethodsFromChannel: Array<ShippingMethod>;
  /** Removes StockLocations from the specified Channel */
  removeStockLocationsFromChannel: Array<StockLocation>;
  runPendingSearchIndexUpdates: Success;
  runScheduledTask: Success;
  scheduleHolidayOrder?: Maybe<RetryPosiResponse>;
  sendFeedbackResponse: Feedback;
  sendFeedbackRewardToCustomer: Feedback;
  sendGroupOrIndividualMarketingMessage: MessageResponse;
  sendMessageToAllCustomer: MessageResponse;
  sendMessageToCustomerGroup: MessageResponse;
  sendPromoNotification?: Maybe<PromoNotificationResponse>;
  sendPushNotification: MessageResponse;
  setCustomerForDraftOrder: SetCustomerForDraftOrderResult;
  /** Sets the billing address for a draft Order */
  setDraftOrderBillingAddress: Order;
  /** Allows any custom fields to be set for the active order */
  setDraftOrderCustomFields: Order;
  /** Sets the shipping address for a draft Order */
  setDraftOrderShippingAddress: Order;
  /** Sets the shipping method by id, which can be obtained with the `eligibleShippingMethodsForDraftOrder` query */
  setDraftOrderShippingMethod: SetOrderShippingMethodResult;
  setOrderCustomFields?: Maybe<Order>;
  /** Allows a different Customer to be assigned to an Order. Added in v2.2.0. */
  setOrderCustomer?: Maybe<Order>;
  setOrderLineIsAdded: OrderLine;
  settlePayment: SettlePaymentResult;
  settleRefund: SettleRefundResult;
  transitionFulfillmentToState: TransitionFulfillmentToStateResult;
  transitionOrderToState?: Maybe<TransitionOrderToStateResult>;
  transitionPaymentToState: TransitionPaymentToStateResult;
  /** Unsets the billing address for a draft Order */
  unsetDraftOrderBillingAddress: Order;
  /** Unsets the shipping address for a draft Order */
  unsetDraftOrderShippingAddress: Order;
  /** Update the active (currently logged-in) Administrator */
  updateActiveAdministrator: Administrator;
  /** Update an existing Administrator */
  updateAdministrator: Administrator;
  /** Update an existing Asset */
  updateAsset: Asset;
  updateCampaign: Campaign;
  /** Update an existing Channel */
  updateChannel: UpdateChannelResult;
  /** Update an existing Collection */
  updateCollection: Collection;
  /** Update an existing Country */
  updateCountry: Country;
  updateCurbsidePickupDetails: CurbsidePickupResult;
  /** Update an existing Customer */
  updateCustomer: UpdateCustomerResult;
  /** Update an existing Address */
  updateCustomerAddress: Address;
  /** Update an existing CustomerGroup */
  updateCustomerGroup: CustomerGroup;
  updateCustomerNote: HistoryEntry;
  updateDripCampaign: DripCampaign;
  /** Update an existing Facet */
  updateFacet: Facet;
  /** Update one or more FacetValues */
  updateFacetValues: Array<FacetValue>;
  updateFeedback: Feedback;
  updateGlobalSettings: UpdateGlobalSettingsResult;
  updateLocation?: Maybe<Channel>;
  updateMarketingTemlate?: Maybe<MessageResponse>;
  updateOrderNote: HistoryEntry;
  updatePage: Page;
  /** Update an existing PaymentMethod */
  updatePaymentMethod: PaymentMethod;
  /** Update an existing Product */
  updateProduct: Product;
  /** Create a new ProductOption within a ProductOptionGroup */
  updateProductOption: ProductOption;
  /** Update an existing ProductOptionGroup */
  updateProductOptionGroup: ProductOptionGroup;
  updateProductReview: ProductReview;
  /** Update an existing ProductVariant */
  updateProductVariant: ProductVariant;
  /** Update existing ProductVariants */
  updateProductVariants: Array<Maybe<ProductVariant>>;
  /** Update multiple existing Products */
  updateProducts: Array<Product>;
  updatePromotion: UpdatePromotionResult;
  /** Update an existing Province */
  updateProvince: Province;
  /** Update an existing Role */
  updateRole: Role;
  updateScheduledTask: ScheduledTask;
  /** Update an existing Seller */
  updateSeller: Seller;
  /** Update an existing ShippingMethod */
  updateShippingMethod: ShippingMethod;
  updateStockLocation: StockLocation;
  /** Update an existing Tag */
  updateTag: Tag;
  /** Update an existing TaxCategory */
  updateTaxCategory: TaxCategory;
  /** Update an existing TaxRate */
  updateTaxRate: TaxRate;
  updateTimeSlot: TimeSlot;
  updateVariantStoreVisibility?: Maybe<ProductVariant>;
  /** Update an existing Zone */
  updateZone: Zone;
  voidPayment?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAcceptPromotionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddCustomersToGroupArgs = {
  customerGroupId: Scalars['ID']['input'];
  customerIds: Array<Scalars['ID']['input']>;
};


export type MutationAddFulfillmentToOrderArgs = {
  input: FulfillOrderInput;
};


export type MutationAddItemToDraftOrderArgs = {
  input: AddItemToDraftOrderInput;
  orderId: Scalars['ID']['input'];
};


export type MutationAddManualPaymentToOrderArgs = {
  input: ManualPaymentInput;
};


export type MutationAddMembersToZoneArgs = {
  memberIds: Array<Scalars['ID']['input']>;
  zoneId: Scalars['ID']['input'];
};


export type MutationAddNoteToCustomerArgs = {
  input: AddNoteToCustomerInput;
};


export type MutationAddNoteToOrderArgs = {
  input: AddNoteToOrderInput;
};


export type MutationAddOptionGroupToProductArgs = {
  optionGroupId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationAdjustDraftOrderLineArgs = {
  input: AdjustDraftOrderLineInput;
  orderId: Scalars['ID']['input'];
};


export type MutationApplyCouponCodeToDraftOrderArgs = {
  couponCode: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationApproveProductReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAssignAssetsToChannelArgs = {
  input: AssignAssetsToChannelInput;
};


export type MutationAssignCollectionsToChannelArgs = {
  input: AssignCollectionsToChannelInput;
};


export type MutationAssignFacetsToChannelArgs = {
  input: AssignFacetsToChannelInput;
};


export type MutationAssignPaymentMethodsToChannelArgs = {
  input: AssignPaymentMethodsToChannelInput;
};


export type MutationAssignProductVariantsToChannelArgs = {
  input: AssignProductVariantsToChannelInput;
};


export type MutationAssignProductsToChannelArgs = {
  input: AssignProductsToChannelInput;
};


export type MutationAssignPromotionsToChannelArgs = {
  input: AssignPromotionsToChannelInput;
};


export type MutationAssignRoleToAdministratorArgs = {
  administratorId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};


export type MutationAssignShippingMethodsToChannelArgs = {
  input: AssignShippingMethodsToChannelInput;
};


export type MutationAssignStockLocationsToChannelArgs = {
  input: AssignStockLocationsToChannelInput;
};


export type MutationAuthenticateArgs = {
  input: AuthenticationInput;
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCancelDoordashDeliveryArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationCancelJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationCancelOrderArgs = {
  input: CancelOrderInput;
};


export type MutationCancelPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateAdministratorArgs = {
  input: CreateAdministratorInput;
};


export type MutationCreateAndSendMarketingMessageArgs = {
  input: CreateAndSendMarketingEmail;
};


export type MutationCreateAssetsArgs = {
  input: Array<CreateAssetInput>;
};


export type MutationCreateBulkTimeSlotsArgs = {
  input: CreateBulkTimeSlotsInput;
};


export type MutationCreateCampaignArgs = {
  input: CampaignConfigInput;
};


export type MutationCreateCarArgs = {
  input: CreateCarInput;
};


export type MutationCreateChannelArgs = {
  input: CreateChannelInput;
};


export type MutationCreateCollectionArgs = {
  input: CreateCollectionInput;
};


export type MutationCreateCountryArgs = {
  input: CreateCountryInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCustomerAddressArgs = {
  customerId: Scalars['ID']['input'];
  input: CreateAddressInput;
};


export type MutationCreateCustomerGroupArgs = {
  input: CreateCustomerGroupInput;
};


export type MutationCreateDoordashBusinessArgs = {
  input: CreateDoordashBusinessInput;
};


export type MutationCreateDoordashOrderArgs = {
  input: CreateDoorDashOrderInput;
};


export type MutationCreateDoordashStoreArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateDripCampaignArgs = {
  input: CreateDripCampaignInput;
};


export type MutationCreateFacetArgs = {
  input: CreateFacetInput;
};


export type MutationCreateFacetValuesArgs = {
  input: Array<CreateFacetValueInput>;
};


export type MutationCreateMarketingTemlateArgs = {
  input: CreateEmailTemplateInput;
};


export type MutationCreatePageArgs = {
  input: CreatePageInput;
};


export type MutationCreatePaymentMethodArgs = {
  input: CreatePaymentMethodInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateProductOptionArgs = {
  input: CreateProductOptionInput;
};


export type MutationCreateProductOptionGroupArgs = {
  input: CreateProductOptionGroupInput;
};


export type MutationCreateProductVariantsArgs = {
  input: Array<CreateProductVariantInput>;
};


export type MutationCreatePromotionArgs = {
  input: CreatePromotionInput;
};


export type MutationCreateProvinceArgs = {
  input: CreateProvinceInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateSellerArgs = {
  input: CreateSellerInput;
};


export type MutationCreateShippingMethodArgs = {
  input: CreateShippingMethodInput;
};


export type MutationCreateStockLocationArgs = {
  input: CreateStockLocationInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateTaxCategoryArgs = {
  input: CreateTaxCategoryInput;
};


export type MutationCreateTaxRateArgs = {
  input: CreateTaxRateInput;
};


export type MutationCreateTimeSlotArgs = {
  input: CreateTimeSlotInput;
};


export type MutationCreateZoneArgs = {
  input: CreateZoneInput;
};


export type MutationDeleteAdministratorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAdministratorsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteAssetArgs = {
  input: DeleteAssetInput;
};


export type MutationDeleteAssetsArgs = {
  input: DeleteAssetsInput;
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCampaignsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCareerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChannelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChannelsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCollectionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCountriesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCountryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomerAddressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomerGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomerGroupsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCustomerNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteDraftOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationDeleteDripCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFacetArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteFacetValuesArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteFacetsArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteFeedbacksArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteMarketingTemplateArgs = {
  name: Scalars['String']['input'];
};


export type MutationDeleteOrderNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePaymentMethodArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeletePaymentMethodsArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductOptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductVariantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductVariantsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteProductsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeletePromotionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePromotionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteProvinceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRolesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteSellerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSellersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteShippingMethodArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShippingMethodsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteStockLocationArgs = {
  input: DeleteStockLocationInput;
};


export type MutationDeleteStockLocationsArgs = {
  input: Array<DeleteStockLocationInput>;
};


export type MutationDeleteTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaxCategoriesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTaxCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaxRateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaxRatesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTimeSlotsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteZoneArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteZonesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDuplicateEntityArgs = {
  input: DuplicateEntityInput;
};


export type MutationDuplicateMarketingTemplateArgs = {
  emailId: Scalars['Int']['input'];
};


export type MutationFlushBufferedJobsArgs = {
  bufferIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationImportProductsArgs = {
  csvFile: Scalars['Upload']['input'];
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
  username: Scalars['String']['input'];
};


export type MutationModifyOrderArgs = {
  input: ModifyOrderInput;
};


export type MutationMoveCollectionArgs = {
  input: MoveCollectionInput;
};


export type MutationRefundOrderArgs = {
  input: RefundOrderInput;
};


export type MutationRefundPaymentArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationRejectProductReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRejectPromotionArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRemoveCollectionsFromChannelArgs = {
  input: RemoveCollectionsFromChannelInput;
};


export type MutationRemoveCouponCodeFromDraftOrderArgs = {
  couponCode: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationRemoveCustomersFromGroupArgs = {
  customerGroupId: Scalars['ID']['input'];
  customerIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveDraftOrderLineArgs = {
  orderId: Scalars['ID']['input'];
  orderLineId: Scalars['ID']['input'];
};


export type MutationRemoveFacetsFromChannelArgs = {
  input: RemoveFacetsFromChannelInput;
};


export type MutationRemoveMembersFromZoneArgs = {
  memberIds: Array<Scalars['ID']['input']>;
  zoneId: Scalars['ID']['input'];
};


export type MutationRemoveOptionGroupFromProductArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  optionGroupId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationRemovePaymentMethodsFromChannelArgs = {
  input: RemovePaymentMethodsFromChannelInput;
};


export type MutationRemoveProductVariantsFromChannelArgs = {
  input: RemoveProductVariantsFromChannelInput;
};


export type MutationRemoveProductsFromChannelArgs = {
  input: RemoveProductsFromChannelInput;
};


export type MutationRemovePromotionsFromChannelArgs = {
  input: RemovePromotionsFromChannelInput;
};


export type MutationRemoveSettledJobsArgs = {
  olderThan?: InputMaybe<Scalars['DateTime']['input']>;
  queueNames?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationRemoveShippingMethodsFromChannelArgs = {
  input: RemoveShippingMethodsFromChannelInput;
};


export type MutationRemoveStockLocationsFromChannelArgs = {
  input: RemoveStockLocationsFromChannelInput;
};


export type MutationRunScheduledTaskArgs = {
  id: Scalars['String']['input'];
};


export type MutationScheduleHolidayOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendFeedbackResponseArgs = {
  input: FeedbackAdminSendResponseInput;
};


export type MutationSendFeedbackRewardToCustomerArgs = {
  input: SendFeedbackRewardToCustomerInput;
};


export type MutationSendGroupOrIndividualMarketingMessageArgs = {
  input: CreateIndividualMessageInput;
};


export type MutationSendMessageToAllCustomerArgs = {
  input?: InputMaybe<SendAllCustomerMessageInput>;
};


export type MutationSendMessageToCustomerGroupArgs = {
  input?: InputMaybe<CreateMessageInput>;
};


export type MutationSendPromoNotificationArgs = {
  input: PromoNotificationInput;
};


export type MutationSendPushNotificationArgs = {
  input?: InputMaybe<CreateNotificationInput>;
};


export type MutationSetCustomerForDraftOrderArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<CreateCustomerInput>;
  orderId: Scalars['ID']['input'];
};


export type MutationSetDraftOrderBillingAddressArgs = {
  input: CreateAddressInput;
  orderId: Scalars['ID']['input'];
};


export type MutationSetDraftOrderCustomFieldsArgs = {
  input: UpdateOrderInput;
  orderId: Scalars['ID']['input'];
};


export type MutationSetDraftOrderShippingAddressArgs = {
  input: CreateAddressInput;
  orderId: Scalars['ID']['input'];
};


export type MutationSetDraftOrderShippingMethodArgs = {
  orderId: Scalars['ID']['input'];
  shippingMethodId: Scalars['ID']['input'];
};


export type MutationSetOrderCustomFieldsArgs = {
  input: UpdateOrderInput;
};


export type MutationSetOrderCustomerArgs = {
  input: SetOrderCustomerInput;
};


export type MutationSetOrderLineIsAddedArgs = {
  isAdded: Scalars['Boolean']['input'];
  orderLineId: Scalars['ID']['input'];
};


export type MutationSettlePaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSettleRefundArgs = {
  input: SettleRefundInput;
};


export type MutationTransitionFulfillmentToStateArgs = {
  id: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};


export type MutationTransitionOrderToStateArgs = {
  id: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};


export type MutationTransitionPaymentToStateArgs = {
  id: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};


export type MutationUnsetDraftOrderBillingAddressArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationUnsetDraftOrderShippingAddressArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationUpdateActiveAdministratorArgs = {
  input: UpdateActiveAdministratorInput;
};


export type MutationUpdateAdministratorArgs = {
  input: UpdateAdministratorInput;
};


export type MutationUpdateAssetArgs = {
  input: UpdateAssetInput;
};


export type MutationUpdateCampaignArgs = {
  id: Scalars['ID']['input'];
  input: CampaignConfigInput;
};


export type MutationUpdateChannelArgs = {
  input: UpdateChannelInput;
};


export type MutationUpdateCollectionArgs = {
  input: UpdateCollectionInput;
};


export type MutationUpdateCountryArgs = {
  input: UpdateCountryInput;
};


export type MutationUpdateCurbsidePickupDetailsArgs = {
  input: UpdateCurbsidePickupInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateCustomerAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateCustomerGroupArgs = {
  input: UpdateCustomerGroupInput;
};


export type MutationUpdateCustomerNoteArgs = {
  input: UpdateCustomerNoteInput;
};


export type MutationUpdateDripCampaignArgs = {
  input: UpdateDripCampaignInput;
};


export type MutationUpdateFacetArgs = {
  input: UpdateFacetInput;
};


export type MutationUpdateFacetValuesArgs = {
  input: Array<UpdateFacetValueInput>;
};


export type MutationUpdateFeedbackArgs = {
  input: FeedbackAdminUpdateInput;
};


export type MutationUpdateGlobalSettingsArgs = {
  input: UpdateGlobalSettingsInput;
};


export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput;
};


export type MutationUpdateMarketingTemlateArgs = {
  input: UpdateEmailTemplateInput;
};


export type MutationUpdateOrderNoteArgs = {
  input: UpdateOrderNoteInput;
};


export type MutationUpdatePageArgs = {
  input: UpdatePageInput;
};


export type MutationUpdatePaymentMethodArgs = {
  input: UpdatePaymentMethodInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationUpdateProductOptionArgs = {
  input: UpdateProductOptionInput;
};


export type MutationUpdateProductOptionGroupArgs = {
  input: UpdateProductOptionGroupInput;
};


export type MutationUpdateProductReviewArgs = {
  input: UpdateProductReviewInput;
};


export type MutationUpdateProductVariantArgs = {
  input: UpdateProductVariantInput;
};


export type MutationUpdateProductVariantsArgs = {
  input: Array<UpdateProductVariantInput>;
};


export type MutationUpdateProductsArgs = {
  input: Array<UpdateProductInput>;
};


export type MutationUpdatePromotionArgs = {
  input: UpdatePromotionInput;
};


export type MutationUpdateProvinceArgs = {
  input: UpdateProvinceInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateScheduledTaskArgs = {
  input: UpdateScheduledTaskInput;
};


export type MutationUpdateSellerArgs = {
  input: UpdateSellerInput;
};


export type MutationUpdateShippingMethodArgs = {
  input: UpdateShippingMethodInput;
};


export type MutationUpdateStockLocationArgs = {
  input: UpdateStockLocationInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationUpdateTaxCategoryArgs = {
  input: UpdateTaxCategoryInput;
};


export type MutationUpdateTaxRateArgs = {
  input: UpdateTaxRateInput;
};


export type MutationUpdateTimeSlotArgs = {
  input: UpdateTimeSlotInput;
};


export type MutationUpdateVariantStoreVisibilityArgs = {
  productVariantId: Scalars['ID']['input'];
  visibility: Scalars['Boolean']['input'];
};


export type MutationUpdateZoneArgs = {
  input: UpdateZoneInput;
};


export type MutationVoidPaymentArgs = {
  orderId: Scalars['ID']['input'];
};

export type NativeAuthInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Returned when attempting an operation that relies on the NativeAuthStrategy, if that strategy is not configured. */
export type NativeAuthStrategyError = ErrorResult & {
  __typename?: 'NativeAuthStrategyError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type NativeAuthenticationResult = CurrentUser | InvalidCredentialsError | NativeAuthStrategyError;

/** Returned when attempting to set a negative OrderLine quantity. */
export type NegativeQuantityError = ErrorResult & {
  __typename?: 'NegativeQuantityError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/**
 * Returned when invoking a mutation which depends on there being an active Order on the
 * current session.
 */
export type NoActiveOrderError = ErrorResult & {
  __typename?: 'NoActiveOrderError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned when a call to modifyOrder fails to specify any changes */
export type NoChangesSpecifiedError = ErrorResult & {
  __typename?: 'NoChangesSpecifiedError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

/** Returned if an attempting to refund an Order but neither items nor shipping refund was specified */
export type NothingToRefundError = ErrorResult & {
  __typename?: 'NothingToRefundError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Operators for filtering on a list of Number fields */
export type NumberListOperators = {
  inList: Scalars['Float']['input'];
};

/** Operators for filtering on a Int or Float field */
export type NumberOperators = {
  between?: InputMaybe<NumberRange>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export type NumberRange = {
  end: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
};

export type Order = Node & {
  __typename?: 'Order';
  /** An order is active as long as the payment process has not been completed */
  active: Scalars['Boolean']['output'];
  aggregateOrder?: Maybe<Order>;
  aggregateOrderId?: Maybe<Scalars['ID']['output']>;
  billingAddress?: Maybe<OrderAddress>;
  channels: Array<Channel>;
  /** A unique code for the Order */
  code: Scalars['String']['output'];
  /** An array of all coupon codes applied to the Order */
  couponCodes: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currencyCode: CurrencyCode;
  customFields?: Maybe<OrderCustomFields>;
  customer?: Maybe<Customer>;
  discounts: Array<Discount>;
  doordashDeliveryId?: Maybe<Scalars['String']['output']>;
  fulfillments?: Maybe<Array<Fulfillment>>;
  history: HistoryEntryList;
  id: Scalars['ID']['output'];
  lines: Array<OrderLine>;
  modifications: Array<OrderModification>;
  nextStates: Array<Scalars['String']['output']>;
  /**
   * The date & time that the Order was placed, i.e. the Customer
   * completed the checkout and the Order is no longer "active"
   */
  orderPlacedAt?: Maybe<Scalars['DateTime']['output']>;
  payments?: Maybe<Array<Payment>>;
  /** Promotions applied to the order. Only gets populated after the payment process has completed. */
  promotions: Array<Promotion>;
  sellerOrders?: Maybe<Array<Order>>;
  shipping: Scalars['Money']['output'];
  shippingAddress?: Maybe<OrderAddress>;
  shippingLines: Array<ShippingLine>;
  shippingWithTax: Scalars['Money']['output'];
  state: Scalars['String']['output'];
  /**
   * The subTotal is the total of all OrderLines in the Order. This figure also includes any Order-level
   * discounts which have been prorated (proportionally distributed) amongst the items of each OrderLine.
   * To get a total of all OrderLines which does not account for prorated discounts, use the
   * sum of `OrderLine.discountedLinePrice` values.
   */
  subTotal: Scalars['Money']['output'];
  /** Same as subTotal, but inclusive of tax */
  subTotalWithTax: Scalars['Money']['output'];
  /**
   * Surcharges are arbitrary modifications to the Order total which are neither
   * ProductVariants nor discounts resulting from applied Promotions. For example,
   * one-off discounts based on customer interaction, or surcharges based on payment
   * methods.
   */
  surcharges: Array<Surcharge>;
  /** A summary of the taxes being applied to this Order */
  taxSummary: Array<OrderTaxSummary>;
  /** Equal to subTotal plus shipping */
  total: Scalars['Money']['output'];
  totalQuantity: Scalars['Int']['output'];
  /** The final payable amount. Equal to subTotalWithTax plus shippingWithTax */
  totalWithTax: Scalars['Money']['output'];
  type: OrderType;
  updatedAt: Scalars['DateTime']['output'];
};


export type OrderHistoryArgs = {
  options?: InputMaybe<HistoryEntryListOptions>;
};

export type OrderAddress = {
  __typename?: 'OrderAddress';
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<AddressCustomFields>;
  fullName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  streetLine1?: Maybe<Scalars['String']['output']>;
  streetLine2?: Maybe<Scalars['String']['output']>;
};

export type OrderAnalyticsSummaryInput = {
  channelID?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['DateTime']['input'];
  interval: MetricInterval;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  productVariantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['DateTime']['input'];
  types: Array<MetricType>;
};

export type OrderCustomFields = {
  __typename?: 'OrderCustomFields';
  alreadyHere?: Maybe<Scalars['Boolean']['output']>;
  appVersion?: Maybe<Scalars['String']['output']>;
  asapOrder?: Maybe<Scalars['Boolean']['output']>;
  carDetails?: Maybe<CarDetails>;
  cloverOrderId?: Maybe<Scalars['String']['output']>;
  customerLoyaltyAchieved?: Maybe<Scalars['Int']['output']>;
  deliveryRiderDasherId?: Maybe<Scalars['String']['output']>;
  deliveryRiderName?: Maybe<Scalars['String']['output']>;
  deliveryRiderNumber?: Maybe<Scalars['String']['output']>;
  deliveryRiderVehicle?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  externalDoordashOrderCustomerFirstName?: Maybe<Scalars['String']['output']>;
  externalDoordashOrderCustomerLastName?: Maybe<Scalars['String']['output']>;
  externalDoordashOrderEntityId?: Maybe<Scalars['String']['output']>;
  freeItemVariantAddons?: Maybe<Scalars['String']['output']>;
  freePromoVariantAddons?: Maybe<Scalars['String']['output']>;
  freePromoVariantId?: Maybe<Scalars['String']['output']>;
  futureOrderTime?: Maybe<Scalars['DateTime']['output']>;
  futureOrderTimeZone?: Maybe<Scalars['String']['output']>;
  holidayName?: Maybe<Scalars['String']['output']>;
  holidayOrderReminderEmailSent?: Maybe<Scalars['Boolean']['output']>;
  isCloverOrder?: Maybe<Scalars['Boolean']['output']>;
  isExternallyDoordashSynced?: Maybe<Scalars['Boolean']['output']>;
  isHolidayOrder?: Maybe<Scalars['Boolean']['output']>;
  isPOSOrder?: Maybe<Scalars['Boolean']['output']>;
  isUserRemovedOrder?: Maybe<Scalars['Boolean']['output']>;
  isVoided?: Maybe<Scalars['Boolean']['output']>;
  loyaltyMultiplierFactor?: Maybe<Scalars['Float']['output']>;
  loyaltyRedeemed?: Maybe<Scalars['Boolean']['output']>;
  orderClone?: Maybe<Scalars['String']['output']>;
  pickupSpot?: Maybe<Scalars['String']['output']>;
  posCheckNumber?: Maybe<Scalars['String']['output']>;
  posTransactionDate?: Maybe<Scalars['String']['output']>;
  positouch_failure?: Maybe<Scalars['Boolean']['output']>;
  refundInvoice?: Maybe<Scalars['String']['output']>;
  saleInvoice?: Maybe<Scalars['String']['output']>;
  sentToPositouch?: Maybe<Scalars['Boolean']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tips?: Maybe<Scalars['Int']['output']>;
  tipsPercentage?: Maybe<Scalars['Float']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
  typeOfDelivery?: Maybe<Scalars['String']['output']>;
  typeOfFullfillment?: Maybe<Scalars['String']['output']>;
  typeOfPickup?: Maybe<Scalars['String']['output']>;
  uberEatsOrderId?: Maybe<Scalars['String']['output']>;
  usedCardId?: Maybe<Scalars['String']['output']>;
  usedLoyaltyPoints?: Maybe<Scalars['Int']['output']>;
  utensilsRequired?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderFilterParameter = {
  _and?: InputMaybe<Array<OrderFilterParameter>>;
  _or?: InputMaybe<Array<OrderFilterParameter>>;
  active?: InputMaybe<BooleanOperators>;
  aggregateOrderId?: InputMaybe<IdOperators>;
  alreadyHere?: InputMaybe<BooleanOperators>;
  appVersion?: InputMaybe<StringOperators>;
  asapOrder?: InputMaybe<BooleanOperators>;
  cloverOrderId?: InputMaybe<StringOperators>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  currencyCode?: InputMaybe<StringOperators>;
  customerLastName?: InputMaybe<StringOperators>;
  customerLoyaltyAchieved?: InputMaybe<NumberOperators>;
  deliveryRiderDasherId?: InputMaybe<StringOperators>;
  deliveryRiderName?: InputMaybe<StringOperators>;
  deliveryRiderNumber?: InputMaybe<StringOperators>;
  deliveryRiderVehicle?: InputMaybe<StringOperators>;
  deviceType?: InputMaybe<StringOperators>;
  doordashDeliveryId?: InputMaybe<StringOperators>;
  externalDoordashOrderCustomerFirstName?: InputMaybe<StringOperators>;
  externalDoordashOrderCustomerLastName?: InputMaybe<StringOperators>;
  externalDoordashOrderEntityId?: InputMaybe<StringOperators>;
  freeItemVariantAddons?: InputMaybe<StringOperators>;
  freePromoVariantAddons?: InputMaybe<StringOperators>;
  freePromoVariantId?: InputMaybe<StringOperators>;
  futureOrderTime?: InputMaybe<DateOperators>;
  futureOrderTimeZone?: InputMaybe<StringOperators>;
  holidayName?: InputMaybe<StringOperators>;
  holidayOrderReminderEmailSent?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  isCloverOrder?: InputMaybe<BooleanOperators>;
  isExternallyDoordashSynced?: InputMaybe<BooleanOperators>;
  isHolidayOrder?: InputMaybe<BooleanOperators>;
  isPOSOrder?: InputMaybe<BooleanOperators>;
  isUserRemovedOrder?: InputMaybe<BooleanOperators>;
  isVoided?: InputMaybe<BooleanOperators>;
  loyaltyMultiplierFactor?: InputMaybe<NumberOperators>;
  loyaltyRedeemed?: InputMaybe<BooleanOperators>;
  orderClone?: InputMaybe<StringOperators>;
  orderPlacedAt?: InputMaybe<DateOperators>;
  pickupSpot?: InputMaybe<StringOperators>;
  posCheckNumber?: InputMaybe<StringOperators>;
  posTransactionDate?: InputMaybe<StringOperators>;
  positouch_failure?: InputMaybe<BooleanOperators>;
  refundInvoice?: InputMaybe<StringOperators>;
  saleInvoice?: InputMaybe<StringOperators>;
  sentToPositouch?: InputMaybe<BooleanOperators>;
  shipping?: InputMaybe<NumberOperators>;
  shippingWithTax?: InputMaybe<NumberOperators>;
  specialInstructions?: InputMaybe<StringOperators>;
  state?: InputMaybe<StringOperators>;
  status?: InputMaybe<StringOperators>;
  subTotal?: InputMaybe<NumberOperators>;
  subTotalWithTax?: InputMaybe<NumberOperators>;
  tips?: InputMaybe<NumberOperators>;
  tipsPercentage?: InputMaybe<NumberOperators>;
  total?: InputMaybe<NumberOperators>;
  totalQuantity?: InputMaybe<NumberOperators>;
  totalWithTax?: InputMaybe<NumberOperators>;
  trackingUrl?: InputMaybe<StringOperators>;
  transactionId?: InputMaybe<StringOperators>;
  type?: InputMaybe<StringOperators>;
  typeOfDelivery?: InputMaybe<StringOperators>;
  typeOfFullfillment?: InputMaybe<StringOperators>;
  typeOfPickup?: InputMaybe<StringOperators>;
  uberEatsOrderId?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  usedCardId?: InputMaybe<StringOperators>;
  usedLoyaltyPoints?: InputMaybe<NumberOperators>;
  utensilsRequired?: InputMaybe<BooleanOperators>;
};

/** Returned when an order operation is rejected by an OrderInterceptor method. */
export type OrderInterceptorError = ErrorResult & {
  __typename?: 'OrderInterceptorError';
  errorCode: ErrorCode;
  interceptorError: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Returned when the maximum order size limit has been reached. */
export type OrderLimitError = ErrorResult & {
  __typename?: 'OrderLimitError';
  errorCode: ErrorCode;
  maxItems: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type OrderLine = Node & {
  __typename?: 'OrderLine';
  actualVariantPrice?: Maybe<Scalars['Money']['output']>;
  addOnsPrice?: Maybe<Scalars['Money']['output']>;
  allBeverageAddonsAdded?: Maybe<Array<Maybe<ProductVariant>>>;
  allBreadAddonsAdded?: Maybe<Array<Maybe<ProductVariant>>>;
  allDessertAddonsAdded?: Maybe<Array<Maybe<ProductVariant>>>;
  allSauceAddonsAdded?: Maybe<Array<Maybe<ProductVariant>>>;
  allSideAddonsAdded?: Maybe<Array<Maybe<ProductVariant>>>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<OrderLineCustomFields>;
  /** The price of the line including discounts, excluding tax */
  discountedLinePrice: Scalars['Money']['output'];
  /** The price of the line including discounts and tax */
  discountedLinePriceWithTax: Scalars['Money']['output'];
  /**
   * The price of a single unit including discounts, excluding tax.
   *
   * If Order-level discounts have been applied, this will not be the
   * actual taxable unit price (see `proratedUnitPrice`), but is generally the
   * correct price to display to customers to avoid confusion
   * about the internal handling of distributed Order-level discounts.
   */
  discountedUnitPrice: Scalars['Money']['output'];
  /** The price of a single unit including discounts and tax */
  discountedUnitPriceWithTax: Scalars['Money']['output'];
  discounts: Array<Discount>;
  featuredAsset?: Maybe<Asset>;
  fulfillmentLines?: Maybe<Array<FulfillmentLine>>;
  id: Scalars['ID']['output'];
  /** The total price of the line excluding tax and discounts. */
  linePrice: Scalars['Money']['output'];
  /** The total price of the line including tax but excluding discounts. */
  linePriceWithTax: Scalars['Money']['output'];
  /** The total tax on this line */
  lineTax: Scalars['Money']['output'];
  order: Order;
  /** The quantity at the time the Order was placed */
  orderPlacedQuantity: Scalars['Int']['output'];
  productVariant: ProductVariant;
  /**
   * The actual line price, taking into account both item discounts _and_ prorated (proportionally-distributed)
   * Order-level discounts. This value is the true economic value of the OrderLine, and is used in tax
   * and refund calculations.
   */
  proratedLinePrice: Scalars['Money']['output'];
  /** The proratedLinePrice including tax */
  proratedLinePriceWithTax: Scalars['Money']['output'];
  /**
   * The actual unit price, taking into account both item discounts _and_ prorated (proportionally-distributed)
   * Order-level discounts. This value is the true economic value of the OrderItem, and is used in tax
   * and refund calculations.
   */
  proratedUnitPrice: Scalars['Money']['output'];
  /** The proratedUnitPrice including tax */
  proratedUnitPriceWithTax: Scalars['Money']['output'];
  /** The quantity of items purchased */
  quantity: Scalars['Int']['output'];
  taxLines: Array<TaxLine>;
  taxRate: Scalars['Float']['output'];
  /** The price of a single unit, excluding tax and discounts */
  unitPrice: Scalars['Money']['output'];
  /** Non-zero if the unitPrice has changed since it was initially added to Order */
  unitPriceChangeSinceAdded: Scalars['Money']['output'];
  /** The price of a single unit, including tax but excluding discounts */
  unitPriceWithTax: Scalars['Money']['output'];
  /** Non-zero if the unitPriceWithTax has changed since it was initially added to Order */
  unitPriceWithTaxChangeSinceAdded: Scalars['Money']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderLineCustomFields = {
  __typename?: 'OrderLineCustomFields';
  addOnMapping?: Maybe<Scalars['String']['output']>;
  addOnQuantityMapping?: Maybe<Scalars['String']['output']>;
  beverageAddOnVariantsAdded?: Maybe<Array<Scalars['String']['output']>>;
  breadAddOnVariantsAdded?: Maybe<Array<Scalars['String']['output']>>;
  collectionOfOrder?: Maybe<Scalars['String']['output']>;
  desertAddOnVariantsAdded?: Maybe<Array<Scalars['String']['output']>>;
  freeGiftDescription?: Maybe<Scalars['String']['output']>;
  freeGiftPromotionId?: Maybe<Scalars['String']['output']>;
  freeOptions?: Maybe<Array<Scalars['String']['output']>>;
  isHolidayOrderLine?: Maybe<Scalars['Boolean']['output']>;
  isLoyaltyGift?: Maybe<Scalars['Boolean']['output']>;
  loyaltyGiftedBy?: Maybe<Customer>;
  loyaltyPointsUsedPerUnit?: Maybe<Scalars['Int']['output']>;
  sauceAddOnVariantsAdded?: Maybe<Array<Scalars['String']['output']>>;
  sideVariantsAdded?: Maybe<Array<Scalars['String']['output']>>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  storeOfOrder?: Maybe<Scalars['String']['output']>;
  typeOfOrder?: Maybe<Scalars['String']['output']>;
};

export type OrderLineCustomFieldsInput = {
  addOnMapping?: InputMaybe<Scalars['String']['input']>;
  addOnQuantityMapping?: InputMaybe<Scalars['String']['input']>;
  beverageAddOnVariantsAdded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadAddOnVariantsAdded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  collectionOfOrder?: InputMaybe<Scalars['String']['input']>;
  desertAddOnVariantsAdded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  freeGiftDescription?: InputMaybe<Scalars['String']['input']>;
  freeGiftPromotionId?: InputMaybe<Scalars['String']['input']>;
  freeOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isHolidayOrderLine?: InputMaybe<Scalars['Boolean']['input']>;
  isLoyaltyGift?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltyGiftedById?: InputMaybe<Scalars['ID']['input']>;
  loyaltyPointsUsedPerUnit?: InputMaybe<Scalars['Int']['input']>;
  sauceAddOnVariantsAdded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sideVariantsAdded?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  storeOfOrder?: InputMaybe<Scalars['String']['input']>;
  typeOfOrder?: InputMaybe<Scalars['String']['input']>;
};

export type OrderLineInput = {
  customFields?: InputMaybe<OrderLineCustomFieldsInput>;
  orderLineId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type OrderList = PaginatedList & {
  __typename?: 'OrderList';
  items: Array<Order>;
  totalItems: Scalars['Int']['output'];
};

export type OrderListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<OrderFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<OrderSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderMetricSummary = {
  __typename?: 'OrderMetricSummary';
  items: Array<MetricSummary>;
  totalOrders: Scalars['Int']['output'];
  totalSales: Scalars['Int']['output'];
};

export type OrderModification = Node & {
  __typename?: 'OrderModification';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isSettled: Scalars['Boolean']['output'];
  lines: Array<OrderModificationLine>;
  note: Scalars['String']['output'];
  payment?: Maybe<Payment>;
  priceChange: Scalars['Money']['output'];
  refund?: Maybe<Refund>;
  surcharges?: Maybe<Array<Surcharge>>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Returned when attempting to modify the contents of an Order that is not in the `AddingItems` state. */
export type OrderModificationError = ErrorResult & {
  __typename?: 'OrderModificationError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type OrderModificationLine = {
  __typename?: 'OrderModificationLine';
  modification: OrderModification;
  modificationId: Scalars['ID']['output'];
  orderLine: OrderLine;
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

/** Returned when attempting to modify the contents of an Order that is not in the `Modifying` state. */
export type OrderModificationStateError = ErrorResult & {
  __typename?: 'OrderModificationStateError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type OrderProcessState = {
  __typename?: 'OrderProcessState';
  name: Scalars['String']['output'];
  to: Array<Scalars['String']['output']>;
};

export type OrderRow = {
  __typename?: 'OrderRow';
  addons?: Maybe<Scalars['String']['output']>;
  cardDigits?: Maybe<Scalars['String']['output']>;
  channelCode?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  fulfillment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Scalars['String']['output']>;
  loyaltyAmount?: Maybe<Scalars['String']['output']>;
  loyaltyPoints?: Maybe<Scalars['String']['output']>;
  pickupDateTime?: Maybe<Scalars['DateTime']['output']>;
  pickupDateTimeTimezone?: Maybe<Scalars['String']['output']>;
  placedAt?: Maybe<Scalars['String']['output']>;
  shippingcost?: Maybe<Scalars['String']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['String']['output']>;
  taxBreakdown?: Maybe<Scalars['String']['output']>;
  tips?: Maybe<Scalars['String']['output']>;
  totalWithTax?: Maybe<Scalars['String']['output']>;
};

export type OrderRowItem = {
  __typename?: 'OrderRowItem';
  addons: Array<OrderRowItemAddon>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type OrderRowItemAddon = {
  __typename?: 'OrderRowItemAddon';
  addonName?: Maybe<Scalars['String']['output']>;
  addonType?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type OrderSortParameter = {
  aggregateOrderId?: InputMaybe<SortOrder>;
  alreadyHere?: InputMaybe<SortOrder>;
  appVersion?: InputMaybe<SortOrder>;
  asapOrder?: InputMaybe<SortOrder>;
  carDetails?: InputMaybe<SortOrder>;
  cloverOrderId?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerLastName?: InputMaybe<SortOrder>;
  customerLoyaltyAchieved?: InputMaybe<SortOrder>;
  deliveryRiderDasherId?: InputMaybe<SortOrder>;
  deliveryRiderName?: InputMaybe<SortOrder>;
  deliveryRiderNumber?: InputMaybe<SortOrder>;
  deliveryRiderVehicle?: InputMaybe<SortOrder>;
  deviceType?: InputMaybe<SortOrder>;
  doordashDeliveryId?: InputMaybe<SortOrder>;
  externalDoordashOrderCustomerFirstName?: InputMaybe<SortOrder>;
  externalDoordashOrderCustomerLastName?: InputMaybe<SortOrder>;
  externalDoordashOrderEntityId?: InputMaybe<SortOrder>;
  freeItemVariantAddons?: InputMaybe<SortOrder>;
  freePromoVariantAddons?: InputMaybe<SortOrder>;
  freePromoVariantId?: InputMaybe<SortOrder>;
  futureOrderTime?: InputMaybe<SortOrder>;
  futureOrderTimeZone?: InputMaybe<SortOrder>;
  holidayName?: InputMaybe<SortOrder>;
  holidayOrderReminderEmailSent?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isCloverOrder?: InputMaybe<SortOrder>;
  isExternallyDoordashSynced?: InputMaybe<SortOrder>;
  isHolidayOrder?: InputMaybe<SortOrder>;
  isPOSOrder?: InputMaybe<SortOrder>;
  isUserRemovedOrder?: InputMaybe<SortOrder>;
  isVoided?: InputMaybe<SortOrder>;
  loyaltyMultiplierFactor?: InputMaybe<SortOrder>;
  loyaltyRedeemed?: InputMaybe<SortOrder>;
  orderClone?: InputMaybe<SortOrder>;
  orderPlacedAt?: InputMaybe<SortOrder>;
  pickupSpot?: InputMaybe<SortOrder>;
  posCheckNumber?: InputMaybe<SortOrder>;
  posTransactionDate?: InputMaybe<SortOrder>;
  positouch_failure?: InputMaybe<SortOrder>;
  refundInvoice?: InputMaybe<SortOrder>;
  saleInvoice?: InputMaybe<SortOrder>;
  sentToPositouch?: InputMaybe<SortOrder>;
  shipping?: InputMaybe<SortOrder>;
  shippingWithTax?: InputMaybe<SortOrder>;
  specialInstructions?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subTotal?: InputMaybe<SortOrder>;
  subTotalWithTax?: InputMaybe<SortOrder>;
  tips?: InputMaybe<SortOrder>;
  tipsPercentage?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  totalQuantity?: InputMaybe<SortOrder>;
  totalWithTax?: InputMaybe<SortOrder>;
  trackingUrl?: InputMaybe<SortOrder>;
  transactionId?: InputMaybe<SortOrder>;
  typeOfDelivery?: InputMaybe<SortOrder>;
  typeOfFullfillment?: InputMaybe<SortOrder>;
  typeOfPickup?: InputMaybe<SortOrder>;
  uberEatsOrderId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  usedCardId?: InputMaybe<SortOrder>;
  usedLoyaltyPoints?: InputMaybe<SortOrder>;
  utensilsRequired?: InputMaybe<SortOrder>;
};

/** Returned if there is an error in transitioning the Order state */
export type OrderStateTransitionError = ErrorResult & {
  __typename?: 'OrderStateTransitionError';
  errorCode: ErrorCode;
  fromState: Scalars['String']['output'];
  message: Scalars['String']['output'];
  toState: Scalars['String']['output'];
  transitionError: Scalars['String']['output'];
};

/**
 * A summary of the taxes being applied to this order, grouped
 * by taxRate.
 */
export type OrderTaxSummary = {
  __typename?: 'OrderTaxSummary';
  /** A description of this tax */
  description: Scalars['String']['output'];
  /** The total net price of OrderLines to which this taxRate applies */
  taxBase: Scalars['Money']['output'];
  /** The taxRate as a percentage */
  taxRate: Scalars['Float']['output'];
  /** The total tax being applied to the Order at this taxRate */
  taxTotal: Scalars['Money']['output'];
};

export enum OrderType {
  Aggregate = 'Aggregate',
  Regular = 'Regular',
  Seller = 'Seller'
}

export type Page = Node & {
  __typename?: 'Page';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTags?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PageFilterParameter = {
  _and?: InputMaybe<Array<PageFilterParameter>>;
  _or?: InputMaybe<Array<PageFilterParameter>>;
  content?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  metaDescription?: InputMaybe<StringOperators>;
  metaTags?: InputMaybe<StringOperators>;
  metaTitle?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  slug?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type PageList = PaginatedList & {
  __typename?: 'PageList';
  items: Array<Page>;
  totalItems: Scalars['Int']['output'];
};

export type PageListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<PageFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<PageSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PageSortParameter = {
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metaDescription?: InputMaybe<SortOrder>;
  metaTags?: InputMaybe<SortOrder>;
  metaTitle?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PaginatedList = {
  items: Array<Node>;
  totalItems: Scalars['Int']['output'];
};

export type PaginationInput = {
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};

export type Payment = Node & {
  __typename?: 'Payment';
  amount: Scalars['Money']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  method: Scalars['String']['output'];
  nextStates: Array<Scalars['String']['output']>;
  refunds: Array<Refund>;
  state: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethod = Node & {
  __typename?: 'PaymentMethod';
  checker?: Maybe<ConfigurableOperation>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  handler: ConfigurableOperation;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  translations: Array<PaymentMethodTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodFilterParameter = {
  _and?: InputMaybe<Array<PaymentMethodFilterParameter>>;
  _or?: InputMaybe<Array<PaymentMethodFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type PaymentMethodList = PaginatedList & {
  __typename?: 'PaymentMethodList';
  items: Array<PaymentMethod>;
  totalItems: Scalars['Int']['output'];
};

export type PaymentMethodListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<PaymentMethodFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<PaymentMethodSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Returned when a call to modifyOrder fails to include a paymentMethod even
 * though the price has increased as a result of the changes.
 */
export type PaymentMethodMissingError = ErrorResult & {
  __typename?: 'PaymentMethodMissingError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type PaymentMethodQuote = {
  __typename?: 'PaymentMethodQuote';
  code: Scalars['String']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  eligibilityMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEligible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type PaymentMethodSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentMethodTranslation = {
  __typename?: 'PaymentMethodTranslation';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Returned if an attempting to refund a Payment against OrderLines from a different Order */
export type PaymentOrderMismatchError = ErrorResult & {
  __typename?: 'PaymentOrderMismatchError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned when there is an error in transitioning the Payment state */
export type PaymentStateTransitionError = ErrorResult & {
  __typename?: 'PaymentStateTransitionError';
  errorCode: ErrorCode;
  fromState: Scalars['String']['output'];
  message: Scalars['String']['output'];
  toState: Scalars['String']['output'];
  transitionError: Scalars['String']['output'];
};

/**
 * @description
 * Permissions for administrators and customers. Used to control access to
 * GraphQL resolvers via the {@link Allow} decorator.
 *
 * ## Understanding Permission.Owner
 *
 * `Permission.Owner` is a special permission which is used in some Vendure resolvers to indicate that that resolver should only
 * be accessible to the "owner" of that resource.
 *
 * For example, the Shop API `activeCustomer` query resolver should only return the Customer object for the "owner" of that Customer, i.e.
 * based on the activeUserId of the current session. As a result, the resolver code looks like this:
 *
 * @example
 * ```TypeScript
 * \@Query()
 * \@Allow(Permission.Owner)
 * async activeCustomer(\@Ctx() ctx: RequestContext): Promise<Customer | undefined> {
 *   const userId = ctx.activeUserId;
 *   if (userId) {
 *     return this.customerService.findOneByUserId(ctx, userId);
 *   }
 * }
 * ```
 *
 * Here we can see that the "ownership" must be enforced by custom logic inside the resolver. Since "ownership" cannot be defined generally
 * nor statically encoded at build-time, any resolvers using `Permission.Owner` **must** include logic to enforce that only the owner
 * of the resource has access. If not, then it is the equivalent of using `Permission.Public`.
 *
 *
 * @docsCategory common
 */
export enum Permission {
  /** Accept or reject a coupon code/deal */
  AcceptRejectPromotion = 'AcceptRejectPromotion',
  /** Authenticated means simply that the user is logged in */
  Authenticated = 'Authenticated',
  /** Grants permission to create Administrator */
  CreateAdministrator = 'CreateAdministrator',
  /** Grants permission to create Asset */
  CreateAsset = 'CreateAsset',
  /** Grants permission to create Products, Facets, Assets, Collections */
  CreateCatalog = 'CreateCatalog',
  /** Grants permission to create Channel */
  CreateChannel = 'CreateChannel',
  /** Grants permission to create Collection */
  CreateCollection = 'CreateCollection',
  /** Grants permission to create Country */
  CreateCountry = 'CreateCountry',
  /** Grants permission to create Customer */
  CreateCustomer = 'CreateCustomer',
  /** Grants permission to create CustomerGroup */
  CreateCustomerGroup = 'CreateCustomerGroup',
  /** Grants permission to create Facet */
  CreateFacet = 'CreateFacet',
  /** Grants permission to create Order */
  CreateOrder = 'CreateOrder',
  /** Grants permission to create PaymentMethod */
  CreatePaymentMethod = 'CreatePaymentMethod',
  /** Grants permission to create Product */
  CreateProduct = 'CreateProduct',
  /** Grants permission to create Promotion */
  CreatePromotion = 'CreatePromotion',
  /** Grants permission to create Seller */
  CreateSeller = 'CreateSeller',
  /** Grants permission to create PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
  CreateSettings = 'CreateSettings',
  /** Grants permission to create ShippingMethod */
  CreateShippingMethod = 'CreateShippingMethod',
  /** Grants permission to create StockLocation */
  CreateStockLocation = 'CreateStockLocation',
  /** Grants permission to create System */
  CreateSystem = 'CreateSystem',
  /** Grants permission to create Tag */
  CreateTag = 'CreateTag',
  /** Grants permission to create TaxCategory */
  CreateTaxCategory = 'CreateTaxCategory',
  /** Grants permission to create TaxRate */
  CreateTaxRate = 'CreateTaxRate',
  /** Grants permission to create Zone */
  CreateZone = 'CreateZone',
  /** Grants permission to delete Administrator */
  DeleteAdministrator = 'DeleteAdministrator',
  /** Grants permission to delete Asset */
  DeleteAsset = 'DeleteAsset',
  /** Grants permission to delete Products, Facets, Assets, Collections */
  DeleteCatalog = 'DeleteCatalog',
  /** Grants permission to delete Channel */
  DeleteChannel = 'DeleteChannel',
  /** Grants permission to delete Collection */
  DeleteCollection = 'DeleteCollection',
  /** Grants permission to delete Country */
  DeleteCountry = 'DeleteCountry',
  /** Grants permission to delete Customer */
  DeleteCustomer = 'DeleteCustomer',
  /** Grants permission to delete CustomerGroup */
  DeleteCustomerGroup = 'DeleteCustomerGroup',
  /** Grants permission to delete Facet */
  DeleteFacet = 'DeleteFacet',
  /** Grants permission to delete Order */
  DeleteOrder = 'DeleteOrder',
  /** Grants permission to delete PaymentMethod */
  DeletePaymentMethod = 'DeletePaymentMethod',
  /** Grants permission to delete Product */
  DeleteProduct = 'DeleteProduct',
  /** Grants permission to delete Promotion */
  DeletePromotion = 'DeletePromotion',
  /** Grants permission to delete Seller */
  DeleteSeller = 'DeleteSeller',
  /** Grants permission to delete PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
  DeleteSettings = 'DeleteSettings',
  /** Grants permission to delete ShippingMethod */
  DeleteShippingMethod = 'DeleteShippingMethod',
  /** Grants permission to delete StockLocation */
  DeleteStockLocation = 'DeleteStockLocation',
  /** Grants permission to delete System */
  DeleteSystem = 'DeleteSystem',
  /** Grants permission to delete Tag */
  DeleteTag = 'DeleteTag',
  /** Grants permission to delete TaxCategory */
  DeleteTaxCategory = 'DeleteTaxCategory',
  /** Grants permission to delete TaxRate */
  DeleteTaxRate = 'DeleteTaxRate',
  /** Grants permission to delete Zone */
  DeleteZone = 'DeleteZone',
  /** Allows administrator to export orders */
  ExportOrders = 'ExportOrders',
  /** Permission to view & update feedbacks (Deletion only allowed to superadmin) */
  FeedbackControl = 'FeedbackControl',
  /** Owner means the user owns this entity, e.g. a Customer's own Order */
  Owner = 'Owner',
  /** Public means any unauthenticated user may perform the operation */
  Public = 'Public',
  /** Grants permission to read Administrator */
  ReadAdministrator = 'ReadAdministrator',
  /** Grants permission to read Asset */
  ReadAsset = 'ReadAsset',
  /** Grants permission to read Products, Facets, Assets, Collections */
  ReadCatalog = 'ReadCatalog',
  /** Grants permission to read Channel */
  ReadChannel = 'ReadChannel',
  /** Grants permission to read Collection */
  ReadCollection = 'ReadCollection',
  /** Grants permission to read Country */
  ReadCountry = 'ReadCountry',
  /** Grants permission to read Customer */
  ReadCustomer = 'ReadCustomer',
  /** Grants permission to read CustomerGroup */
  ReadCustomerGroup = 'ReadCustomerGroup',
  /** Grants permission to read Facet */
  ReadFacet = 'ReadFacet',
  /** Grants permission to read Order */
  ReadOrder = 'ReadOrder',
  /** Grants permission to read PaymentMethod */
  ReadPaymentMethod = 'ReadPaymentMethod',
  /** Grants permission to read Product */
  ReadProduct = 'ReadProduct',
  /** Grants permission to read Promotion */
  ReadPromotion = 'ReadPromotion',
  /** Grants permission to read Seller */
  ReadSeller = 'ReadSeller',
  /** Grants permission to read PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
  ReadSettings = 'ReadSettings',
  /** Grants permission to read ShippingMethod */
  ReadShippingMethod = 'ReadShippingMethod',
  /** Grants permission to read StockLocation */
  ReadStockLocation = 'ReadStockLocation',
  /** Grants permission to read System */
  ReadSystem = 'ReadSystem',
  /** Grants permission to read Tag */
  ReadTag = 'ReadTag',
  /** Grants permission to read TaxCategory */
  ReadTaxCategory = 'ReadTaxCategory',
  /** Grants permission to read TaxRate */
  ReadTaxRate = 'ReadTaxRate',
  /** Grants permission to read Zone */
  ReadZone = 'ReadZone',
  /** Permission to control scratch rewards */
  ScratchRewardsControl = 'ScratchRewardsControl',
  /** Permission to control spin rewards */
  SpinRewardsControl = 'SpinRewardsControl',
  /** SuperAdmin has unrestricted access to all operations */
  SuperAdmin = 'SuperAdmin',
  /** Grants permission to update Administrator */
  UpdateAdministrator = 'UpdateAdministrator',
  /** Grants permission to update Asset */
  UpdateAsset = 'UpdateAsset',
  /** Grants permission to update Products, Facets, Assets, Collections */
  UpdateCatalog = 'UpdateCatalog',
  /** Grants permission to update Channel */
  UpdateChannel = 'UpdateChannel',
  /** Grants permission to update Collection */
  UpdateCollection = 'UpdateCollection',
  /** Grants permission to update Country */
  UpdateCountry = 'UpdateCountry',
  /** Grants permission to update Customer */
  UpdateCustomer = 'UpdateCustomer',
  /** Grants permission to update CustomerGroup */
  UpdateCustomerGroup = 'UpdateCustomerGroup',
  /** Grants permission to update Facet */
  UpdateFacet = 'UpdateFacet',
  /** Grants permission to update GlobalSettings */
  UpdateGlobalSettings = 'UpdateGlobalSettings',
  /** Grants permission to update Order */
  UpdateOrder = 'UpdateOrder',
  /** Grants permission to update PaymentMethod */
  UpdatePaymentMethod = 'UpdatePaymentMethod',
  /** Grants permission to update Product */
  UpdateProduct = 'UpdateProduct',
  /** Grants permission to update Promotion */
  UpdatePromotion = 'UpdatePromotion',
  /** Grants permission to update Seller */
  UpdateSeller = 'UpdateSeller',
  /** Grants permission to update PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
  UpdateSettings = 'UpdateSettings',
  /** Grants permission to update ShippingMethod */
  UpdateShippingMethod = 'UpdateShippingMethod',
  /** Grants permission to update StockLocation */
  UpdateStockLocation = 'UpdateStockLocation',
  /** Grants permission to update System */
  UpdateSystem = 'UpdateSystem',
  /** Grants permission to update Tag */
  UpdateTag = 'UpdateTag',
  /** Grants permission to update TaxCategory */
  UpdateTaxCategory = 'UpdateTaxCategory',
  /** Grants permission to update TaxRate */
  UpdateTaxRate = 'UpdateTaxRate',
  /** Grants permission to update Zone */
  UpdateZone = 'UpdateZone'
}

export type PermissionDefinition = {
  __typename?: 'PermissionDefinition';
  assignable: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PreviewCollectionVariantsInput = {
  filters: Array<ConfigurableOperationInput>;
  inheritFilters: Scalars['Boolean']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type PriceData = {
  __typename?: 'PriceData';
  value: Scalars['Int']['output'];
};

/** The price range where the result has more than one price */
export type PriceRange = {
  __typename?: 'PriceRange';
  max: Scalars['Money']['output'];
  min: Scalars['Money']['output'];
};

export type Product = Node & {
  __typename?: 'Product';
  assets: Array<Asset>;
  channels: Array<Channel>;
  collections: Array<Collection>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<ProductCustomFields>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  facetValues: Array<FacetValue>;
  featuredAsset?: Maybe<Asset>;
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  optionGroups: Array<ProductOptionGroup>;
  reviews: ProductReviewList;
  reviewsHistogram: Array<ProductReviewHistogramItem>;
  slug: Scalars['String']['output'];
  translations: Array<ProductTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  /** Returns a paginated, sortable, filterable list of ProductVariants */
  variantList: ProductVariantList;
  /** Returns all ProductVariants */
  variants: Array<ProductVariant>;
};


export type ProductReviewsArgs = {
  options?: InputMaybe<ProductReviewListOptions>;
};


export type ProductVariantListArgs = {
  options?: InputMaybe<ProductVariantListOptions>;
};

export type ProductAsset = {
  __typename?: 'ProductAsset';
  focalPoint?: Maybe<FocalPoint>;
  id: Scalars['ID']['output'];
  preview: Scalars['String']['output'];
};

export type ProductCustomFields = {
  __typename?: 'ProductCustomFields';
  cateringUnitMeasure?: Maybe<Scalars['String']['output']>;
  featuredReview?: Maybe<ProductReview>;
  isOrderCatering?: Maybe<Scalars['Boolean']['output']>;
  nutritionalInfo?: Maybe<Asset>;
  reviewCount?: Maybe<Scalars['Float']['output']>;
  reviewRating?: Maybe<Scalars['Float']['output']>;
};

export type ProductFilterParameter = {
  _and?: InputMaybe<Array<ProductFilterParameter>>;
  _or?: InputMaybe<Array<ProductFilterParameter>>;
  cateringUnitMeasure?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  facetValueId?: InputMaybe<IdOperators>;
  id?: InputMaybe<IdOperators>;
  isOrderCatering?: InputMaybe<BooleanOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  reviewCount?: InputMaybe<NumberOperators>;
  reviewRating?: InputMaybe<NumberOperators>;
  sku?: InputMaybe<StringOperators>;
  slug?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ProductList = PaginatedList & {
  __typename?: 'ProductList';
  items: Array<Product>;
  totalItems: Scalars['Int']['output'];
};

export type ProductListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ProductFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ProductSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductOption = Node & {
  __typename?: 'ProductOption';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  group: ProductOptionGroup;
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  translations: Array<ProductOptionTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionGroup = Node & {
  __typename?: 'ProductOptionGroup';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  options: Array<ProductOption>;
  translations: Array<ProductOptionGroupTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionGroupTranslation = {
  __typename?: 'ProductOptionGroupTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionGroupTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProductOptionInUseError = ErrorResult & {
  __typename?: 'ProductOptionInUseError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  optionGroupCode: Scalars['String']['output'];
  productVariantCount: Scalars['Int']['output'];
};

export type ProductOptionTranslation = {
  __typename?: 'ProductOptionTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProductReview = Node & {
  __typename?: 'ProductReview';
  author?: Maybe<Customer>;
  authorLocation?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  downvotes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  product: Product;
  productVariant?: Maybe<ProductVariant>;
  rating: Scalars['Float']['output'];
  response?: Maybe<Scalars['String']['output']>;
  responseCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  state: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  upvotes: Scalars['Int']['output'];
};

export type ProductReviewFilterParameter = {
  _and?: InputMaybe<Array<ProductReviewFilterParameter>>;
  _or?: InputMaybe<Array<ProductReviewFilterParameter>>;
  authorLocation?: InputMaybe<StringOperators>;
  authorName?: InputMaybe<StringOperators>;
  body?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  downvotes?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  rating?: InputMaybe<NumberOperators>;
  response?: InputMaybe<StringOperators>;
  responseCreatedAt?: InputMaybe<DateOperators>;
  state?: InputMaybe<StringOperators>;
  summary?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  upvotes?: InputMaybe<NumberOperators>;
};

export type ProductReviewHistogramItem = {
  __typename?: 'ProductReviewHistogramItem';
  bin: Scalars['Int']['output'];
  frequency: Scalars['Int']['output'];
};

export type ProductReviewList = PaginatedList & {
  __typename?: 'ProductReviewList';
  items: Array<ProductReview>;
  totalItems: Scalars['Int']['output'];
};

export type ProductReviewListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ProductReviewFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ProductReviewSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductReviewSortParameter = {
  authorLocation?: InputMaybe<SortOrder>;
  authorName?: InputMaybe<SortOrder>;
  body?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  downvotes?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rating?: InputMaybe<SortOrder>;
  response?: InputMaybe<SortOrder>;
  responseCreatedAt?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  summary?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  upvotes?: InputMaybe<SortOrder>;
};

export type ProductSortParameter = {
  cateringUnitMeasure?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  featuredReview?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isOrderCatering?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nutritionalInfo?: InputMaybe<SortOrder>;
  reviewCount?: InputMaybe<SortOrder>;
  reviewRating?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductTranslation = {
  __typename?: 'ProductTranslation';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ProductVariant = Node & {
  __typename?: 'ProductVariant';
  assets: Array<Asset>;
  channels: Array<Channel>;
  createdAt: Scalars['DateTime']['output'];
  currencyCode: CurrencyCode;
  customFields?: Maybe<ProductVariantCustomFields>;
  enabled: Scalars['Boolean']['output'];
  facetValues: Array<FacetValue>;
  featuredAsset?: Maybe<Asset>;
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  options: Array<ProductOption>;
  outOfStockThreshold: Scalars['Int']['output'];
  price: Scalars['Money']['output'];
  priceWithTax: Scalars['Money']['output'];
  prices: Array<ProductVariantPrice>;
  product: Product;
  productId: Scalars['ID']['output'];
  sku: Scalars['String']['output'];
  /** @deprecated use stockLevels */
  stockAllocated: Scalars['Int']['output'];
  stockLevel: Scalars['String']['output'];
  stockLevels: Array<StockLevel>;
  stockMovements: StockMovementList;
  /** @deprecated use stockLevels */
  stockOnHand: Scalars['Int']['output'];
  taxCategory: TaxCategory;
  taxRateApplied: TaxRate;
  trackInventory: GlobalFlag;
  translations: Array<ProductVariantTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  useGlobalOutOfStockThreshold: Scalars['Boolean']['output'];
};


export type ProductVariantStockMovementsArgs = {
  options?: InputMaybe<StockMovementListOptions>;
};

export type ProductVariantCustomFields = {
  __typename?: 'ProductVariantCustomFields';
  beverageAddOnVariantsAvailable?: Maybe<Array<ProductVariant>>;
  beverageAlACarteAddOnVariantsMaximum?: Maybe<Scalars['Int']['output']>;
  beverageAlACarteAddOnVariantsRequired?: Maybe<Scalars['Int']['output']>;
  beverageMakeAMealAddOnVariantsMaximum?: Maybe<Scalars['Int']['output']>;
  beverageMakeAMealAddOnVariantsRequired?: Maybe<Scalars['Int']['output']>;
  breadAddOnVariantsAvailable?: Maybe<Array<ProductVariant>>;
  breadAlACarteAddOnVariantsMaximum?: Maybe<Scalars['Int']['output']>;
  breadAlACarteAddOnVariantsRequired?: Maybe<Scalars['Int']['output']>;
  breadMakeAMealAddOnVariantsMaximum?: Maybe<Scalars['Int']['output']>;
  breadMakeAMealAddOnVariantsRequired?: Maybe<Scalars['Int']['output']>;
  cateringFreeOptions?: Maybe<Array<Scalars['String']['output']>>;
  cateringMinimumThreshold?: Maybe<Scalars['Int']['output']>;
  cateringServingSize?: Maybe<Scalars['Int']['output']>;
  cloverCatalogObjectId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  desertAddOnVariantsAvailable?: Maybe<Array<ProductVariant>>;
  desertAlACarteAddOnVariantsMaximum?: Maybe<Scalars['Int']['output']>;
  desertAlACarteAddOnVariantsRequired?: Maybe<Scalars['Int']['output']>;
  desertMakeAMealAddOnVariantsMaximum?: Maybe<Scalars['Int']['output']>;
  desertMakeAMealAddOnVariantsRequired?: Maybe<Scalars['Int']['output']>;
  loyaltyGiftPoints?: Maybe<Array<ProductVariantLoyaltyGiftPointsStruct>>;
  makeAMealSKU?: Maybe<Scalars['String']['output']>;
  noOfCateringSidesRequired?: Maybe<Scalars['Int']['output']>;
  preparationTime?: Maybe<Scalars['Float']['output']>;
  sauceAddOnVariantsAvailable?: Maybe<Array<ProductVariant>>;
  sauceAlACarteAddOnVariantsMaximum?: Maybe<Scalars['Int']['output']>;
  sauceAlACarteAddOnVariantsRequired?: Maybe<Scalars['Int']['output']>;
  sauceMakeAMealAddOnVariantsMaximum?: Maybe<Scalars['Int']['output']>;
  sauceMakeAMealAddOnVariantsRequired?: Maybe<Scalars['Int']['output']>;
  showInDeals?: Maybe<Scalars['Boolean']['output']>;
  sideAlACarteVariantsMaximum?: Maybe<Scalars['Int']['output']>;
  sideAlACarteVariantsRequired?: Maybe<Scalars['Int']['output']>;
  sideMakeAMealVariantsMaximum?: Maybe<Scalars['Int']['output']>;
  sideMakeAMealVariantsRequired?: Maybe<Scalars['Int']['output']>;
  sideVariantsAvailable?: Maybe<Array<ProductVariant>>;
};

export type ProductVariantFilterParameter = {
  _and?: InputMaybe<Array<ProductVariantFilterParameter>>;
  _or?: InputMaybe<Array<ProductVariantFilterParameter>>;
  beverageAlACarteAddOnVariantsMaximum?: InputMaybe<NumberOperators>;
  beverageAlACarteAddOnVariantsRequired?: InputMaybe<NumberOperators>;
  beverageMakeAMealAddOnVariantsMaximum?: InputMaybe<NumberOperators>;
  beverageMakeAMealAddOnVariantsRequired?: InputMaybe<NumberOperators>;
  breadAlACarteAddOnVariantsMaximum?: InputMaybe<NumberOperators>;
  breadAlACarteAddOnVariantsRequired?: InputMaybe<NumberOperators>;
  breadMakeAMealAddOnVariantsMaximum?: InputMaybe<NumberOperators>;
  breadMakeAMealAddOnVariantsRequired?: InputMaybe<NumberOperators>;
  cateringFreeOptions?: InputMaybe<StringListOperators>;
  cateringMinimumThreshold?: InputMaybe<NumberOperators>;
  cateringServingSize?: InputMaybe<NumberOperators>;
  cloverCatalogObjectId?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  currencyCode?: InputMaybe<StringOperators>;
  description?: InputMaybe<StringOperators>;
  desertAlACarteAddOnVariantsMaximum?: InputMaybe<NumberOperators>;
  desertAlACarteAddOnVariantsRequired?: InputMaybe<NumberOperators>;
  desertMakeAMealAddOnVariantsMaximum?: InputMaybe<NumberOperators>;
  desertMakeAMealAddOnVariantsRequired?: InputMaybe<NumberOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  facetValueId?: InputMaybe<IdOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  makeAMealSKU?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  noOfCateringSidesRequired?: InputMaybe<NumberOperators>;
  outOfStockThreshold?: InputMaybe<NumberOperators>;
  preparationTime?: InputMaybe<NumberOperators>;
  price?: InputMaybe<NumberOperators>;
  priceWithTax?: InputMaybe<NumberOperators>;
  productId?: InputMaybe<IdOperators>;
  sauceAlACarteAddOnVariantsMaximum?: InputMaybe<NumberOperators>;
  sauceAlACarteAddOnVariantsRequired?: InputMaybe<NumberOperators>;
  sauceMakeAMealAddOnVariantsMaximum?: InputMaybe<NumberOperators>;
  sauceMakeAMealAddOnVariantsRequired?: InputMaybe<NumberOperators>;
  showInDeals?: InputMaybe<BooleanOperators>;
  sideAlACarteVariantsMaximum?: InputMaybe<NumberOperators>;
  sideAlACarteVariantsRequired?: InputMaybe<NumberOperators>;
  sideMakeAMealVariantsMaximum?: InputMaybe<NumberOperators>;
  sideMakeAMealVariantsRequired?: InputMaybe<NumberOperators>;
  sku?: InputMaybe<StringOperators>;
  stockAllocated?: InputMaybe<NumberOperators>;
  stockLevel?: InputMaybe<StringOperators>;
  stockOnHand?: InputMaybe<NumberOperators>;
  trackInventory?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  useGlobalOutOfStockThreshold?: InputMaybe<BooleanOperators>;
};

export type ProductVariantList = PaginatedList & {
  __typename?: 'ProductVariantList';
  items: Array<ProductVariant>;
  totalItems: Scalars['Int']['output'];
};

export type ProductVariantListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ProductVariantFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ProductVariantSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductVariantLoyaltyGiftPointsStruct = {
  __typename?: 'ProductVariantLoyaltyGiftPointsStruct';
  loyaltyTier?: Maybe<Scalars['String']['output']>;
  pointsRequired?: Maybe<Scalars['Int']['output']>;
};

export type ProductVariantLoyaltyGiftPointsStructInput = {
  loyaltyTier?: InputMaybe<Scalars['String']['input']>;
  pointsRequired?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductVariantPrice = {
  __typename?: 'ProductVariantPrice';
  currencyCode: CurrencyCode;
  customFields?: Maybe<ProductVariantPriceCustomFields>;
  price: Scalars['Money']['output'];
};

export type ProductVariantPriceCustomFields = {
  __typename?: 'ProductVariantPriceCustomFields';
  availableDates?: Maybe<Array<Scalars['String']['output']>>;
  availableDays?: Maybe<Array<Scalars['String']['output']>>;
  cateringAvailableDates?: Maybe<Array<Scalars['String']['output']>>;
  cateringAvailableDays?: Maybe<Array<Scalars['String']['output']>>;
  cateringCutOffDates?: Maybe<Array<Scalars['String']['output']>>;
  cateringCutOffDays?: Maybe<Array<Scalars['String']['output']>>;
  cateringShowIfNotAvailable?: Maybe<Scalars['Boolean']['output']>;
  cutOffDates?: Maybe<Array<Scalars['String']['output']>>;
  cutOffDays?: Maybe<Array<Scalars['String']['output']>>;
  enableAlACarte?: Maybe<Scalars['Boolean']['output']>;
  enableMakeAMeal?: Maybe<Scalars['Boolean']['output']>;
  enableVariant?: Maybe<Scalars['Boolean']['output']>;
  holidayAvailableDates?: Maybe<Array<Scalars['String']['output']>>;
  holidayAvailableDays?: Maybe<Array<Scalars['String']['output']>>;
  holidayCutOffDates?: Maybe<Array<Scalars['String']['output']>>;
  holidayCutOffDays?: Maybe<Array<Scalars['String']['output']>>;
  holidayShowIfNotAvailable?: Maybe<Scalars['Boolean']['output']>;
  makeAMealCost?: Maybe<Scalars['Int']['output']>;
  showIfNotAvailable?: Maybe<Scalars['Boolean']['output']>;
};

export type ProductVariantSearchItem = {
  __typename?: 'ProductVariantSearchItem';
  channelId: Scalars['ID']['output'];
  price: PriceData;
  priceWithTax: PriceData;
  productAsset?: Maybe<ProductAsset>;
  productVariantId: Scalars['ID']['output'];
  productVariantName: Scalars['String']['output'];
  sku: Scalars['String']['output'];
};

export type ProductVariantSortParameter = {
  beverageAlACarteAddOnVariantsMaximum?: InputMaybe<SortOrder>;
  beverageAlACarteAddOnVariantsRequired?: InputMaybe<SortOrder>;
  beverageMakeAMealAddOnVariantsMaximum?: InputMaybe<SortOrder>;
  beverageMakeAMealAddOnVariantsRequired?: InputMaybe<SortOrder>;
  breadAlACarteAddOnVariantsMaximum?: InputMaybe<SortOrder>;
  breadAlACarteAddOnVariantsRequired?: InputMaybe<SortOrder>;
  breadMakeAMealAddOnVariantsMaximum?: InputMaybe<SortOrder>;
  breadMakeAMealAddOnVariantsRequired?: InputMaybe<SortOrder>;
  cateringMinimumThreshold?: InputMaybe<SortOrder>;
  cateringServingSize?: InputMaybe<SortOrder>;
  cloverCatalogObjectId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  desertAlACarteAddOnVariantsMaximum?: InputMaybe<SortOrder>;
  desertAlACarteAddOnVariantsRequired?: InputMaybe<SortOrder>;
  desertMakeAMealAddOnVariantsMaximum?: InputMaybe<SortOrder>;
  desertMakeAMealAddOnVariantsRequired?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  makeAMealSKU?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  noOfCateringSidesRequired?: InputMaybe<SortOrder>;
  outOfStockThreshold?: InputMaybe<SortOrder>;
  preparationTime?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceWithTax?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  sauceAlACarteAddOnVariantsMaximum?: InputMaybe<SortOrder>;
  sauceAlACarteAddOnVariantsRequired?: InputMaybe<SortOrder>;
  sauceMakeAMealAddOnVariantsMaximum?: InputMaybe<SortOrder>;
  sauceMakeAMealAddOnVariantsRequired?: InputMaybe<SortOrder>;
  showInDeals?: InputMaybe<SortOrder>;
  sideAlACarteVariantsMaximum?: InputMaybe<SortOrder>;
  sideAlACarteVariantsRequired?: InputMaybe<SortOrder>;
  sideMakeAMealVariantsMaximum?: InputMaybe<SortOrder>;
  sideMakeAMealVariantsRequired?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  stockAllocated?: InputMaybe<SortOrder>;
  stockLevel?: InputMaybe<SortOrder>;
  stockOnHand?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductVariantTranslation = {
  __typename?: 'ProductVariantTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductVariantTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PromoNotificationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  medium: Array<PromoNotificationMedium>;
  promotionId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export enum PromoNotificationMedium {
  APP = 'APP',
  EMAIL = 'EMAIL',
  SMS = 'SMS'
}

export type PromoNotificationResponse = {
  __typename?: 'PromoNotificationResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Promotion = Node & {
  __typename?: 'Promotion';
  actions: Array<ConfigurableOperation>;
  conditions: Array<ConfigurableOperation>;
  couponCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<PromotionCustomFields>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isAdminAccepted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  perCustomerUsageLimit?: Maybe<Scalars['Int']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  translations: Array<PromotionTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  usageLimit?: Maybe<Scalars['Int']['output']>;
};

export type PromotionCustomFields = {
  __typename?: 'PromotionCustomFields';
  adminAccepted?: Maybe<Scalars['Boolean']['output']>;
  banner?: Maybe<Asset>;
  image?: Maybe<Asset>;
  isDeal?: Maybe<Scalars['Boolean']['output']>;
  isFeedbackReward?: Maybe<Scalars['Boolean']['output']>;
  isScratchPromo?: Maybe<Scalars['Boolean']['output']>;
  isScratchReward?: Maybe<Scalars['Boolean']['output']>;
  isSpinPromo?: Maybe<Scalars['Boolean']['output']>;
  isSpinReward?: Maybe<Scalars['Boolean']['output']>;
  promoTag?: Maybe<Scalars['String']['output']>;
  rejectedReason?: Maybe<Scalars['String']['output']>;
  typeOfCoupon?: Maybe<Scalars['String']['output']>;
};

export type PromotionFilterParameter = {
  _and?: InputMaybe<Array<PromotionFilterParameter>>;
  _or?: InputMaybe<Array<PromotionFilterParameter>>;
  adminAccepted?: InputMaybe<BooleanOperators>;
  couponCode?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  deletedAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  endsAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  isAdminAccepted?: InputMaybe<BooleanOperators>;
  isDeal?: InputMaybe<BooleanOperators>;
  isFeedbackReward?: InputMaybe<BooleanOperators>;
  isScratchPromo?: InputMaybe<BooleanOperators>;
  isScratchReward?: InputMaybe<BooleanOperators>;
  isSpinPromo?: InputMaybe<BooleanOperators>;
  isSpinReward?: InputMaybe<BooleanOperators>;
  name?: InputMaybe<StringOperators>;
  perCustomerUsageLimit?: InputMaybe<NumberOperators>;
  promoTag?: InputMaybe<StringOperators>;
  rejectedReason?: InputMaybe<StringOperators>;
  startsAt?: InputMaybe<DateOperators>;
  typeOfCoupon?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  usageLimit?: InputMaybe<NumberOperators>;
};

export type PromotionList = PaginatedList & {
  __typename?: 'PromotionList';
  items: Array<Promotion>;
  totalItems: Scalars['Int']['output'];
};

export type PromotionListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<PromotionFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<PromotionSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PromotionSortParameter = {
  adminAccepted?: InputMaybe<SortOrder>;
  banner?: InputMaybe<SortOrder>;
  couponCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  endsAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  isDeal?: InputMaybe<SortOrder>;
  isFeedbackReward?: InputMaybe<SortOrder>;
  isScratchPromo?: InputMaybe<SortOrder>;
  isScratchReward?: InputMaybe<SortOrder>;
  isSpinPromo?: InputMaybe<SortOrder>;
  isSpinReward?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  perCustomerUsageLimit?: InputMaybe<SortOrder>;
  promoTag?: InputMaybe<SortOrder>;
  rejectedReason?: InputMaybe<SortOrder>;
  startsAt?: InputMaybe<SortOrder>;
  typeOfCoupon?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  usageLimit?: InputMaybe<SortOrder>;
};

export type PromotionTranslation = {
  __typename?: 'PromotionTranslation';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PromotionTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Province = Node & Region & {
  __typename?: 'Province';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  parent?: Maybe<Region>;
  parentId?: Maybe<Scalars['ID']['output']>;
  translations: Array<RegionTranslation>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProvinceFilterParameter = {
  _and?: InputMaybe<Array<ProvinceFilterParameter>>;
  _or?: InputMaybe<Array<ProvinceFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  parentId?: InputMaybe<IdOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ProvinceList = PaginatedList & {
  __typename?: 'ProvinceList';
  items: Array<Province>;
  totalItems: Scalars['Int']['output'];
};

export type ProvinceListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ProvinceFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ProvinceSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProvinceSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProvinceTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Returned if the specified quantity of an OrderLine is greater than the number of items in that line */
export type QuantityTooGreatError = ErrorResult & {
  __typename?: 'QuantityTooGreatError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  FetchCustomerLocations: CustomerLocationList;
  activeAdministrator?: Maybe<Administrator>;
  activeChannel: Channel;
  administrator?: Maybe<Administrator>;
  administrators: AdministratorList;
  allowCurbsideDelivery?: Maybe<Scalars['Boolean']['output']>;
  appDownloads?: Maybe<Array<Maybe<AppDownload>>>;
  /** Get a single Asset by id */
  asset?: Maybe<Asset>;
  /** Get a list of Assets */
  assets: AssetList;
  availableOrderExportStrategies: Array<Scalars['String']['output']>;
  campaign?: Maybe<Campaign>;
  campaignLogs: Array<CampaignLog>;
  campaigns: CampaignList;
  canAcceptPromotion?: Maybe<Scalars['Boolean']['output']>;
  canRejectPromotion?: Maybe<Scalars['Boolean']['output']>;
  career?: Maybe<Career>;
  careers: CareerList;
  channel?: Maybe<Channel>;
  channels: ChannelList;
  checkVoidablePayment?: Maybe<Scalars['Boolean']['output']>;
  /** Get a Collection either by id or slug. If neither id nor slug is specified, an error will result. */
  collection?: Maybe<Collection>;
  collectionFilters: Array<ConfigurableOperationDefinition>;
  collections: CollectionList;
  countries: CountryList;
  country?: Maybe<Country>;
  customer?: Maybe<Customer>;
  customerAnalyticsMetricsSummary: CustomerMetricSummary;
  customerGroup?: Maybe<CustomerGroup>;
  customerGroups: CustomerGroupList;
  customers: CustomerList;
  doorDashStoreState: Scalars['Boolean']['output'];
  doordashDeliveryCancelState: Scalars['Boolean']['output'];
  dripCampaign?: Maybe<DripCampaign>;
  dripCampaigns: Array<DripCampaign>;
  /** Returns a list of eligible shipping methods for the draft Order */
  eligibleShippingMethodsForDraftOrder: Array<ShippingMethodQuote>;
  /** Returns all configured EntityDuplicators. */
  entityDuplicators: Array<EntityDuplicatorDefinition>;
  extendedCustomers: CustomerList;
  facet?: Maybe<Facet>;
  facetValues: FacetValueList;
  facets: FacetList;
  feedback?: Maybe<Feedback>;
  feedbacks: FeedbackList;
  filteredAppUsers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fulfillmentHandlers: Array<ConfigurableOperationDefinition>;
  generateDashboardEmbedUrls: Array<MetabaseDashboard>;
  getAppTemplates: EmailTemplateList;
  getAvailableCars: Array<CarDetails>;
  getEmailTemplates: EmailTemplateList;
  getFilteredOrdersByDay: Array<FilteredOrdersByDay>;
  getMarketingEmailTemplate: EmailTemplateList;
  getMarketingTemplateById?: Maybe<EmailTemplate>;
  getMarketingTemplateByName?: Maybe<EmailTemplate>;
  getMarketingTemplates: EmailTemplateList;
  getPhoneTemplates: EmailTemplateList;
  getPositouchServerNumber: Scalars['String']['output'];
  getPromotionEmailTemplate: EmailTemplateList;
  globalSettings: GlobalSettings;
  googleAppReviews?: Maybe<Array<Maybe<AppReview>>>;
  googleReviews?: Maybe<Array<Maybe<GoogleReview>>>;
  iosAppReviews?: Maybe<Array<Maybe<AppReview>>>;
  isPositouchFailed: Scalars['Boolean']['output'];
  job?: Maybe<Job>;
  jobBufferSize: Array<JobBufferSize>;
  jobQueues: Array<JobQueue>;
  jobs: JobList;
  jobsById: Array<Job>;
  listAllDoordashOrders: DoorDashOrderList;
  listDoordashOrder?: Maybe<DoorDashOrder>;
  me?: Maybe<CurrentUser>;
  /** Get metrics for the given interval and metric types. */
  metricSummary: Array<MetricSummary>;
  order?: Maybe<Order>;
  orderAnalyticsMetricsSummary: OrderMetricSummary;
  orderLine?: Maybe<OrderLine>;
  orderLines?: Maybe<Array<OrderLine>>;
  orderLinesFromOrder?: Maybe<Array<OrderLine>>;
  orders: OrderList;
  page: Page;
  pages: PageList;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodEligibilityCheckers: Array<ConfigurableOperationDefinition>;
  paymentMethodHandlers: Array<ConfigurableOperationDefinition>;
  paymentMethods: PaymentMethodList;
  pendingSearchIndexUpdates: Scalars['Int']['output'];
  /** Used for real-time previews of the contents of a Collection */
  previewCollectionVariants: ProductVariantList;
  /** Get a Product either by id or slug. If neither id nor slug is specified, an error will result. */
  product?: Maybe<Product>;
  productOptionGroup?: Maybe<ProductOptionGroup>;
  productOptionGroups: Array<ProductOptionGroup>;
  productReview?: Maybe<ProductReview>;
  productReviews: ProductReviewList;
  /** Get a ProductVariant by id */
  productVariant?: Maybe<ProductVariant>;
  /** List ProductVariants either all or for the specific product. */
  productVariants: ProductVariantList;
  /** List Products */
  products: ProductList;
  promotion?: Maybe<Promotion>;
  promotionActions: Array<ConfigurableOperationDefinition>;
  promotionConditions: Array<ConfigurableOperationDefinition>;
  promotions: PromotionList;
  province?: Maybe<Province>;
  provinces: ProvinceList;
  retryPosi?: Maybe<RetryPosiResponse>;
  role?: Maybe<Role>;
  roles: RoleList;
  scheduledTasks: Array<ScheduledTask>;
  search: SearchResponse;
  searchProductVariants: CustomSearchResponse;
  seller?: Maybe<Seller>;
  sellers: SellerList;
  shippingCalculators: Array<ConfigurableOperationDefinition>;
  shippingEligibilityCheckers: Array<ConfigurableOperationDefinition>;
  shippingMethod?: Maybe<ShippingMethod>;
  shippingMethods: ShippingMethodList;
  stockLocation?: Maybe<StockLocation>;
  stockLocations: StockLocationList;
  tag: Tag;
  tags: TagList;
  taxCategories: TaxCategoryList;
  taxCategory?: Maybe<TaxCategory>;
  taxRate?: Maybe<TaxRate>;
  taxRates: TaxRateList;
  testEligibleShippingMethods: Array<ShippingMethodQuote>;
  testPosi?: Maybe<Scalars['String']['output']>;
  testPosiHealth?: Maybe<Scalars['String']['output']>;
  testShippingMethod: TestShippingMethodResult;
  timeSlot: TimeSlot;
  timeSlots: TimeSlotList;
  totalLoyaltyPointsAvailable: Scalars['Float']['output'];
  zone?: Maybe<Zone>;
  zones: ZoneList;
};


export type QueryFetchCustomerLocationsArgs = {
  options: CustomerListInput;
};


export type QueryAdministratorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdministratorsArgs = {
  options?: InputMaybe<AdministratorListOptions>;
};


export type QueryAppDownloadsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryAssetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssetsArgs = {
  options?: InputMaybe<AssetListOptions>;
};


export type QueryCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCampaignLogsArgs = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCampaignsArgs = {
  options?: InputMaybe<CampaignListOptions>;
};


export type QueryCanAcceptPromotionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCanRejectPromotionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCareerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCareersArgs = {
  options?: InputMaybe<CareerListOptions>;
};


export type QueryChannelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChannelsArgs = {
  options?: InputMaybe<ChannelListOptions>;
};


export type QueryCheckVoidablePaymentArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryCollectionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCollectionsArgs = {
  options?: InputMaybe<CollectionListOptions>;
};


export type QueryCountriesArgs = {
  options?: InputMaybe<CountryListOptions>;
};


export type QueryCountryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerAnalyticsMetricsSummaryArgs = {
  input: CustomerAnalyticsSummaryInput;
};


export type QueryCustomerGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerGroupsArgs = {
  options?: InputMaybe<CustomerGroupListOptions>;
};


export type QueryCustomersArgs = {
  options?: InputMaybe<CustomerListOptions>;
};


export type QueryDoorDashStoreStateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDoordashDeliveryCancelStateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDripCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEligibleShippingMethodsForDraftOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryExtendedCustomersArgs = {
  options?: InputMaybe<CustomerListOptions>;
};


export type QueryFacetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFacetValuesArgs = {
  options?: InputMaybe<FacetValueListOptions>;
};


export type QueryFacetsArgs = {
  options?: InputMaybe<FacetListOptions>;
};


export type QueryFeedbackArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeedbacksArgs = {
  options?: InputMaybe<FeedbackListOptions>;
};


export type QueryFilteredAppUsersArgs = {
  emails: Array<Scalars['String']['input']>;
};


export type QueryGetAppTemplatesArgs = {
  options?: InputMaybe<EmailTemplateListOptions>;
};


export type QueryGetEmailTemplatesArgs = {
  options?: InputMaybe<EmailTemplateListOptions>;
};


export type QueryGetFilteredOrdersByDayArgs = {
  input: GetFilteredOrdersByDayInput;
};


export type QueryGetMarketingEmailTemplateArgs = {
  options?: InputMaybe<EmailTemplateListOptions>;
};


export type QueryGetMarketingTemplateByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMarketingTemplateByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryGetMarketingTemplatesArgs = {
  options?: InputMaybe<EmailTemplateListOptions>;
};


export type QueryGetPhoneTemplatesArgs = {
  options?: InputMaybe<EmailTemplateListOptions>;
};


export type QueryGetPromotionEmailTemplateArgs = {
  options?: InputMaybe<EmailTemplateListOptions>;
};


export type QueryIsPositouchFailedArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryJobBufferSizeArgs = {
  bufferIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryJobsArgs = {
  options?: InputMaybe<JobListOptions>;
};


export type QueryJobsByIdArgs = {
  jobIds: Array<Scalars['ID']['input']>;
};


export type QueryListAllDoordashOrdersArgs = {
  pagination: PaginationInput;
};


export type QueryListDoordashOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMetricSummaryArgs = {
  input?: InputMaybe<MetricSummaryInput>;
};


export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderAnalyticsMetricsSummaryArgs = {
  input: OrderAnalyticsSummaryInput;
};


export type QueryOrderLineArgs = {
  orderLineId: Scalars['ID']['input'];
};


export type QueryOrderLinesArgs = {
  orderLineIds: Array<Scalars['ID']['input']>;
};


export type QueryOrderLinesFromOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryOrdersArgs = {
  options?: InputMaybe<OrderListOptions>;
};


export type QueryPageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPagesArgs = {
  options?: InputMaybe<PageListOptions>;
};


export type QueryPaymentMethodArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentMethodsArgs = {
  options?: InputMaybe<PaymentMethodListOptions>;
};


export type QueryPreviewCollectionVariantsArgs = {
  input: PreviewCollectionVariantsInput;
  options?: InputMaybe<ProductVariantListOptions>;
};


export type QueryProductArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductOptionGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductOptionGroupsArgs = {
  filterTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductReviewsArgs = {
  options?: InputMaybe<ProductReviewListOptions>;
};


export type QueryProductVariantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductVariantsArgs = {
  options?: InputMaybe<ProductVariantListOptions>;
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductsArgs = {
  options?: InputMaybe<ProductListOptions>;
};


export type QueryPromotionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPromotionsArgs = {
  options?: InputMaybe<PromotionListOptions>;
};


export type QueryProvinceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProvincesArgs = {
  options?: InputMaybe<ProvinceListOptions>;
};


export type QueryRetryPosiArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRolesArgs = {
  options?: InputMaybe<RoleListOptions>;
};


export type QuerySearchArgs = {
  input: SearchInput;
};


export type QuerySearchProductVariantsArgs = {
  take?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
};


export type QuerySellerArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySellersArgs = {
  options?: InputMaybe<SellerListOptions>;
};


export type QueryShippingMethodArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShippingMethodsArgs = {
  options?: InputMaybe<ShippingMethodListOptions>;
};


export type QueryStockLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStockLocationsArgs = {
  options?: InputMaybe<StockLocationListOptions>;
};


export type QueryTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTagsArgs = {
  options?: InputMaybe<TagListOptions>;
};


export type QueryTaxCategoriesArgs = {
  options?: InputMaybe<TaxCategoryListOptions>;
};


export type QueryTaxCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaxRateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaxRatesArgs = {
  options?: InputMaybe<TaxRateListOptions>;
};


export type QueryTestEligibleShippingMethodsArgs = {
  input: TestEligibleShippingMethodsInput;
};


export type QueryTestPosiArgs = {
  api: Scalars['String']['input'];
  endpoint: Scalars['String']['input'];
};


export type QueryTestShippingMethodArgs = {
  input: TestShippingMethodInput;
};


export type QueryTimeSlotArgs = {
  id: Scalars['String']['input'];
};


export type QueryTimeSlotsArgs = {
  options?: InputMaybe<TimeSlotListOptions>;
};


export type QueryZoneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryZonesArgs = {
  options?: InputMaybe<ZoneListOptions>;
};

export type Refund = Node & {
  __typename?: 'Refund';
  adjustment: Scalars['Money']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  items: Scalars['Money']['output'];
  lines: Array<RefundLine>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  paymentId: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  shipping: Scalars['Money']['output'];
  state: Scalars['String']['output'];
  total: Scalars['Money']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Returned if `amount` is greater than the maximum un-refunded amount of the Payment */
export type RefundAmountError = ErrorResult & {
  __typename?: 'RefundAmountError';
  errorCode: ErrorCode;
  maximumRefundable: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type RefundLine = {
  __typename?: 'RefundLine';
  orderLine: OrderLine;
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  refund: Refund;
  refundId: Scalars['ID']['output'];
};

export type RefundOrderInput = {
  /**
   * The amount to be refunded to this particular payment. This was introduced in v2.2.0 as the preferred way to specify the refund amount.
   * Can be as much as the total amount of the payment minus the sum of all previous refunds.
   */
  amount?: InputMaybe<Scalars['Money']['input']>;
  paymentId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RefundOrderResult = AlreadyRefundedError | MultipleOrderError | NothingToRefundError | OrderStateTransitionError | PaymentOrderMismatchError | QuantityTooGreatError | Refund | RefundAmountError | RefundOrderStateError | RefundStateTransitionError;

/** Returned if an attempting to refund an Order which is not in the expected state */
export type RefundOrderStateError = ErrorResult & {
  __typename?: 'RefundOrderStateError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  orderState: Scalars['String']['output'];
};

/**
 * Returned when a call to modifyOrder fails to include a refundPaymentId even
 * though the price has decreased as a result of the changes.
 */
export type RefundPaymentIdMissingError = ErrorResult & {
  __typename?: 'RefundPaymentIdMissingError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned when there is an error in transitioning the Refund state */
export type RefundStateTransitionError = ErrorResult & {
  __typename?: 'RefundStateTransitionError';
  errorCode: ErrorCode;
  fromState: Scalars['String']['output'];
  message: Scalars['String']['output'];
  toState: Scalars['String']['output'];
  transitionError: Scalars['String']['output'];
};

export type Region = {
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  parent?: Maybe<Region>;
  parentId?: Maybe<Scalars['ID']['output']>;
  translations: Array<RegionTranslation>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RegionTranslation = {
  __typename?: 'RegionTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RelationCustomFieldConfig = CustomField & {
  __typename?: 'RelationCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  entity: Scalars['String']['output'];
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  scalarFields: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type Release = Node & StockMovement & {
  __typename?: 'Release';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  type: StockMovementType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RemoveCollectionsFromChannelInput = {
  channelId: Scalars['ID']['input'];
  collectionIds: Array<Scalars['ID']['input']>;
};

export type RemoveFacetFromChannelResult = Facet | FacetInUseError;

export type RemoveFacetsFromChannelInput = {
  channelId: Scalars['ID']['input'];
  facetIds: Array<Scalars['ID']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoveOptionGroupFromProductResult = Product | ProductOptionInUseError;

export type RemoveOrderItemsResult = Order | OrderInterceptorError | OrderModificationError;

export type RemovePaymentMethodsFromChannelInput = {
  channelId: Scalars['ID']['input'];
  paymentMethodIds: Array<Scalars['ID']['input']>;
};

export type RemoveProductVariantsFromChannelInput = {
  channelId: Scalars['ID']['input'];
  productVariantIds: Array<Scalars['ID']['input']>;
};

export type RemoveProductsFromChannelInput = {
  channelId: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};

export type RemovePromotionsFromChannelInput = {
  channelId: Scalars['ID']['input'];
  promotionIds: Array<Scalars['ID']['input']>;
};

export type RemoveShippingMethodsFromChannelInput = {
  channelId: Scalars['ID']['input'];
  shippingMethodIds: Array<Scalars['ID']['input']>;
};

export type RemoveStockLocationsFromChannelInput = {
  channelId: Scalars['ID']['input'];
  stockLocationIds: Array<Scalars['ID']['input']>;
};

export type Return = Node & StockMovement & {
  __typename?: 'Return';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  type: StockMovementType;
  updatedAt: Scalars['DateTime']['output'];
};

export type Role = Node & {
  __typename?: 'Role';
  channels: Array<Channel>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  permissions: Array<Permission>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RoleFilterParameter = {
  _and?: InputMaybe<Array<RoleFilterParameter>>;
  _or?: InputMaybe<Array<RoleFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type RoleList = PaginatedList & {
  __typename?: 'RoleList';
  items: Array<Role>;
  totalItems: Scalars['Int']['output'];
};

export type RoleListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<RoleFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<RoleSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type RoleSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type Sale = Node & StockMovement & {
  __typename?: 'Sale';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  type: StockMovementType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ScheduledTask = {
  __typename?: 'ScheduledTask';
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isRunning: Scalars['Boolean']['output'];
  lastExecutedAt?: Maybe<Scalars['DateTime']['output']>;
  lastResult?: Maybe<Scalars['JSON']['output']>;
  nextExecutionAt?: Maybe<Scalars['DateTime']['output']>;
  schedule: Scalars['String']['output'];
  scheduleDescription: Scalars['String']['output'];
};

export type SearchInput = {
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  collectionSlug?: InputMaybe<Scalars['String']['input']>;
  facetValueFilters?: InputMaybe<Array<FacetValueFilterInput>>;
  groupByProduct?: InputMaybe<Scalars['Boolean']['input']>;
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SearchResultSortParameter>;
  take?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type SearchReindexResponse = {
  __typename?: 'SearchReindexResponse';
  success: Scalars['Boolean']['output'];
};

export type SearchResponse = {
  __typename?: 'SearchResponse';
  collections: Array<CollectionResult>;
  facetValues: Array<FacetValueResult>;
  items: Array<SearchResult>;
  totalItems: Scalars['Int']['output'];
};

export type SearchResult = {
  __typename?: 'SearchResult';
  /** An array of ids of the Channels in which this result appears */
  channelIds: Array<Scalars['ID']['output']>;
  /** An array of ids of the Collections in which this result appears */
  collectionIds: Array<Scalars['ID']['output']>;
  currencyCode: CurrencyCode;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  facetIds: Array<Scalars['ID']['output']>;
  facetValueIds: Array<Scalars['ID']['output']>;
  inStock: Scalars['Boolean']['output'];
  price: SearchResultPrice;
  priceWithTax: SearchResultPrice;
  productAsset?: Maybe<SearchResultAsset>;
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  productVariantAsset?: Maybe<SearchResultAsset>;
  productVariantId: Scalars['ID']['output'];
  productVariantName: Scalars['String']['output'];
  /** A relevance score for the result. Differs between database implementations */
  score: Scalars['Float']['output'];
  sku: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type SearchResultAsset = {
  __typename?: 'SearchResultAsset';
  focalPoint?: Maybe<Coordinate>;
  id: Scalars['ID']['output'];
  preview: Scalars['String']['output'];
};

/** The price of a search result product, either as a range or as a single price */
export type SearchResultPrice = PriceRange | SinglePrice;

export type SearchResultSortParameter = {
  name?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
};

export type Seller = Node & {
  __typename?: 'Seller';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SellerFilterParameter = {
  _and?: InputMaybe<Array<SellerFilterParameter>>;
  _or?: InputMaybe<Array<SellerFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type SellerList = PaginatedList & {
  __typename?: 'SellerList';
  items: Array<Seller>;
  totalItems: Scalars['Int']['output'];
};

export type SellerListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<SellerFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<SellerSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type SellerSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SendAllCustomerMessageInput = {
  email: Scalars['Boolean']['input'];
  emailTemplateName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['Boolean']['input'];
  phoneTemplateName?: InputMaybe<Scalars['String']['input']>;
};

export type SendFeedbackRewardToCustomerInput = {
  actions?: InputMaybe<Array<ConfigurableOperationInput>>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  sendVia: SendViaInput;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SendViaInput = {
  email?: InputMaybe<Scalars['Boolean']['input']>;
  inApp?: InputMaybe<Scalars['Boolean']['input']>;
  manually?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServerConfig = {
  __typename?: 'ServerConfig';
  /**
   * This field is deprecated in v2.2 in favor of the entityCustomFields field,
   * which allows custom fields to be defined on user-supplies entities.
   */
  customFieldConfig: CustomFields;
  entityCustomFields: Array<EntityCustomFields>;
  moneyStrategyPrecision: Scalars['Int']['output'];
  orderProcess: Array<OrderProcessState>;
  permissions: Array<PermissionDefinition>;
  permittedAssetTypes: Array<Scalars['String']['output']>;
};

export type SetCustomerForDraftOrderResult = EmailAddressConflictError | Order;

export type SetOrderCustomerInput = {
  customerId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};

export type SetOrderShippingMethodResult = IneligibleShippingMethodError | NoActiveOrderError | Order | OrderModificationError;

/** Returned if the Payment settlement fails */
export type SettlePaymentError = ErrorResult & {
  __typename?: 'SettlePaymentError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  paymentErrorMessage: Scalars['String']['output'];
};

export type SettlePaymentResult = OrderStateTransitionError | Payment | PaymentStateTransitionError | SettlePaymentError;

export type SettleRefundInput = {
  id: Scalars['ID']['input'];
  transactionId: Scalars['String']['input'];
};

export type SettleRefundResult = Refund | RefundStateTransitionError;

export type ShippingLine = {
  __typename?: 'ShippingLine';
  customFields?: Maybe<Scalars['JSON']['output']>;
  discountedPrice: Scalars['Money']['output'];
  discountedPriceWithTax: Scalars['Money']['output'];
  discounts: Array<Discount>;
  id: Scalars['ID']['output'];
  price: Scalars['Money']['output'];
  priceWithTax: Scalars['Money']['output'];
  shippingMethod: ShippingMethod;
};

export type ShippingMethod = Node & {
  __typename?: 'ShippingMethod';
  calculator: ConfigurableOperation;
  checker: ConfigurableOperation;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  fulfillmentHandlerCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  translations: Array<ShippingMethodTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ShippingMethodFilterParameter = {
  _and?: InputMaybe<Array<ShippingMethodFilterParameter>>;
  _or?: InputMaybe<Array<ShippingMethodFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  fulfillmentHandlerCode?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ShippingMethodList = PaginatedList & {
  __typename?: 'ShippingMethodList';
  items: Array<ShippingMethod>;
  totalItems: Scalars['Int']['output'];
};

export type ShippingMethodListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ShippingMethodFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ShippingMethodSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ShippingMethodQuote = {
  __typename?: 'ShippingMethodQuote';
  code: Scalars['String']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Any optional metadata returned by the ShippingCalculator in the ShippingCalculationResult */
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Money']['output'];
  priceWithTax: Scalars['Money']['output'];
};

export type ShippingMethodSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  fulfillmentHandlerCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ShippingMethodTranslation = {
  __typename?: 'ShippingMethodTranslation';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShippingMethodTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The price value where the result has a single price */
export type SinglePrice = {
  __typename?: 'SinglePrice';
  value: Scalars['Money']['output'];
};

export type Slot = {
  __typename?: 'Slot';
  currentOrders: Scalars['Int']['output'];
  maxOrders: Scalars['Int']['output'];
  time: Scalars['String']['output'];
};

export type SlotInput = {
  currentOrders?: InputMaybe<Scalars['Int']['input']>;
  maxOrders: Scalars['Int']['input'];
  time: Scalars['String']['input'];
};

export type SortInput = {
  direction: SortOrder;
  field: Scalars['String']['input'];
};

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type StockAdjustment = Node & StockMovement & {
  __typename?: 'StockAdjustment';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  type: StockMovementType;
  updatedAt: Scalars['DateTime']['output'];
};

export type StockLevel = Node & {
  __typename?: 'StockLevel';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  stockAllocated: Scalars['Int']['output'];
  stockLocation: StockLocation;
  stockLocationId: Scalars['ID']['output'];
  stockOnHand: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type StockLevelInput = {
  stockLocationId: Scalars['ID']['input'];
  stockOnHand: Scalars['Int']['input'];
};

export type StockLocation = Node & {
  __typename?: 'StockLocation';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type StockLocationFilterParameter = {
  _and?: InputMaybe<Array<StockLocationFilterParameter>>;
  _or?: InputMaybe<Array<StockLocationFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type StockLocationList = PaginatedList & {
  __typename?: 'StockLocationList';
  items: Array<StockLocation>;
  totalItems: Scalars['Int']['output'];
};

export type StockLocationListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<StockLocationFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<StockLocationSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type StockLocationSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StockMovement = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  productVariant: ProductVariant;
  quantity: Scalars['Int']['output'];
  type: StockMovementType;
  updatedAt: Scalars['DateTime']['output'];
};

export type StockMovementItem = Allocation | Cancellation | Release | Return | Sale | StockAdjustment;

export type StockMovementList = {
  __typename?: 'StockMovementList';
  items: Array<StockMovementItem>;
  totalItems: Scalars['Int']['output'];
};

export type StockMovementListOptions = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<StockMovementType>;
};

export enum StockMovementType {
  ADJUSTMENT = 'ADJUSTMENT',
  ALLOCATION = 'ALLOCATION',
  CANCELLATION = 'CANCELLATION',
  RELEASE = 'RELEASE',
  RETURN = 'RETURN',
  SALE = 'SALE'
}

export type StringCustomFieldConfig = CustomField & {
  __typename?: 'StringCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  length?: Maybe<Scalars['Int']['output']>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<StringFieldOption>>;
  pattern?: Maybe<Scalars['String']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type StringFieldOption = {
  __typename?: 'StringFieldOption';
  label?: Maybe<Array<LocalizedString>>;
  value: Scalars['String']['output'];
};

/** Operators for filtering on a list of String fields */
export type StringListOperators = {
  inList: Scalars['String']['input'];
};

/** Operators for filtering on a String field */
export type StringOperators = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type StringStructFieldConfig = StructField & {
  __typename?: 'StringStructFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  label?: Maybe<Array<LocalizedString>>;
  length?: Maybe<Scalars['Int']['output']>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<StringFieldOption>>;
  pattern?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type StructCustomFieldConfig = CustomField & {
  __typename?: 'StructCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  fields: Array<StructFieldConfig>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type StructField = {
  description?: Maybe<Array<LocalizedString>>;
  label?: Maybe<Array<LocalizedString>>;
  list?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type StructFieldConfig = BooleanStructFieldConfig | DateTimeStructFieldConfig | FloatStructFieldConfig | IntStructFieldConfig | StringStructFieldConfig | TextStructFieldConfig;

/** Indicates that an operation succeeded, where we do not want to return any more specific information. */
export type Success = {
  __typename?: 'Success';
  success: Scalars['Boolean']['output'];
};

export type Surcharge = Node & {
  __typename?: 'Surcharge';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  price: Scalars['Money']['output'];
  priceWithTax: Scalars['Money']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  taxLines: Array<TaxLine>;
  taxRate: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SurchargeInput = {
  description: Scalars['String']['input'];
  price: Scalars['Money']['input'];
  priceIncludesTax: Scalars['Boolean']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  taxDescription?: InputMaybe<Scalars['String']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
};

export type Tag = Node & {
  __typename?: 'Tag';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type TagFilterParameter = {
  _and?: InputMaybe<Array<TagFilterParameter>>;
  _or?: InputMaybe<Array<TagFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  value?: InputMaybe<StringOperators>;
};

export type TagList = PaginatedList & {
  __typename?: 'TagList';
  items: Array<Tag>;
  totalItems: Scalars['Int']['output'];
};

export type TagListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<TagFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<TagSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type TagSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type TaxCategory = Node & {
  __typename?: 'TaxCategory';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TaxCategoryFilterParameter = {
  _and?: InputMaybe<Array<TaxCategoryFilterParameter>>;
  _or?: InputMaybe<Array<TaxCategoryFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  isDefault?: InputMaybe<BooleanOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type TaxCategoryList = PaginatedList & {
  __typename?: 'TaxCategoryList';
  items: Array<TaxCategory>;
  totalItems: Scalars['Int']['output'];
};

export type TaxCategoryListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<TaxCategoryFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<TaxCategorySortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type TaxCategorySortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TaxLine = {
  __typename?: 'TaxLine';
  description: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
};

export type TaxRate = Node & {
  __typename?: 'TaxRate';
  category: TaxCategory;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  customerGroup?: Maybe<CustomerGroup>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
  zone: Zone;
};

export type TaxRateFilterParameter = {
  _and?: InputMaybe<Array<TaxRateFilterParameter>>;
  _or?: InputMaybe<Array<TaxRateFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  value?: InputMaybe<NumberOperators>;
};

export type TaxRateList = PaginatedList & {
  __typename?: 'TaxRateList';
  items: Array<TaxRate>;
  totalItems: Scalars['Int']['output'];
};

export type TaxRateListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<TaxRateFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<TaxRateSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type TaxRateSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export enum TemplateEnum {
  APP = 'APP',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE'
}

export type TestEligibleShippingMethodsInput = {
  lines: Array<TestShippingMethodOrderLineInput>;
  shippingAddress: CreateAddressInput;
};

export type TestShippingMethodInput = {
  calculator: ConfigurableOperationInput;
  checker: ConfigurableOperationInput;
  lines: Array<TestShippingMethodOrderLineInput>;
  shippingAddress: CreateAddressInput;
};

export type TestShippingMethodOrderLineInput = {
  productVariantId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type TestShippingMethodQuote = {
  __typename?: 'TestShippingMethodQuote';
  metadata?: Maybe<Scalars['JSON']['output']>;
  price: Scalars['Money']['output'];
  priceWithTax: Scalars['Money']['output'];
};

export type TestShippingMethodResult = {
  __typename?: 'TestShippingMethodResult';
  eligible: Scalars['Boolean']['output'];
  quote?: Maybe<TestShippingMethodQuote>;
};

export type TextCustomFieldConfig = CustomField & {
  __typename?: 'TextCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type TextStructFieldConfig = StructField & {
  __typename?: 'TextStructFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type TimeSlot = Node & {
  __typename?: 'TimeSlot';
  channel: Channel;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  slots: Array<Slot>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TimeSlotFilterParameter = {
  _and?: InputMaybe<Array<TimeSlotFilterParameter>>;
  _or?: InputMaybe<Array<TimeSlotFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  date?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type TimeSlotList = PaginatedList & {
  __typename?: 'TimeSlotList';
  items: Array<TimeSlot>;
  totalItems: Scalars['Int']['output'];
};

export type TimeSlotListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<TimeSlotFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<TimeSlotSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeSlotSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TransitionFulfillmentToStateResult = Fulfillment | FulfillmentStateTransitionError;

export type TransitionOrderToStateResult = Order | OrderStateTransitionError;

export type TransitionPaymentToStateResult = Payment | PaymentStateTransitionError;

export type UpdateActiveAdministratorInput = {
  customFields?: InputMaybe<UpdateAdministratorCustomFieldsInput>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAddressCustomFieldsInput = {
  addressTag?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input used to update an Address.
 *
 * The countryCode must correspond to a `code` property of a Country that has been defined in the
 * Vendure server. The `code` property is typically a 2-character ISO code such as "GB", "US", "DE" etc.
 * If an invalid code is passed, the mutation will fail.
 */
export type UpdateAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<UpdateAddressCustomFieldsInput>;
  defaultBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  defaultShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  streetLine1?: InputMaybe<Scalars['String']['input']>;
  streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdministratorCustomFieldsInput = {
  fcmToken?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdministratorInput = {
  customFields?: InputMaybe<UpdateAdministratorCustomFieldsInput>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateAssetInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  focalPoint?: InputMaybe<CoordinateInput>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateChannelCustomFieldsInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  allowFeedbackAdminEmail?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  backUpDoorDashURL?: InputMaybe<Scalars['String']['input']>;
  backUpPaytronixURL?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cloverAccessToken?: InputMaybe<Scalars['String']['input']>;
  cloverLocationId?: InputMaybe<Scalars['String']['input']>;
  cloverTenderName?: InputMaybe<Scalars['String']['input']>;
  curbSideOperationTimes?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceNumber?: InputMaybe<Scalars['String']['input']>;
  disableOrderMinutesBeforeClosing?: InputMaybe<Scalars['Int']['input']>;
  doordashExternalId?: InputMaybe<Scalars['String']['input']>;
  doordashOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  driveInOperationTimes?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  enableAlACarte?: InputMaybe<Scalars['Boolean']['input']>;
  enableCateringOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableCurbsidePickUp?: InputMaybe<Scalars['Boolean']['input']>;
  enableDripCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  enableHolidayOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableHolidayTimeSlot?: InputMaybe<Scalars['Boolean']['input']>;
  enableMakeAMeal?: InputMaybe<Scalars['Boolean']['input']>;
  isAlwaysOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isInactive?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  popUpTerminalNumber?: InputMaybe<Scalars['String']['input']>;
  positouchAdminEmail?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  sendHolidayOrderEmailAfterPlacement?: InputMaybe<Scalars['Int']['input']>;
  sendHolidayOrderEmailDurationBeforePickup?: InputMaybe<Scalars['Int']['input']>;
  sendToCloverPOS?: InputMaybe<Scalars['Boolean']['input']>;
  sendToXMLPOS?: InputMaybe<Scalars['Boolean']['input']>;
  shift4AccessToken?: InputMaybe<Scalars['String']['input']>;
  shift4AuthToken?: InputMaybe<Scalars['String']['input']>;
  storeBasedTax?: InputMaybe<Array<ChannelStoreBasedTaxStructInput>>;
  storeIp?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
  streetLine1?: InputMaybe<Scalars['String']['input']>;
  streetLine2?: InputMaybe<Scalars['String']['input']>;
  welcomeMessageBody?: InputMaybe<Scalars['String']['input']>;
  welcomeMessageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeMessageFrom?: InputMaybe<Scalars['String']['input']>;
  welcomeMessageIconId?: InputMaybe<Scalars['ID']['input']>;
  welcomeMessageTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChannelInput = {
  availableCurrencyCodes?: InputMaybe<Array<CurrencyCode>>;
  availableLanguageCodes?: InputMaybe<Array<LanguageCode>>;
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<UpdateChannelCustomFieldsInput>;
  defaultCurrencyCode?: InputMaybe<CurrencyCode>;
  defaultLanguageCode?: InputMaybe<LanguageCode>;
  defaultShippingZoneId?: InputMaybe<Scalars['ID']['input']>;
  defaultTaxZoneId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  outOfStockThreshold?: InputMaybe<Scalars['Int']['input']>;
  pricesIncludeTax?: InputMaybe<Scalars['Boolean']['input']>;
  sellerId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateChannelResult = Channel | LanguageNotAvailableError;

export type UpdateCollectionCustomFieldsInput = {
  availableDates?: InputMaybe<Array<Scalars['String']['input']>>;
  availableDays?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringAvailableDates?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringAvailableDays?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringCutOffDates?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringCutOffDays?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringShowIfNotAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  cutOffDates?: InputMaybe<Array<Scalars['String']['input']>>;
  cutOffDays?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayAvailableDates?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayAvailableDays?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayCutOffDates?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayCutOffDays?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayShowIfNotAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isAlACarteBreadRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isAlACarteSauceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isAlACarteSideRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isCateringCollection?: InputMaybe<Scalars['Boolean']['input']>;
  isHolidayCollection?: InputMaybe<Scalars['Boolean']['input']>;
  isMakeAMeakSauceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isMakeAMealBreadRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isMakeAMealSideRequired?: InputMaybe<Scalars['Boolean']['input']>;
  showIfNotAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  showInDeals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCollectionInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customFields?: InputMaybe<UpdateCollectionCustomFieldsInput>;
  featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<Array<ConfigurableOperationInput>>;
  id: Scalars['ID']['input'];
  inheritFilters?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  translations?: InputMaybe<Array<UpdateCollectionTranslationInput>>;
};

export type UpdateCollectionTranslationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCountryInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  translations?: InputMaybe<Array<CountryTranslationInput>>;
};

export type UpdateCurbsidePickupInput = {
  alreadyHere?: InputMaybe<Scalars['Boolean']['input']>;
  orderCode: Scalars['String']['input'];
  pickupSpot: Scalars['String']['input'];
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerCustomFieldsInput = {
  claimSignUpRewardLater?: InputMaybe<Scalars['Boolean']['input']>;
  cloverCustomerIds?: InputMaybe<Scalars['String']['input']>;
  cumulativePoints?: InputMaybe<Scalars['Int']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  lastScratchDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastSpinDate?: InputMaybe<Scalars['DateTime']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  loyaltyCodes?: InputMaybe<Array<CustomerLoyaltyCodesStructInput>>;
  loyaltyPoints?: InputMaybe<Scalars['Int']['input']>;
  loyaltyTier?: InputMaybe<Scalars['String']['input']>;
  marketingUserID?: InputMaybe<Scalars['String']['input']>;
  signUpRewardClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  topMostFavoriteLocation?: InputMaybe<Scalars['String']['input']>;
  topMostFavoriteRestaurantId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCustomerGroupInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerInput = {
  customFields?: InputMaybe<UpdateCustomerCustomFieldsInput>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerNoteInput = {
  note: Scalars['String']['input'];
  noteId: Scalars['ID']['input'];
};

export type UpdateCustomerResult = Customer | EmailAddressConflictError;

export type UpdateDripCampaignInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<Array<DripStepInput>>;
};

export type UpdateEmailTemplateInput = {
  id: Scalars['Int']['input'];
  status: Scalars['Boolean']['input'];
};

export type UpdateFacetInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<Array<FacetTranslationInput>>;
};

export type UpdateFacetValueInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  translations?: InputMaybe<Array<FacetValueTranslationInput>>;
};

export type UpdateGlobalSettingsCustomFieldsInput = {
  cateringTierOneConversionToDollar?: InputMaybe<Scalars['Float']['input']>;
  cateringTierOneConversionToPoints?: InputMaybe<Scalars['Float']['input']>;
  cateringTierThreeConversionToDollar?: InputMaybe<Scalars['Float']['input']>;
  cateringTierThreeConversionToPoints?: InputMaybe<Scalars['Float']['input']>;
  cateringTierTwoConversionToDollar?: InputMaybe<Scalars['Float']['input']>;
  cateringTierTwoConversionToPoints?: InputMaybe<Scalars['Float']['input']>;
  curbsideNumber?: InputMaybe<Scalars['String']['input']>;
  doordashBusinessId?: InputMaybe<Scalars['String']['input']>;
  dripCampaigns?: InputMaybe<Array<GlobalSettingsDripCampaignsStructInput>>;
  enableAlACarte?: InputMaybe<Scalars['Boolean']['input']>;
  enableCateringOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableCurbsidePickUp?: InputMaybe<Scalars['Boolean']['input']>;
  enableHolidayOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  enableMakeAMeal?: InputMaybe<Scalars['Boolean']['input']>;
  enablePOSStatusEmail?: InputMaybe<Scalars['Boolean']['input']>;
  enableScratchPromo?: InputMaybe<Scalars['Boolean']['input']>;
  enableSpinPromo?: InputMaybe<Scalars['Boolean']['input']>;
  franchiseColor?: InputMaybe<Scalars['String']['input']>;
  franchiseEmail?: InputMaybe<Scalars['String']['input']>;
  franchiseLogoId?: InputMaybe<Scalars['ID']['input']>;
  franchiseName?: InputMaybe<Scalars['String']['input']>;
  franchiseNumber?: InputMaybe<Scalars['String']['input']>;
  heroSectionAssetId?: InputMaybe<Scalars['ID']['input']>;
  heroSectionText?: InputMaybe<Scalars['String']['input']>;
  holidayTierOneConversionToDollar?: InputMaybe<Scalars['Float']['input']>;
  holidayTierOneConversionToPoints?: InputMaybe<Scalars['Float']['input']>;
  holidayTierThreeConversionToDollar?: InputMaybe<Scalars['Float']['input']>;
  holidayTierThreeConversionToPoints?: InputMaybe<Scalars['Float']['input']>;
  holidayTierTwoConversionToDollar?: InputMaybe<Scalars['Float']['input']>;
  holidayTierTwoConversionToPoints?: InputMaybe<Scalars['Float']['input']>;
  loyaltyBreakPoints?: InputMaybe<Scalars['String']['input']>;
  loyaltyGiftExpiresInDays?: InputMaybe<Scalars['Int']['input']>;
  loyaltyPointsForAdminReferralCodeShared?: InputMaybe<Scalars['Int']['input']>;
  loyaltyPointsForAdminReferralCodeUsed?: InputMaybe<Scalars['Int']['input']>;
  loyaltyPointsForreferralCodeShared?: InputMaybe<Scalars['Int']['input']>;
  loyaltyPointsForreferralCodeUsed?: InputMaybe<Scalars['Int']['input']>;
  marketingCustomerSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  marketingPlatformAPIKey?: InputMaybe<Scalars['String']['input']>;
  marketingPlatformURL?: InputMaybe<Scalars['String']['input']>;
  memoNumber?: InputMaybe<Scalars['String']['input']>;
  mobileDiscountNumber?: InputMaybe<Scalars['String']['input']>;
  nameNumber?: InputMaybe<Scalars['String']['input']>;
  pickUpTimeNumber?: InputMaybe<Scalars['String']['input']>;
  posLoyaltyActiveMinutes?: InputMaybe<Scalars['Int']['input']>;
  positouchServerNumber?: InputMaybe<Scalars['String']['input']>;
  scratchWinningAllowedPeriod?: InputMaybe<Scalars['Int']['input']>;
  scratchesRequiredToWin?: InputMaybe<Scalars['Int']['input']>;
  serverMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  signUpLoyaltyPoints?: InputMaybe<Scalars['Int']['input']>;
  spinsRequiredToWin?: InputMaybe<Scalars['Int']['input']>;
  splashScreenImageId?: InputMaybe<Scalars['ID']['input']>;
  splashScreenText?: InputMaybe<Scalars['String']['input']>;
  supportTicketReceiverEmail?: InputMaybe<Array<Scalars['String']['input']>>;
  temporaryMenuNumber?: InputMaybe<Scalars['String']['input']>;
  terminalNumber?: InputMaybe<Scalars['String']['input']>;
  tierOne?: InputMaybe<Scalars['Int']['input']>;
  tierOneBreakPoint1Description?: InputMaybe<Scalars['String']['input']>;
  tierOneBreakPoint2Description?: InputMaybe<Scalars['String']['input']>;
  tierOneBreakPoint3Description?: InputMaybe<Scalars['String']['input']>;
  tierOneConversionToDollar?: InputMaybe<Scalars['Float']['input']>;
  tierOneConversionToPoints?: InputMaybe<Scalars['Float']['input']>;
  tierOneDescription?: InputMaybe<Scalars['String']['input']>;
  tierOneName?: InputMaybe<Scalars['String']['input']>;
  tierThree?: InputMaybe<Scalars['Int']['input']>;
  tierThreeBreakPoint1Description?: InputMaybe<Scalars['String']['input']>;
  tierThreeBreakPoint2Description?: InputMaybe<Scalars['String']['input']>;
  tierThreeBreakPoint3Description?: InputMaybe<Scalars['String']['input']>;
  tierThreeConversionToDollar?: InputMaybe<Scalars['Float']['input']>;
  tierThreeConversionToPoints?: InputMaybe<Scalars['Float']['input']>;
  tierThreeDescription?: InputMaybe<Scalars['String']['input']>;
  tierThreeName?: InputMaybe<Scalars['String']['input']>;
  tierTwo?: InputMaybe<Scalars['Int']['input']>;
  tierTwoBreakPoint1Description?: InputMaybe<Scalars['String']['input']>;
  tierTwoBreakPoint2Description?: InputMaybe<Scalars['String']['input']>;
  tierTwoBreakPoint3Description?: InputMaybe<Scalars['String']['input']>;
  tierTwoConversionToDollar?: InputMaybe<Scalars['Float']['input']>;
  tierTwoConversionToPoints?: InputMaybe<Scalars['Float']['input']>;
  tierTwoDescription?: InputMaybe<Scalars['String']['input']>;
  tierTwoName?: InputMaybe<Scalars['String']['input']>;
  tipsOptions?: InputMaybe<Array<GlobalSettingsTipsOptionsStructInput>>;
  utensilsRequiredTimeNumber?: InputMaybe<Scalars['String']['input']>;
  winningAllowedPeriod?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGlobalSettingsInput = {
  availableLanguages?: InputMaybe<Array<LanguageCode>>;
  customFields?: InputMaybe<UpdateGlobalSettingsCustomFieldsInput>;
  outOfStockThreshold?: InputMaybe<Scalars['Int']['input']>;
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateGlobalSettingsResult = ChannelDefaultLanguageError | GlobalSettings;

export type UpdateLocationInput = {
  channelId: Scalars['ID']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  streetLine1?: InputMaybe<Scalars['String']['input']>;
  streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<UpdateAddressCustomFieldsInput>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  streetLine1?: InputMaybe<Scalars['String']['input']>;
  streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderCustomFieldsInput = {
  alreadyHere?: InputMaybe<Scalars['Boolean']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  asapOrder?: InputMaybe<Scalars['Boolean']['input']>;
  carDetailsId?: InputMaybe<Scalars['ID']['input']>;
  cloverOrderId?: InputMaybe<Scalars['String']['input']>;
  deliveryRiderDasherId?: InputMaybe<Scalars['String']['input']>;
  deliveryRiderName?: InputMaybe<Scalars['String']['input']>;
  deliveryRiderNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryRiderVehicle?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  externalDoordashOrderCustomerFirstName?: InputMaybe<Scalars['String']['input']>;
  externalDoordashOrderCustomerLastName?: InputMaybe<Scalars['String']['input']>;
  externalDoordashOrderEntityId?: InputMaybe<Scalars['String']['input']>;
  freeItemVariantAddons?: InputMaybe<Scalars['String']['input']>;
  freePromoVariantAddons?: InputMaybe<Scalars['String']['input']>;
  freePromoVariantId?: InputMaybe<Scalars['String']['input']>;
  futureOrderTime?: InputMaybe<Scalars['DateTime']['input']>;
  futureOrderTimeZone?: InputMaybe<Scalars['String']['input']>;
  holidayName?: InputMaybe<Scalars['String']['input']>;
  isCloverOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isExternallyDoordashSynced?: InputMaybe<Scalars['Boolean']['input']>;
  isHolidayOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isUserRemovedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  pickupSpot?: InputMaybe<Scalars['String']['input']>;
  positouch_failure?: InputMaybe<Scalars['Boolean']['input']>;
  sentToPositouch?: InputMaybe<Scalars['Boolean']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  trackingUrl?: InputMaybe<Scalars['String']['input']>;
  typeOfDelivery?: InputMaybe<Scalars['String']['input']>;
  typeOfFullfillment?: InputMaybe<Scalars['String']['input']>;
  typeOfPickup?: InputMaybe<Scalars['String']['input']>;
  usedLoyaltyPoints?: InputMaybe<Scalars['Int']['input']>;
  utensilsRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrderInput = {
  customFields?: InputMaybe<UpdateOrderCustomFieldsInput>;
  id: Scalars['ID']['input'];
};

export type UpdateOrderItemsResult = InsufficientStockError | NegativeQuantityError | Order | OrderInterceptorError | OrderLimitError | OrderModificationError;

export type UpdateOrderNoteInput = {
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  noteId: Scalars['ID']['input'];
};

export type UpdatePageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTags?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentMethodInput = {
  checker?: InputMaybe<ConfigurableOperationInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  handler?: InputMaybe<ConfigurableOperationInput>;
  id: Scalars['ID']['input'];
  translations?: InputMaybe<Array<PaymentMethodTranslationInput>>;
};

export type UpdateProductCustomFieldsInput = {
  cateringUnitMeasure?: InputMaybe<Scalars['String']['input']>;
  featuredReviewId?: InputMaybe<Scalars['ID']['input']>;
  isOrderCatering?: InputMaybe<Scalars['Boolean']['input']>;
  nutritionalInfoId?: InputMaybe<Scalars['ID']['input']>;
  reviewCount?: InputMaybe<Scalars['Float']['input']>;
  reviewRating?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateProductInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customFields?: InputMaybe<UpdateProductCustomFieldsInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  facetValueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  translations?: InputMaybe<Array<ProductTranslationInput>>;
};

export type UpdateProductOptionGroupInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  translations?: InputMaybe<Array<ProductOptionGroupTranslationInput>>;
};

export type UpdateProductOptionInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  translations?: InputMaybe<Array<ProductOptionGroupTranslationInput>>;
};

export type UpdateProductReviewInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  response?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductVariantCustomFieldsInput = {
  beverageAddOnVariantsAvailableIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  beverageAlACarteAddOnVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  beverageAlACarteAddOnVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  beverageMakeAMealAddOnVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  beverageMakeAMealAddOnVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  breadAddOnVariantsAvailableIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  breadAlACarteAddOnVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  breadAlACarteAddOnVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  breadMakeAMealAddOnVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  breadMakeAMealAddOnVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  cateringFreeOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringMinimumThreshold?: InputMaybe<Scalars['Int']['input']>;
  cateringServingSize?: InputMaybe<Scalars['Int']['input']>;
  cloverCatalogObjectId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  desertAddOnVariantsAvailableIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  desertAlACarteAddOnVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  desertAlACarteAddOnVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  desertMakeAMealAddOnVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  desertMakeAMealAddOnVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  loyaltyGiftPoints?: InputMaybe<Array<ProductVariantLoyaltyGiftPointsStructInput>>;
  makeAMealSKU?: InputMaybe<Scalars['String']['input']>;
  noOfCateringSidesRequired?: InputMaybe<Scalars['Int']['input']>;
  preparationTime?: InputMaybe<Scalars['Float']['input']>;
  sauceAddOnVariantsAvailableIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sauceAlACarteAddOnVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  sauceAlACarteAddOnVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  sauceMakeAMealAddOnVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  sauceMakeAMealAddOnVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  showInDeals?: InputMaybe<Scalars['Boolean']['input']>;
  sideAlACarteVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  sideAlACarteVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  sideMakeAMealVariantsMaximum?: InputMaybe<Scalars['Int']['input']>;
  sideMakeAMealVariantsRequired?: InputMaybe<Scalars['Int']['input']>;
  sideVariantsAvailableIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateProductVariantInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customFields?: InputMaybe<UpdateProductVariantCustomFieldsInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  facetValueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featuredAssetId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  outOfStockThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Sets the price for the ProductVariant in the Channel's default currency */
  price?: InputMaybe<Scalars['Money']['input']>;
  /** Allows multiple prices to be set for the ProductVariant in different currencies. */
  prices?: InputMaybe<Array<UpdateProductVariantPriceInput>>;
  sku?: InputMaybe<Scalars['String']['input']>;
  stockLevels?: InputMaybe<Array<StockLevelInput>>;
  stockOnHand?: InputMaybe<Scalars['Int']['input']>;
  taxCategoryId?: InputMaybe<Scalars['ID']['input']>;
  trackInventory?: InputMaybe<GlobalFlag>;
  translations?: InputMaybe<Array<ProductVariantTranslationInput>>;
  useGlobalOutOfStockThreshold?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProductVariantPriceCustomFieldsInput = {
  availableDates?: InputMaybe<Array<Scalars['String']['input']>>;
  availableDays?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringAvailableDates?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringAvailableDays?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringCutOffDates?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringCutOffDays?: InputMaybe<Array<Scalars['String']['input']>>;
  cateringShowIfNotAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  cutOffDates?: InputMaybe<Array<Scalars['String']['input']>>;
  cutOffDays?: InputMaybe<Array<Scalars['String']['input']>>;
  enableAlACarte?: InputMaybe<Scalars['Boolean']['input']>;
  enableMakeAMeal?: InputMaybe<Scalars['Boolean']['input']>;
  enableVariant?: InputMaybe<Scalars['Boolean']['input']>;
  holidayAvailableDates?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayAvailableDays?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayCutOffDates?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayCutOffDays?: InputMaybe<Array<Scalars['String']['input']>>;
  holidayShowIfNotAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  makeAMealCost?: InputMaybe<Scalars['Int']['input']>;
  showIfNotAvailable?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Used to set up update the price of a ProductVariant in a particular Channel.
 * If the `delete` flag is `true`, the price will be deleted for the given Channel.
 */
export type UpdateProductVariantPriceInput = {
  currencyCode: CurrencyCode;
  customFields?: InputMaybe<UpdateProductVariantPriceCustomFieldsInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  price: Scalars['Money']['input'];
};

export type UpdatePromotionCustomFieldsInput = {
  adminAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  bannerId?: InputMaybe<Scalars['ID']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isDeal?: InputMaybe<Scalars['Boolean']['input']>;
  isFeedbackReward?: InputMaybe<Scalars['Boolean']['input']>;
  isScratchPromo?: InputMaybe<Scalars['Boolean']['input']>;
  isScratchReward?: InputMaybe<Scalars['Boolean']['input']>;
  isSpinPromo?: InputMaybe<Scalars['Boolean']['input']>;
  isSpinReward?: InputMaybe<Scalars['Boolean']['input']>;
  promoTag?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  typeOfCoupon?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePromotionInput = {
  actions?: InputMaybe<Array<ConfigurableOperationInput>>;
  conditions?: InputMaybe<Array<ConfigurableOperationInput>>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<UpdatePromotionCustomFieldsInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  perCustomerUsageLimit?: InputMaybe<Scalars['Int']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  translations?: InputMaybe<Array<PromotionTranslationInput>>;
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePromotionResult = MissingConditionsError | Promotion;

export type UpdateProvinceInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  translations?: InputMaybe<Array<ProvinceTranslationInput>>;
};

export type UpdateRoleInput = {
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  permissions?: InputMaybe<Array<Permission>>;
};

export type UpdateScheduledTaskInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
};

export type UpdateSellerInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateShippingMethodInput = {
  calculator?: InputMaybe<ConfigurableOperationInput>;
  checker?: InputMaybe<ConfigurableOperationInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  fulfillmentHandler?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  translations: Array<ShippingMethodTranslationInput>;
};

export type UpdateStockLocationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTagInput = {
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaxCategoryInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaxRateInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  customerGroupId?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTimeSlotInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  slots?: InputMaybe<Array<SlotInput>>;
};

export type UpdateZoneInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type User = Node & {
  __typename?: 'User';
  authenticationMethods: Array<AuthenticationMethod>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<UserCustomFields>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  roles: Array<Role>;
  updatedAt: Scalars['DateTime']['output'];
  verified: Scalars['Boolean']['output'];
};

export type UserCustomFields = {
  __typename?: 'UserCustomFields';
  isPhoneVerified?: Maybe<Scalars['Boolean']['output']>;
  needsPasswordReset?: Maybe<Scalars['Boolean']['output']>;
};

export type WishlistItem = Node & {
  __typename?: 'WishlistItem';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  productVariant: ProductVariant;
  productVariantId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Zone = Node & {
  __typename?: 'Zone';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  members: Array<Region>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ZoneFilterParameter = {
  _and?: InputMaybe<Array<ZoneFilterParameter>>;
  _or?: InputMaybe<Array<ZoneFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ZoneList = PaginatedList & {
  __typename?: 'ZoneList';
  items: Array<Zone>;
  totalItems: Scalars['Int']['output'];
};

export type ZoneListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ZoneFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ZoneSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ZoneSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CustomerListInput = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type RetryPosiResponse = {
  __typename?: 'retryPosiResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FeedbackFragment = { __typename?: 'Feedback', id: string, subject: string, message: string, createdAt: any, updatedAt: any, type: FeedbackType, tag: string, sentiment: FeedbackSentiment, responsesSent?: Array<any>, deviceType?: string, promoMetadata?: any, phone?: string, email?: string, name?: string, store?: { __typename?: 'Channel', id: string, code: string }, order?: { __typename?: 'Order', id: string, code: string }, customer?: { __typename?: 'Customer', id: string, firstName: string, lastName: string }, promotionSent?: { __typename?: 'Promotion', id: string, name: string, deletedAt?: any } };

export type GetFeedbacksQueryVariables = Exact<{
  options?: InputMaybe<FeedbackListOptions>;
}>;


export type GetFeedbacksQuery = { __typename?: 'Query', feedbacks: { __typename?: 'FeedbackList', totalItems: number, items: Array<{ __typename?: 'Feedback', id: string, subject: string, message: string, createdAt: any, updatedAt: any, type: FeedbackType, tag: string, sentiment: FeedbackSentiment, responsesSent?: Array<any>, deviceType?: string, promoMetadata?: any, phone?: string, email?: string, name?: string, store?: { __typename?: 'Channel', id: string, code: string }, order?: { __typename?: 'Order', id: string, code: string }, customer?: { __typename?: 'Customer', id: string, firstName: string, lastName: string }, promotionSent?: { __typename?: 'Promotion', id: string, name: string, deletedAt?: any } }> } };

export type GetFeedbackQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFeedbackQuery = { __typename?: 'Query', feedback?: { __typename?: 'Feedback', id: string, subject: string, message: string, createdAt: any, updatedAt: any, type: FeedbackType, tag: string, sentiment: FeedbackSentiment, responsesSent?: Array<any>, deviceType?: string, promoMetadata?: any, phone?: string, email?: string, name?: string, store?: { __typename?: 'Channel', id: string, code: string }, order?: { __typename?: 'Order', id: string, code: string }, customer?: { __typename?: 'Customer', id: string, firstName: string, lastName: string }, promotionSent?: { __typename?: 'Promotion', id: string, name: string, deletedAt?: any } } };

export type UpdateFeedbackMutationVariables = Exact<{
  input: FeedbackAdminUpdateInput;
}>;


export type UpdateFeedbackMutation = { __typename?: 'Mutation', updateFeedback: { __typename?: 'Feedback', id: string, subject: string, message: string, createdAt: any, updatedAt: any, type: FeedbackType, tag: string, sentiment: FeedbackSentiment, responsesSent?: Array<any>, deviceType?: string, promoMetadata?: any, phone?: string, email?: string, name?: string, store?: { __typename?: 'Channel', id: string, code: string }, order?: { __typename?: 'Order', id: string, code: string }, customer?: { __typename?: 'Customer', id: string, firstName: string, lastName: string }, promotionSent?: { __typename?: 'Promotion', id: string, name: string, deletedAt?: any } } };

export type SendFeedbackResponseMutationVariables = Exact<{
  input: FeedbackAdminSendResponseInput;
}>;


export type SendFeedbackResponseMutation = { __typename?: 'Mutation', sendFeedbackResponse: { __typename?: 'Feedback', id: string, subject: string, message: string, createdAt: any, updatedAt: any, type: FeedbackType, tag: string, sentiment: FeedbackSentiment, responsesSent?: Array<any>, deviceType?: string, promoMetadata?: any, phone?: string, email?: string, name?: string, store?: { __typename?: 'Channel', id: string, code: string }, order?: { __typename?: 'Order', id: string, code: string }, customer?: { __typename?: 'Customer', id: string, firstName: string, lastName: string }, promotionSent?: { __typename?: 'Promotion', id: string, name: string, deletedAt?: any } } };

export type SendFeedbackRewardToCustomerMutationVariables = Exact<{
  input: SendFeedbackRewardToCustomerInput;
}>;


export type SendFeedbackRewardToCustomerMutation = { __typename?: 'Mutation', sendFeedbackRewardToCustomer: { __typename?: 'Feedback', id: string, subject: string, message: string, createdAt: any, updatedAt: any, type: FeedbackType, tag: string, sentiment: FeedbackSentiment, responsesSent?: Array<any>, deviceType?: string, promoMetadata?: any, phone?: string, email?: string, name?: string, store?: { __typename?: 'Channel', id: string, code: string }, order?: { __typename?: 'Order', id: string, code: string }, customer?: { __typename?: 'Customer', id: string, firstName: string, lastName: string }, promotionSent?: { __typename?: 'Promotion', id: string, name: string, deletedAt?: any } } };

export type DeleteFeedbacksMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteFeedbacksMutation = { __typename?: 'Mutation', deleteFeedbacks: { __typename?: 'DeleteFeedbacksResponse', success: boolean, message?: string } };

export const FeedbackFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Feedback"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feedback"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"sentiment"}},{"kind":"Field","name":{"kind":"Name","value":"responsesSent"}},{"kind":"Field","name":{"kind":"Name","value":"deviceType"}},{"kind":"Field","name":{"kind":"Name","value":"promoMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotionSent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<FeedbackFragment, unknown>;
export const GetFeedbacksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFeedbacks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FeedbackListOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Feedback"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalItems"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Feedback"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feedback"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"sentiment"}},{"kind":"Field","name":{"kind":"Name","value":"responsesSent"}},{"kind":"Field","name":{"kind":"Name","value":"deviceType"}},{"kind":"Field","name":{"kind":"Name","value":"promoMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotionSent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<GetFeedbacksQuery, GetFeedbacksQueryVariables>;
export const GetFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Feedback"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Feedback"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feedback"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"sentiment"}},{"kind":"Field","name":{"kind":"Name","value":"responsesSent"}},{"kind":"Field","name":{"kind":"Name","value":"deviceType"}},{"kind":"Field","name":{"kind":"Name","value":"promoMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotionSent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<GetFeedbackQuery, GetFeedbackQueryVariables>;
export const UpdateFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeedbackAdminUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Feedback"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Feedback"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feedback"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"sentiment"}},{"kind":"Field","name":{"kind":"Name","value":"responsesSent"}},{"kind":"Field","name":{"kind":"Name","value":"deviceType"}},{"kind":"Field","name":{"kind":"Name","value":"promoMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotionSent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>;
export const SendFeedbackResponseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendFeedbackResponse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeedbackAdminSendResponseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendFeedbackResponse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Feedback"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Feedback"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feedback"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"sentiment"}},{"kind":"Field","name":{"kind":"Name","value":"responsesSent"}},{"kind":"Field","name":{"kind":"Name","value":"deviceType"}},{"kind":"Field","name":{"kind":"Name","value":"promoMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotionSent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<SendFeedbackResponseMutation, SendFeedbackResponseMutationVariables>;
export const SendFeedbackRewardToCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendFeedbackRewardToCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendFeedbackRewardToCustomerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendFeedbackRewardToCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Feedback"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Feedback"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feedback"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"sentiment"}},{"kind":"Field","name":{"kind":"Name","value":"responsesSent"}},{"kind":"Field","name":{"kind":"Name","value":"deviceType"}},{"kind":"Field","name":{"kind":"Name","value":"promoMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotionSent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<SendFeedbackRewardToCustomerMutation, SendFeedbackRewardToCustomerMutationVariables>;
export const DeleteFeedbacksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFeedbacks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFeedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteFeedbacksMutation, DeleteFeedbacksMutationVariables>;